/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FieldError {
  field: string;
  fieldValue: string;
  identifier: string;
  identifierValue: string;
  messageCode: string;
  errorType: string;
}

export interface ErrorResponse {
  messageCode: string;
  errors: FieldError[];
}

export interface MemberPackageProductEmailDomain {
  memberPackageProductId: number;
  emailDomain: string;
  updatedBy: number;
  memberPackageProduct: MemberPackageProduct;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export enum PAYMENT_PROVIDER {
  Stripe = 'stripe',
  Vipps = 'vipps',
  External = 'external',
  Nets = 'nets',
  EfakturaAvtalegiroEhf = 'efaktura-avtalegiro-ehf',
}

export interface Translation {
  en: string;
  no: string;
  key?: string;
}

export interface ShippingCharge {
  country: string;
  charge: number;
}

export interface Tag {
  name: string;
  translatedName: Translation;
  entity: string;
  entityTags: EntityTag[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface OptionalProductProperties {
  isRequired: boolean;
  quantityRange: number;
}

export interface SubscriptionPlanProduct {
  subscriptionPlanId: number;
  productId: number;
  price: number;
  properties: OptionalProductProperties;
  subscriptionPlan: SubscriptionPlan;
  product: Product;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface SubscriptionPlan {
  paymentProviders: PAYMENT_PROVIDER[];
  name: string;
  uuid: string;
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency: number;
  autoRenew: boolean;
  status: 'draft' | 'published' | 'unpublished';
  tenantId: number;
  allowSameSubscriptionChange: boolean;
  allowDifferentSubscriptionSwitch: boolean;
  enableGiftSubscription: boolean;
  allowFutureStartDate: boolean;
  showAsOptionOnSubscriptionSwitch: boolean;
  tenant: Tenant;
  entityTags: EntityTag[];
  subscriptionPlanProducts: SubscriptionPlanProduct[];
  packages: Package[];
  memberPackages: MemberPackage[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface ActionType {
  name: string;
  workflowActions: WorkflowAction[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface WorkflowAction {
  workflow: Workflow;
  actionType: ActionType;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Workflow {
  name: string;
  isPublished: boolean;
  workflowEvents: WorkflowEvent[];
  workflowActions: WorkflowAction[];
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface InternalEmail {
  name: string;
  subject: string;
  content: object;
  internalReceivers: string[];
  workflowEvent: WorkflowEvent;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CommunicationTemplate {
  name: string;
  templateType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel: 'sms' | 'email';
  locale: 'en' | 'no';
  template: string;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CommunicationSender {
  /** @pattern /^\d{11}$/ */
  senderName: string;
  senderEmail: string;
  replyTo: string;
  communicationChannel: 'sms' | 'email';
  tenant: Tenant;
  externalEmails: ExternalEmail[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface ExternalEmail {
  name: string;
  subject: string;
  content: object;
  emailTemplate: CommunicationTemplate;
  conditions: object[];
  workflowEvent: WorkflowEvent;
  sender: CommunicationSender;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface WorkflowEvent {
  workflow: Workflow;
  eventType: EventType;
  internalEmails: InternalEmail[];
  externalEmails: ExternalEmail[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CustomPropertyOption {
  name: string;
  value: string | number;
}

export interface CustomPropertySettings {
  isRequired: boolean;
  isUnique: boolean;
  isSearchable: boolean;
  options: CustomPropertyOption[];
  maxLength: number;
  minValue: number;
  maxValue: number;
  regex: string;
  regexErrorMessageCode: string;
  defaultValue: string | number | boolean;
  sequenceStartNumber: number;
  helpText: Translation;
}

export interface AccessObject {
  admin: boolean;
  member: boolean;
  api: boolean;
}

export interface CustomPropertyPermissions {
  readAccess: AccessObject;
  editAccess: AccessObject;
}

export interface CustomProperty {
  name: string;
  displayName: string;
  entity:
    | 'Member'
    | 'MemberPackageProduct'
    | 'MemberPackage'
    | 'Order'
    | 'OrderItem'
    | 'CustomOrder'
    | 'CustomOrderItem';
  dataType: 'string' | 'numeric' | 'boolean' | 'date' | 'text';
  fieldType: 'text' | 'date' | 'radio' | 'checkbox' | 'select' | 'sequence';
  description: string;
  settings: CustomPropertySettings;
  permissions: CustomPropertyPermissions;
  order: number;
  tenantId: number;
  createdBy: number;
  updatedBy: number;
  tenant: Tenant;
  eventTypeMappings: EventTypeCustomProperty[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface EventTypeCustomProperty {
  customPropertyId: number;
  eventTypeId: number;
  customProperty: CustomProperty;
  eventType: EventType;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface EventType {
  name: string;
  emitterName: string;
  description: string;
  workflowEvents: WorkflowEvent[];
  entityTags: EntityTag[];
  customPropertyMappings: EventTypeCustomProperty[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface EntityTag {
  productId: number;
  tagId: number;
  subscriptionPlanId: number;
  eventTypeId: number;
  tag: Tag;
  product: Product;
  subscriptionPlan: SubscriptionPlan;
  eventType: EventType;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface PackageProduct {
  packageId: number;
  productId: number;
  price: number;
  properties: OptionalProductProperties;
  package: Package;
  product: Product;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface StripeCardInfo {
  brand: string;
  expMonth: number;
  expYear: number;
  last4: string;
  country: string;
}

export interface StripePayment {
  paymentId: number;
  email: string;
  customerId: string;
  paymentMethodId: string;
  paymentIntentId: string;
  status:
    | 'requires_payment_method'
    | 'requires_confirmation'
    | 'requires_action'
    | 'processing'
    | 'requires_capture'
    | 'canceled'
    | 'succeeded';
  isSaved: boolean;
  cardInfo: StripeCardInfo;
  payment: Payment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface VippsPayment {
  uuid: string;
  agreementId: string;
  externalId: string;
  phone: string;
  chargeId: string;
  /** @format date-time */
  due: string;
  transactionId: string;
  vippsConfirmationUrl: string;
  failureReason: string;
  failureDescription: string;
  status:
    | 'PENDING'
    | 'ACTIVE'
    | 'STOPPED'
    | 'EXPIRED'
    | 'DUE'
    | 'CHARGED'
    | 'RESERVED'
    | 'PARTIALLY_CAPTURED'
    | 'FAILED'
    | 'CANCELLED'
    | 'PARTIALLY_REFUNDED'
    | 'REFUNDED'
    | 'PROCESSING'
    | 'CHARGE_CREATION_FAILED';
  summary: string;
  history: string;
  paymentId: number;
  payment: Payment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export type NetsCardInfo = object;

export interface NetsPayment {
  email: string;
  uuid: string;
  paymentIntentId: string;
  reference: string;
  status: 'pending' | 'succeeded' | 'failed';
  isRecurring: boolean;
  chargeId: string;
  bulkId: string;
  subscriptionId: string;
  cardInfo: NetsCardInfo;
  paymentId: number;
  payment: Payment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export enum INVOICE_STATUS {
  Paid = 'paid',
  Unpaid = 'unpaid',
  OverDue = 'over-due',
  OverPaid = 'over-paid',
  PartiallyPaid = 'partially-paid',
  Refunded = 'refunded',
  Credited = 'credited',
  PartiallyCredited = 'partially-credited',
}

export enum INVOICE_DELIVERY_STATUS {
  SentViaEinvoice = 'sent_via_einvoice',
  SentViaEmail = 'sent_via_email',
  SentViaPaymentGateway = 'sent_via_payment_gateway',
  SentManually = 'sent_manually',
  InProgress = 'in_progress',
  NotSent = 'not_sent',
}

export interface MemberInfo {
  fullName: string;
  email: string;
  phone: string;
  isCompany: boolean;
  companyName: string;
  organizationNo: string;
}

export interface AddressInfo {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  name?: string;
  addressType: 'primary' | 'delivery' | 'billing' | 'not_set';
  invoiceReference: string;
  companyName: string;
}

export interface TenantInfo {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  name?: string;
  addressType: 'primary' | 'delivery' | 'billing' | 'not_set';
  invoiceReference: string;
  companyName: string;
  tenantName: string;
  tenantContact: string;
  registeredBusinessNo: string;
  bankAccountNo: string;
  swiftCode: string;
  iban: string;
  invoiceLogo: string;
}

export interface OrderItemInfo {
  name: string;
  price: number;
  tax: number;
  quantity: number;
}

export interface TaxGroupInfo {
  taxRate: number;
  baseAmount: number;
  taxAmount: number;
}

export interface Refund {
  refundNumber: number;
  invoiceNumber: number;
  language: 'en' | 'no';
  memberInfo: MemberInfo;
  addressInfo: AddressInfo;
  tenantInfo: TenantInfo;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  amount: number;
  /** @format date-time */
  refundedAt: string;
  currency: string;
  note: string;
  invoice: Invoice;
  member: Member;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface TransactionGroup {
  uuid: string;
  isOpen: boolean;
  isManualMatch: boolean;
  transactions: Transaction[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Transaction {
  transactionGroupId: number;
  type: 'payment' | 'refund' | 'invoice' | 'credit_note' | 'rounding_adjustment';
  memberPackageId: number;
  amount: number;
  reference: string;
  invoiceId: number;
  paymentId: number;
  refundId: number;
  /** @format date-time */
  accountingDate: string;
  status: 'ignored';
  transactionGroup: TransactionGroup;
  member: Member;
  tenant: Tenant;
  invoice: Invoice;
  payment: Payment;
  refund: Refund;
  memberPackage: MemberPackage;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Invoice {
  status: INVOICE_STATUS;
  deliveryStatus: INVOICE_DELIVERY_STATUS;
  remainingAmount: number;
  totalTaxAmount: number;
  taxExclusiveAmount: number;
  invoiceNumber: number;
  language: 'en' | 'no';
  packName: string;
  planName: string;
  autoGenerated: boolean;
  /** @format date-time */
  periodStartDate: string;
  /** @format date-time */
  periodEndDate: string;
  memberInfo: MemberInfo;
  addressInfo: AddressInfo;
  tenantInfo: TenantInfo;
  orderNumber: number;
  orderItemInfo: OrderItemInfo[];
  taxGroupInfo: TaxGroupInfo[];
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  paymentMethod: 'card' | 'vipps' | 'manual_registration' | 'efaktura' | 'ehf' | 'avtalegiro';
  amount: number;
  paidAmount: number;
  /** @format date-time */
  dueDate: string;
  /** @format date-time */
  paymentDate: string;
  currency: string;
  tenantId: number;
  order: Order;
  eInvoicePayment: EInvoicePayment;
  member: Member;
  tenant: Tenant;
  refunds: Refund[];
  isCreditNote: boolean;
  note: string;
  referencedInvoiceNumber: number;
  referencedInvoice: Invoice;
  creditNotes: Invoice[];
  payments: Payment[];
  transaction: Transaction;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface EInvoicePayment {
  kid: string;
  status:
    | 'PENDING'
    | 'SENT'
    | 'AGGREGATED'
    | 'DELIVERY_ERROR'
    | 'PARTIALLY_ACCEPTED'
    | 'PENDING_RECEIPT'
    | 'PENDING_RECEIPT_L2'
    | 'REJECTED'
    | 'VALIDATION_ERROR'
    | 'ERROR'
    | 'PAID'
    | 'SENT_VIA_EMAIL'
    | 'SENT_MANUALLY'
    | 'NOT_SENT';
  channel: 'Efaktura 2.0' | 'AvtaleGiro' | 'AKSESSPUNKT';
  summary: string;
  xml: string;
  invoiceId: number;
  paymentId: number;
  invoice: Invoice;
  payment: Payment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface ProfileAddress {
  line1: string;
  line2: string;
  city: string;
  postCode: string;
  country: string;
  name: string;
  email: string;
  companyName: string;
  organizationNo: string;
  invoiceReference?: string;
}

export interface MemberPersonalInfo {
  id: string;
  fullName: string;
  nickName: string;
  /** @format date-time */
  createdAt: string;
  avatar: string;
  countryCode?: string;
  /** @format date-time */
  birthDate: string;
  deleteAfterExpiration: boolean;
  isCompany: boolean;
  companyName: string;
  organizationNo: string;
  customPropertyValues: object;
  emailVerified?: string;
  phoneVerified?: string;
  memberNumber: number;
  userId: number;
  /** @format email */
  email: string;
  phone: string;
  address: ProfileAddress;
}

export type ProductAdditionalMemberData = object;

export interface CheckoutStatePhysicalProductData {
  memberAddressData: string[];
  productData: string[];
}

export type ProductGiftReceiverData = object;

export interface CheckoutStateGiftReceiverDeliveryData {
  giftReceiverAddressData: string[];
  productData: string[];
}

export interface CheckoutState {
  uuid: string;
  memberId: string;
  status:
    | 'created'
    | 'payment_completed'
    | 'payment_failed'
    | 'member_info'
    | 'additional_member_info'
    | 'physical_product_info'
    | 'gift_receiver_info'
    | 'gift_receiver_delivery_info'
    | 'consent_info'
    | 'completed'
    | 'not_set'
    | 'pending';
  steps: (
    | 'created'
    | 'payment_completed'
    | 'payment_failed'
    | 'member_info'
    | 'additional_member_info'
    | 'physical_product_info'
    | 'gift_receiver_info'
    | 'gift_receiver_delivery_info'
    | 'consent_info'
    | 'completed'
    | 'not_set'
    | 'pending'
  )[];
  paymentData: object;
  memberData: MemberPersonalInfo;
  additionalMemberData: ProductAdditionalMemberData[];
  physicalProductData: CheckoutStatePhysicalProductData;
  giftReceiverData: ProductGiftReceiverData[];
  giftReceiverDeliveryData: CheckoutStateGiftReceiverDeliveryData;
  paymentId: number;
  memberPackageId: number;
  payment: Payment;
  member: Member;
  memberPackage: MemberPackage;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Payment {
  packageId: number;
  /** @format date-time */
  paymentDate: string;
  /** @format date-time */
  registrationDate: string;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  paymentMethod: 'card' | 'vipps' | 'manual_registration' | 'efaktura' | 'ehf' | 'avtalegiro';
  amount: number;
  currency: string;
  status: 'pending' | 'succeeded' | 'failed';
  note: string;
  isAdminAction: boolean;
  memberId: string;
  stripePayment: StripePayment;
  vippsPayment: VippsPayment;
  netsPayment: NetsPayment;
  eInvoicePayment: EInvoicePayment;
  package: Package;
  order: Order;
  checkoutState: CheckoutState;
  invoiceId: number;
  invoice: Invoice;
  member: Member;
  updatedBy: number;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface PlanChange {
  previousPlanId: number;
  previousPlanName: string;
  newPlanId: number;
  newPlanName: string;
}

export interface ProductChange {
  action: string;
  productId: number;
  productName: string;
  shippingCountry: string;
  previousQuantity: number;
  newQuantity: number;
}

export interface OptionalProductWithQuantity {
  productId: number;
  /** @min 1 */
  quantity: number;
  shippingCountry?: string;
}

export interface MemberPackageChangeData {
  planChange: PlanChange;
  productChange: ProductChange[];
  optionalProducts: OptionalProductWithQuantity[];
}

export interface MemberPackageChange {
  isImmediate: boolean;
  changeInPrice: number;
  status:
    | 'CREATED'
    | 'PAYMENT_PENDING'
    | 'CONFIRMATION_PENDING_FOR_NEXT_RENEWAL'
    | 'PENDING_FOR_NEXT_RENEWAL'
    | 'COMPLETED'
    | 'CANCELLED';
  data: MemberPackageChangeData;
  updatedBy: number;
  memberPackage: MemberPackage;
  order: Order;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Order {
  orderNumber: number;
  memberPackageId: number;
  paymentId: number;
  type: 'initial' | 'recurrent' | 'upgrade' | 'credit-note';
  orderItems: OrderItem[];
  payment: Payment;
  memberPackage: MemberPackage;
  invoice: Invoice;
  tenantId: number;
  tenant: Tenant;
  memberPackageChange: MemberPackageChange;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface OrderItem {
  orderId: number;
  productId: number;
  name: string;
  price: number;
  tax: number;
  quantity: number;
  note: string;
  order: Order;
  product: Product;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Product {
  productCategory:
    | 'digital_subscription'
    | 'physical_subscription'
    | 'physical'
    | 'event_ticket'
    | 'PHYSICAL_PRODUCT';
  tenantId: number;
  name: string;
  uuid: string;
  isOptional: boolean;
  price: number;
  currency: string;
  tax: number;
  stock: number;
  maxQuantityPerOrder: number;
  ean: string;
  allowFutureStartDate: boolean;
  status: 'draft' | 'published' | 'unpublished';
  properties: object;
  shippingCharges: ShippingCharge[];
  description: string;
  tenant: Tenant;
  entityTags: EntityTag[];
  subscriptionPlanProducts: SubscriptionPlanProduct[];
  packageProducts: PackageProduct[];
  memberPackageProducts: MemberPackageProduct[];
  orderItem: OrderItem[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface PaymentProviderConfig {
  name: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  config: object;
  tenantId: number;
  showOnMyPage: boolean;
  showOnAdmin: boolean;
  webhookEvents: string[];
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface NewsletterConfig {
  id: string;
  name: string;
  webhookSecret: string;
  apiKey: string;
  userName: string;
  password: string;
}

export interface JsonQuery {
  rules: object[];
  combinator: 'AND' | 'OR';
  id?: string;
}

export interface SegmentMember {
  memberId: string;
  member: Member;
  exceptionType: 'included' | 'excluded';
  segmentId: number;
  segment: Segment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Segment {
  name: string;
  description: string;
  query: JsonQuery;
  type: 'static' | 'dynamic';
  status: 'draft' | 'published';
  adminUserId: number;
  adminUser: User;
  tenantId: number;
  tenant: Tenant;
  segmentMembers: SegmentMember[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CommunicationLogEvent {
  event:
    | 'processed'
    | 'dropped'
    | 'deferred'
    | 'bounce'
    | 'delivered'
    | 'open'
    | 'failed'
    | 'click';
  eventMetaData: object;
  eventTimestamp: number;
  communicationLogId: number;
  communicationLog: CommunicationLog;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CommunicationLog {
  reference: string;
  sender: string;
  recipient: string;
  status:
    | 'processed'
    | 'dropped'
    | 'deferred'
    | 'bounce'
    | 'delivered'
    | 'open'
    | 'failed'
    | 'click';
  subject: string;
  deliveredAt: number;
  firstOpenedAt: number;
  emailProvider: 'brevo' | 'sendgrid';
  messageId: string;
  tags: string[];
  communicationChannel: 'sms' | 'email';
  communicationType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  subritePrice: number;
  costPrice: number;
  currency: string;
  direction: 'incoming' | 'outgoing';
  communicationId: number;
  memberId: string;
  tenantId: number;
  member: Member;
  tenant: Tenant;
  communication: Communication;
  events: CommunicationLogEvent[];
  personalizedTokens: object;
  automationTemplateId: number;
  automationEmailContent: object;
  automationTemplate: CommunicationTemplate;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Communication {
  name: string;
  status: 'draft' | 'ready' | 'scheduled' | 'completed' | 'failed' | 'processing';
  smsContent: string;
  subject: string;
  emailEditorRawContent: object;
  communicationType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel: 'sms' | 'email';
  /** @format date-time */
  scheduledAt: string;
  /** @format date-time */
  completedAt: string;
  adminUserId: number;
  tenantId: number;
  consentId: number;
  segmentId: number;
  templateId: number;
  emailPreviewText: string;
  deliveryMethod: string;
  externalEmailBody: string;
  emailHtmlPreview: string;
  senderId: number;
  sender: CommunicationSender;
  adminUser: User;
  tenant: Tenant;
  consent: Consent;
  segment: Segment;
  template: CommunicationTemplate;
  communicationLogs: CommunicationLog[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Consent {
  integrationId: string;
  title: string;
  description: string;
  image: string;
  showOnCheckoutPage: boolean;
  showOnMyPage: boolean;
  status: boolean;
  purpose: 'marketing_and_newsletter' | 'consent';
  frequency: string;
  defaultSubscribed: boolean;
  newsletterProviderConfig: NewsletterProviderConfig;
  newsletterProviderConfigId: number;
  tenant: Tenant;
  communications: Communication[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface NewsletterProviderConfig {
  provider: 'mailchimp' | 'make';
  name: string;
  tenantId: number;
  config: NewsletterConfig;
  tenant: Tenant;
  consents: Consent[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface OidcClient {
  name: string;
  applicationType: 'web' | 'native';
  platform: string;
  clientId: string;
  clientSecret: string;
  callbackUrl: string;
  postLogoutRedirectUris: string[];
  disablePKCE: boolean;
  debugMode: boolean;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface OauthProvider {
  id: string;
  clientId: string;
  clientSecret: string;
  name: string;
  tenant: Tenant;
}

export interface ActivityLog {
  data: object;
  action:
    | 'initial_purchase'
    | 'subscription_renewed'
    | 'auto_renewal_turned_off'
    | 'auto_renewal_turned_on'
    | 'subscription_expired'
    | 'payment_failed'
    | 'subscription_activated'
    | 'subscription_deactivated'
    | 'subscription_reactivated'
    | 'subscription_stopped'
    | 'subscription_canceled_before_activation'
    | 'activation_date_updated'
    | 'next_renewal_updated'
    | 'recurring_price_updated'
    | 'change_initiated'
    | 'change_completed'
    | 'change_cancelled'
    | 'seat_invitation_sent'
    | 'seat_invitation_removed'
    | 'seat_invitation_accepted'
    | 'seat_member_added'
    | 'seat_gift_receiver_added'
    | 'seat_gift_receiver_removed'
    | 'seat_gift_receiver_accepted'
    | 'seat_gift_receiver_invitation_sent'
    | 'invoice_sent'
    | 'payment_method_updated'
    | 'payment_provider_updated'
    | 'invoice_address_updated'
    | 'delivery_address_updated'
    | 'credit_note_created'
    | 'refund_registered'
    | 'payment_registered'
    | 'vipps_recurring_charge_initiated'
    | 'update_member_profile'
    | 'update_consent'
    | 'login'
    | 'signup'
    | 'gdpr_deleted';
  entity: string;
  entityId: string;
  description: string;
  memberId: string;
  updatedBy: string;
  feed: object;
  member: Member;
  tenant: Tenant;
  tenantId: number;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export enum M2MPERMISSIONS {
  MemberRead = 'member:read',
  MemberUpdate = 'member:update',
  SubscriptionRead = 'subscription:read',
  SubscriptionUpdate = 'subscription:update',
  ConsentRead = 'consent:read',
  ConsentUpdate = 'consent:update',
  PushSubscriptionRead = 'push-subscription:read',
  PushSubscriptionUpdate = 'push-subscription:update',
  PushContentRead = 'push-content:read',
  PushContentUpdate = 'push-content:update',
  CommunicationRead = 'communication:read',
  CommunicationUpdate = 'communication:update',
  SegmentRead = 'segment:read',
  SegmentUpdate = 'segment:update',
  ContentRead = 'content:read',
  ContentUpdate = 'content:update',
  CustomOrderRead = 'custom-order:read',
  CustomOrderUpdate = 'custom-order:update',
}

export interface M2MApiClient {
  scopes: M2MPERMISSIONS[];
  clientIdentifier: string;
  name: string;
  description: string;
  tokenSuffix: string;
  isActive: boolean;
  tenantId: number;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface SystemFieldConfig {
  name: string;
  show: boolean;
  required: boolean;
}

export interface PageInputFieldConfig {
  page: string;
  systemFields: SystemFieldConfig[];
  customProperties: string[];
}

export interface GlobalMessage {
  en: string;
  no: string;
}

export interface MaintenanceModeConfig {
  enabled: boolean;
  globalMessage: GlobalMessage;
}

export enum PaymentProvider {
  Stripe = 'stripe',
  Vipps = 'vipps',
  External = 'external',
  Nets = 'nets',
  EfakturaAvtalegiroEhf = 'efaktura-avtalegiro-ehf',
}

export enum FieldPropertyType {
  Text = 'text',
  Qrcode = 'qrcode',
}

export interface FieldStyleDto {
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  width?: string;
  height?: string;
  fontFamily?: string;
}

export interface PropertiesConfig {
  type: FieldPropertyType;
  value: string;
  style?: FieldStyleDto;
}

export interface CustomFieldsOnInvoiceDto {
  paymentProvider: PaymentProvider;
  properties: PropertiesConfig[];
}

export enum INITIAL_ACTIVATION {
  ON_PAYMENT = 'ON_PAYMENT',
  ON_ORDER = 'ON_ORDER',
}

export enum DEACTIVATION_POLICY {
  ON_DUE = 'ON_DUE',
  ON_RENEWAL = 'ON_RENEWAL',
  NEVER = 'NEVER',
}

export interface EInvoicePaymentPreference {
  initialActivation: INITIAL_ACTIVATION;
  dueDaysAfterOrderForInitial: number;
  initialDeactivation: DEACTIVATION_POLICY;
  initialOnDueDeactivationBufferDays: number;
  orderDaysBeforeRenewal: number;
  dueDaysAfterOrderForRecurring: number;
  recurringDeactivation: DEACTIVATION_POLICY;
  recurringOnDueDeactivationBufferDays: number;
}

export interface FontSourceConfig {
  url: string;
  type: string;
  style: string;
  weight: string;
  display: string;
}

export interface FontConfig {
  fontFamily: string;
  fontSources: FontSourceConfig[];
}

export interface TypographyConfig {
  primaryFont: FontConfig;
  secondaryFont: FontConfig;
}

export interface ThemeConfig {
  typography: TypographyConfig;
}

export interface Preference {
  welcomeImage: string;
  headerText: string;
  welcomePrimaryText: string;
  welcomeSecondaryText: string;
  memberInfoText: string;
  giftSubscriptionConfirmationTextLoggedIn: string;
  giftSubscriptionWelcomeHelpText: string;
  paymentConfirmationImage: string;
  subscriptionChangeCompleteScreenImage: string;
  paymentConfirmationPrimaryText: string;
  paymentConfirmationSecondaryTextLoggedOut: string;
  paymentConfirmationSecondaryTextLoggedIn: string;
  headerColor: string;
  headerTextColor: string;
  primaryButtonColor: string;
  primaryButtonHoverColor: string;
  primaryButtonTextColor: string;
  primaryStepColor: string;
  inputFieldConfig: PageInputFieldConfig[];
  onboardingFlow: boolean;
  invoiceLogo: string;
  automationTemplateId: number;
  allowedDaysAfterExpiry: number;
  maintenanceModeConfig: MaintenanceModeConfig;
  onNewUserCompletedProductPackageSlug: string;
  systemUpgradeNotification: Translation;
  customFieldsOnMemberCard: string[];
  customFieldsOnInvoice: CustomFieldsOnInvoiceDto[];
  permissionLevelForBuyingSamePackage: 'allow' | 'warn' | 'block';
  permissionLevelForBuyingMultipleSubscriptions: 'allow' | 'warn' | 'block';
  allowBuyNewSubsFromMypage: boolean;
  allowBuyGiftSubsFromMypage: boolean;
  onNewUserCompletedNewsletterAndConsent: boolean;
  eInvoicePaymentPreference: EInvoicePaymentPreference;
  theme: ThemeConfig;
  showMinSideCTAOnCheckoutWelcome: boolean;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface PageHeaderConfig {
  logo: string;
  textContent: string;
  textColor: string;
  bgColor: string;
}

export interface ButtonConfig {
  bgColor: string;
  textColor: string;
  hoverColor: string;
  stepColor: string;
}

export interface BrandKitFontConfig {
  family: string;
  url: string;
  type: string;
  style: string;
  display: string;
  weight: string;
}

export interface BrandKit {
  name: string;
  brandKitSenderName?: string;
  brandKitSenderEmail?: string;
  smsOtp?: boolean;
  smsSenderName?: string;
  favicon?: string;
  siteUrl?: string;
  termsUrl?: string;
  privacyUrl?: string;
  defaultLogoutUrl?: string;
  pageHeader?: PageHeaderConfig;
  primaryButton?: ButtonConfig;
  primaryFont?: BrandKitFontConfig;
  secondaryFont?: BrandKitFontConfig;
  otpTemplateId?: Translation;
  tenantId: number;
  tenant: Tenant;
  tenantHostnames: TenantHostname[];
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface TenantHostname {
  hostName: string;
  tenantId: number;
  tenant: Tenant;
  brandKitId: string;
  brandKit: BrandKit;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface ExportHistory {
  fileLink: string;
  fileName: string;
  status: 'started' | 'completed' | 'failed' | 'queued';
  exportType:
    | 'subscriptions'
    | 'subscription_products'
    | 'subscription_users'
    | 'payments'
    | 'invoices'
    | 'all_members'
    | 'segments'
    | 'ledger';
  systemGenerated: boolean;
  adminUserId: number;
  tenantId: number;
  adminUser: User;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MypageCardsSettings {
  title: Translation;
  showOnMyPage: boolean;
  cardType: 'subrite_standard' | 'custom';
  link: string;
  description: Translation;
  display_order: number;
  tenantId: number;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface WebhookAuthenticationBearerConfig {
  token: string;
}

export interface WebhookRequestBody {
  id: string;
  /** @format date-time */
  timestamp: string;
  event:
    | 'member.deleted'
    | 'member.updated'
    | 'subscription.created'
    | 'subscription.renewed'
    | 'member.subscription.activated'
    | 'member.subscription.deactivated';
  data: object;
}

export interface WebhookEventLog {
  idempotencyKey: string;
  attemptNo: number;
  status: 'succeeded' | 'failed';
  timestamp: number;
  requestMethod: 'POST' | 'GET' | 'DELETE';
  requestBody: WebhookRequestBody;
  responseCode: number;
  responseBody: object;
  requestHeaders: object;
  url: string;
  error: object;
  webhookEventId: number;
  webhookEvent: WebhookEvent;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface WebhookEvent {
  name:
    | 'member.deleted'
    | 'member.updated'
    | 'subscription.created'
    | 'subscription.renewed'
    | 'member.subscription.activated'
    | 'member.subscription.deactivated';
  webhook: Webhook;
  webhookEventLogs: WebhookEventLog[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Webhook {
  requestMethod: 'POST' | 'GET' | 'DELETE';
  name: string;
  description: string;
  url: string;
  secret: string;
  authenticationMethod: 'bearer';
  authenticationConfig: WebhookAuthenticationBearerConfig;
  isActive: boolean;
  tenantId: number;
  webhookEvents: WebhookEvent[];
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CustomOrderSource {
  name: string;
  tenantId: number;
  tenant: Tenant;
  orders: CustomOrder[];
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CustomOrderItem {
  orderId: string;
  sequence: number;
  productId: string;
  productName: string;
  categoryId: string;
  categoryName: string;
  quantity: number;
  price: number;
  priceVat: number;
  customPropertyValues: object;
  order: CustomOrder;
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CustomOrder {
  /** @format date-time */
  orderTime: string;
  memberId: string;
  sourceId: string;
  sourceRef: string;
  totalPrice: number;
  totalPriceVat: number;
  currency: string;
  tenantId: number;
  customPropertyValues: object;
  tenant: Tenant;
  source: CustomOrderSource;
  items: CustomOrderItem[];
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Tenant {
  name: string;
  isActive: boolean;
  language: 'en' | 'no';
  hostName: string;
  logo: string;
  favicon: string;
  siteUrl: string;
  termsUrl: string;
  privacyUrl: string;
  gtm: string;
  taxRates?: number[];
  smsOtp: boolean;
  smsSenderName: string;
  emailProvider: 'brevo' | 'sendgrid';
  tenantContact: string;
  tenantSenderEmail: string;
  tenantSenderName: string;
  registeredBusinessNo: string;
  bankAccountNo: string;
  swiftCode: string;
  iban: string;
  subriteTrackerId: string;
  defaultLogoutURL: string;
  postalAddress: string;
  otpTemplateId?: Translation;
  products: Product[];
  users: User[];
  members: Member[];
  roles: Role[];
  subscriptionPlans: SubscriptionPlan[];
  packages: Package[];
  invoices: Invoice[];
  orders: Order[];
  paymentProviders: PaymentProviderConfig[];
  newslettersProviderConfig: NewsletterProviderConfig[];
  paymentProviderConfigs: PaymentProviderConfig[];
  workflows: Workflow[];
  oidcClients: OidcClient[];
  oauthProviders: OauthProvider[];
  activityLogs: ActivityLog[];
  m2m_api_clients: M2MApiClient[];
  customProperties: CustomProperty[];
  consents: Consent[];
  preference: Preference;
  communicationTemplates: CommunicationTemplate[];
  additionalHostnames: TenantHostname[];
  exportHistory: ExportHistory[];
  mypageCardsSettings: MypageCardsSettings[];
  webhooks: Webhook[];
  customOrders: CustomOrder[];
  customOrderSources: CustomOrderSource[];
  brandKits: BrandKit[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Package {
  paymentProviders: PAYMENT_PROVIDER[];
  salesTitle: string;
  uuid: string;
  subscriptionPlanId: number;
  slug: string;
  image: string;
  name: string;
  description: object;
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency: number;
  status: 'draft' | 'published' | 'unpublished';
  isAvailableOnMyPage: boolean;
  isAvailableViaSlug: boolean;
  isAvailableForManualOrderViaAdmin: boolean;
  allowSameSubscriptionChange: boolean;
  allowDifferentSubscriptionSwitch: boolean;
  tenantId: number;
  onboardingWelcomeRedirectCTAText: Translation;
  /** @format date-time */
  introPeriodFixedEndDate: string;
  tenant: Tenant;
  packageProducts: PackageProduct[];
  subscriptionPlan: SubscriptionPlan;
  payments: Payment[];
  memberPackages: MemberPackage[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackageProviderPayment {
  memberPackageId: number;
  paymentInfo: object;
  isSaved: boolean;
  cardInfo: object;
  memberPackage: MemberPackage;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackageHistory {
  action:
    | 'initial_purchase'
    | 'subscription_renewed'
    | 'auto_renewal_turned_off'
    | 'auto_renewal_turned_on'
    | 'subscription_expired'
    | 'payment_failed'
    | 'subscription_activated'
    | 'subscription_deactivated'
    | 'subscription_reactivated'
    | 'subscription_stopped'
    | 'subscription_canceled_before_activation'
    | 'activation_date_updated'
    | 'next_renewal_updated'
    | 'recurring_price_updated'
    | 'change_initiated'
    | 'change_completed'
    | 'change_cancelled'
    | 'seat_invitation_sent'
    | 'seat_invitation_removed'
    | 'seat_invitation_accepted'
    | 'seat_member_added'
    | 'seat_gift_receiver_added'
    | 'seat_gift_receiver_removed'
    | 'seat_gift_receiver_accepted'
    | 'seat_gift_receiver_invitation_sent'
    | 'invoice_sent'
    | 'payment_method_updated'
    | 'payment_provider_updated'
    | 'invoice_address_updated'
    | 'delivery_address_updated'
    | 'credit_note_created'
    | 'refund_registered'
    | 'payment_registered'
    | 'vipps_recurring_charge_initiated'
    | 'update_member_profile'
    | 'update_consent'
    | 'login'
    | 'signup'
    | 'gdpr_deleted';
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  nextRenewal: string;
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'paused'
    | 'stopped'
    | 'expired'
    | 'waiting_for_activation';
  autoRenew: boolean;
  recurringPrice: number;
  currentPrice: number;
  entity: string;
  entityId: string;
  newData: object;
  updatedBy: number;
  memberPackage: MemberPackage;
  subscriptionPlan: SubscriptionPlan;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackage {
  memberId: string;
  packageId: number;
  subscriptionPlanId: number;
  recurringPrice: number;
  currentPrice: number;
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'paused'
    | 'stopped'
    | 'expired'
    | 'waiting_for_activation';
  autoRenew: boolean;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  forcedStopDate: string;
  /** @format date-time */
  cancelledAt: string;
  isCustomized: boolean;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  reference: string;
  /** @format date-time */
  lastActiveAt: string;
  isOnIntroPeriod: boolean;
  /** @format date-time */
  nextOrderDate: string;
  /** @format date-time */
  scheduledActivationDate: string | null;
  package: Package;
  subscriptionPlan: SubscriptionPlan;
  member: Member;
  memberPackageProducts: MemberPackageProduct[];
  orders: Order[];
  memberPackageProviderPayment: MemberPackageProviderPayment;
  changes: MemberPackageChange[];
  histories: MemberPackageHistory[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackageProductSeat {
  memberPackageProductId: number;
  memberId: string;
  email: string;
  accepted: boolean;
  /** @format date-time */
  acceptedAt: string;
  /** @format date-time */
  expiresAt: string;
  uuid: string;
  memberPackageProduct: MemberPackageProduct;
  member: Member;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackageProduct {
  memberPackageId: number;
  productId: number;
  price: number;
  recurringPrice: number;
  quantity: number;
  hasAccess: boolean;
  shippingCountry: string;
  shippingProvider: 'Helthjem' | 'Bring - Posten';
  allowDistributorToUpdateDeliveryAddress: boolean;
  memberPackageProductEmailDomains: MemberPackageProductEmailDomain[];
  memberPackage: MemberPackage;
  product: Product;
  seats: MemberPackageProductSeat[];
  recipients: MemberPackageProductRecipient[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MemberPackageProductRecipient {
  memberPackageProductId: number;
  memberId: string;
  memberPackageProduct: MemberPackageProduct;
  member: Member;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Member {
  userId: number | null;
  memberNumber: number | null;
  tenantId: number;
  externalId: string | null;
  fullName: string;
  nickName: string;
  avatar: string;
  email: string;
  /** @format date-time */
  birthDate: string | null;
  phone: string;
  isCompany: boolean;
  companyName: string | null;
  organizationNo: string | null;
  isVatLiable: boolean;
  deleteAfterExpiration: boolean;
  customPropertyValues: object;
  productRecipients: MemberPackageProductRecipient[];
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Note {
  note: string;
  memberId: string;
  adminUserId: number;
  member: Member;
  adminUser: User;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface UserSettings {
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  receiveAdminEmails: boolean;
  twoFactorAuth: boolean;
  hasSignedDPA: boolean;
  language: 'en' | 'no';
  metaData: object;
  user: User;
}

export interface UserAccount {
  id: string;
  tenant: Tenant;
  tenantId: number;
  type: string;
  token_type: string;
  scope: string;
  provider: string;
  providerAccountId: string;
  image: string;
  refresh_token: string;
  access_token: string;
  id_token: string;
  session_state: string;
  expires_at: number;
  user: User;
  userId: number;
  email: string | null;
  phone: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format date-time */
  createdAt?: string | null;
}

export interface UserSession {
  id: string;
  expires: string;
  sessionToken: string;
  userId: number;
  user: User;
}

export interface User {
  userType: 'system_admin' | 'tenant_admin' | 'member' | 'not_set';
  tenantId: number;
  email: string;
  fullName: string;
  phone: string;
  emailVerified: string | null;
  phoneVerified: string | null;
  isOwner: boolean;
  isTestUser: boolean;
  image: string;
  createdInCheckoutUuid: string;
  userRoles?: UserRole[];
  notes: Note[];
  exportHistory: ExportHistory[];
  userSettings?: UserSettings;
  member?: Member;
  tenant: Tenant;
  userAccounts: UserAccount[];
  userSessions: UserSession[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface UserRole {
  userId: number;
  roleId: number;
  user: User;
  role: Role;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Permission {
  action: 'read' | 'update';
  sectionId:
    | 'dashboard'
    | 'members'
    | 'content'
    | 'automation'
    | 'data'
    | 'analytics'
    | 'account_settings'
    | 'segments'
    | 'communications'
    | 'plans_and_products';
  rolePermissions: RolePermission[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface RolePermission {
  roleId: number;
  permissionId: number;
  role: Role;
  permission: Permission;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface Role {
  name: string;
  tenantId: number;
  isActive: boolean;
  userRoles: UserRole[];
  rolePermissions: RolePermission[];
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface SectionPermission {
  sectionId:
    | 'dashboard'
    | 'members'
    | 'content'
    | 'automation'
    | 'data'
    | 'analytics'
    | 'account_settings'
    | 'segments'
    | 'communications'
    | 'plans_and_products';
  sectionName: string;
  readPermission: boolean;
  updatePermission: boolean;
}

export interface UserResponse {
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  role?: Role;
  permissions?: SectionPermission[];
  userSettings?: UserSettings;
  nickname?: string;
  avatar?: string;
  userType: 'system_admin' | 'tenant_admin' | 'member' | 'not_set';
  tenantId: number;
  email: string;
  fullName: string;
  phone: string;
  emailVerified: string | null;
  phoneVerified: string | null;
  isOwner: boolean;
  isTestUser: boolean;
  image: string;
  createdInCheckoutUuid: string;
  userRoles?: UserRole[];
  notes: Note[];
  exportHistory: ExportHistory[];
  member?: Member;
  tenant: Tenant;
  userAccounts: UserAccount[];
  userSessions: UserSession[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface UserSettingsDto {
  receiveAdminEmails: boolean;
  twoFactorAuth: boolean;
  hasSignedDPA: boolean;
  language: 'en' | 'no';
}

export interface UpdateProfileDto {
  fullName: string;
  /** @format email */
  email: string;
  phone: string;
  userSettings: UserSettingsDto;
}

export interface CreateUserDto {
  fullName: string;
  /** @format email */
  email: string;
  phone: string;
  roleId: number;
}

export interface PageMeta {
  page: number;
  take: number;
  count: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface UserResponsePaginated {
  items: UserResponse[];
  meta: PageMeta;
}

export interface UpdateUserDto {
  fullName?: string;
  userSettings: UserSettingsDto;
  /** @format email */
  email?: string;
  phone?: string;
  roleId?: number;
}

export interface CreateRoleDto {
  name: string;
  isActive: boolean;
  sectionPermissions: SectionPermission[];
}

export interface RoleResponse {
  id: number;
  name: string;
  userCount: number;
  isActive: boolean;
  tenantId: number;
  sectionPermissions: SectionPermission[];
  /** @format date-time */
  updatedAt: string;
}

export interface RolePaginated {
  items: Role[];
  meta: PageMeta;
}

export interface UpdateRoleDto {
  name?: string;
  isActive?: boolean;
  sectionPermissions?: SectionPermission[];
}

export interface MypageCardsSettingsResponseDto {
  title: Translation | null;
  description: Translation | null;
  id: number;
  link: string;
  cardType: 'subrite_standard' | 'custom';
  showOnMyPage: boolean;
  display_order: number;
}

export interface JoinSubscriptionsRequestDto {
  /**
   * Array of MemberPackageProduct IDs to join
   * @minItems 1
   * @example [12,45]
   */
  memberPackageProductIds: number[];
}

export enum MemberPackageStatusEnum {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Paused = 'paused',
  Stopped = 'stopped',
  Expired = 'expired',
  WaitingForActivation = 'waiting_for_activation',
}

export interface SubscriptionListItem {
  id: number;
  packageId: number;
  name: string;
  slug: string;
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'paused'
    | 'stopped'
    | 'expired'
    | 'waiting_for_activation';
  /** @format date-time */
  nextRenewal: string;
  hasChange: boolean;
  changePlanName?: string | null;
}

export enum TransactionResponseType {
  Payment = 'payment',
  Refund = 'refund',
  Invoice = 'invoice',
  CreditNote = 'credit_note',
  RoundingAdjustment = 'rounding_adjustment',
}

export enum MEMBER_PACKAGE_STATUS {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
  Paused = 'paused',
  Stopped = 'stopped',
  Expired = 'expired',
  WaitingForActivation = 'waiting_for_activation',
}

export interface InvoiceResponse {
  id: number;
  type: TransactionResponseType;
  invoiceNo: number;
  /** @format date-time */
  invoiceDate: string;
  packName: string;
  memberPackageId: number;
  memberId: string;
  memberEmail: string;
  totalAmount: number;
  status: INVOICE_STATUS;
  memberPackageStatus?: MEMBER_PACKAGE_STATUS;
  deliveryStatus?: INVOICE_DELIVERY_STATUS;
  isCreditNote: boolean;
  referencedInvoiceNumber?: number;
  kid: string;
  note: string;
  paymentProvider: PAYMENT_PROVIDER;
  memberNumber: number;
  /** @format date-time */
  invoiceDueDate?: string;
  orderId: number;
}

export enum PAYMENT_STATUS {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export interface BillingPeriodDetails {
  billingPeriodFrequency: number;
  billingPeriodUnit: string;
}

export interface BillingPeriodInfo {
  billingPeriod: string;
  customBillingPeriod: BillingPeriodDetails;
}

export interface OrderResponse {
  id: number;
  /** @format date-time */
  orderDate: string;
  orderNumber: number;
  paymentStatus: PAYMENT_STATUS;
  amount: number;
  credit: number;
  debit: number;
  packageName: string;
  planName: string;
  paymentProvider: PAYMENT_PROVIDER;
  currency: string;
  billingPeriodInfo: BillingPeriodInfo;
  allowedPaymentProviders: PAYMENT_PROVIDER[];
  tenantId: number;
  upgradeData?: MemberPackageChangeData;
  memberPackageId: number;
  paymentId: number;
  type: 'initial' | 'recurrent' | 'upgrade' | 'credit-note';
  orderItems: OrderItem[];
  payment: Payment;
  memberPackage: MemberPackage;
  invoice: Invoice;
  tenant: Tenant;
  memberPackageChange: MemberPackageChange;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface OrderResponsePaginated {
  items: OrderResponse[];
  meta: PageMeta;
}

export enum UserType {
  SystemAdmin = 'system_admin',
  TenantAdmin = 'tenant_admin',
  Member = 'member',
  NotSet = 'not_set',
}

export interface SubscriptionPlanProducts {
  id: number;
  name: string;
}

export interface ActiveSubscriptionInfo {
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  activatedAt: string;
  /** @format date-time */
  expiresAt: string;
  autoRenew: boolean;
  subscriptionId: number;
  packageId: number;
  packageName: string;
  status: MEMBER_PACKAGE_STATUS;
  subscriptionProducts: SubscriptionPlanProducts[];
}

export interface ContentChannel {
  id: number;
  name: string;
  description: string;
  tenant: Tenant;
  tenantId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface PodcastDto {
  id: number;
  podcastUrlSignature: string;
  imageUrl: string;
  name: string;
}

export interface MemberConsentDto {
  id: number;
  /** @format date-time */
  updatedAt: string;
  title: string;
  description: string;
  image: string;
  showOnCheckoutPage: boolean;
  showOnMyPage: boolean;
  status: object;
  frequency: string;
  newsletterProviderConfigId: number;
  consentStatus: string;
  purpose: 'marketing_and_newsletter' | 'consent';
}

export interface MemberWithSubscriptions {
  id: string;
  fullName: string;
  memberNumber: number;
  userType: UserType;
  nickName: string;
  avatar: string;
  subscriptions: ActiveSubscriptionInfo[];
  customPropertyValues: object;
  contentChannels?: ContentChannel[];
  podcasts?: PodcastDto[];
  consents?: MemberConsentDto[];
  phone: string;
  /** @format email */
  email: string;
  address: ProfileAddress;
}

export interface UpdateMemberPersonalInfo {
  id?: string;
  fullName?: string;
  nickName?: string;
  /** @format date-time */
  createdAt?: string;
  countryCode?: string;
  /** @format date-time */
  birthDate?: string;
  deleteAfterExpiration?: boolean;
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  customPropertyValues?: object;
  emailVerified?: string;
  phoneVerified?: string;
  memberNumber?: number;
  userId?: number;
  phone?: string;
  address?: ProfileAddress;
}

export interface UpdateAvatarDto {
  /** @format binary */
  image?: File;
  imagePreview?: string;
  previousImageUrl?: string;
}

export interface UpdateMemberEmailBodyDto {
  /** @format email */
  email: string;
}

export interface OTPSendResponseDto {
  hash: string;
}

export interface UpdateMemberEmailDto {
  /** @format email */
  email: string;
  otp: string;
  hash: string;
}

export interface UpdateMemberPhoneBodyDto {
  phone: string;
  language: 'en' | 'no';
}

export interface UpdateMemberPhoneDto {
  phone: string;
  otp: string;
  hash: string;
}

export interface VippsPaymentInfoWithDueCharge {
  dueChargeId: string;
  agreementId: string;
  phone: string;
}

export interface EInvoicePaymentInfo {
  isPaid: boolean;
  /** @format date-time */
  nextOrderDate: string;
  lastInvoiceNumber?: number;
  lastInvoiceStatus?: INVOICE_STATUS;
  /** @format date-time */
  lastInvoiceDate?: string;
  /** @format date-time */
  lastInvoiceDueDate?: string;
  /** @format date-time */
  forcedStopDate?: string;
  lastInvoiceDueAmount?: number;
  paymentLink?: string;
  /** @format date-time */
  lastInvoicePeriodEndDate?: string;
  invoiceIsSentForNextPeriod?: boolean;
  invoiceIsNotPaidForCurrentPeriod?: boolean;
}

export interface ExternalPaymentInfo {
  isPaid: boolean;
  /** @format date-time */
  paidTill: string;
}

export interface PaymentInfo {
  stripeCardInfo: StripeCardInfo;
  netsCardInfo: NetsCardInfo;
  vippsPaymentInfoWithDueCharge: VippsPaymentInfoWithDueCharge;
  eInvoicePaymentInfo: EInvoicePaymentInfo;
  externalPaymentInfo: ExternalPaymentInfo;
}

export interface SeatData {
  id: number;
  name: string;
  email: string;
  status: 'pending' | 'accepted' | 'expired' | 'awaiting_activation';
  memberId: string;
  memberData: MemberPersonalInfo;
  expiresAt: string;
}

export interface GroupSubscriptionResponse {
  ownerHasAccess: boolean;
  seatsAllowed: number;
  seatsActive: number;
  seatsRemaining: number;
  maxQuantityPerOrder: number;
  groupOwnerMemberName: string;
  groupOwnerMemberId: string;
  groupOwnerMemberNumber: number;
  seats: SeatData[];
}

export interface ProductPackage {
  id: number;
  name: string;
  productId: number;
  productCategory:
    | 'digital_subscription'
    | 'physical_subscription'
    | 'physical'
    | 'event_ticket'
    | 'PHYSICAL_PRODUCT';
  price: number;
  recurringPrice: number;
  quantity: number;
  hasAccess: boolean;
  isOptional: boolean;
  shippingCountry: string;
  shippingCharges: ShippingCharge[];
  shippingCountries: string[];
  shippingPrice: number;
  groupInfo: GroupSubscriptionResponse;
}

export enum SUBSCRIPTION_CHANGE_BLOCK_REASON {
  ON_INTRO_PERIOD = 'ON_INTRO_PERIOD',
  NOT_ACTIVE = 'NOT_ACTIVE',
  PAST_DUE = 'PAST_DUE',
  ON_RENEWAL_DAY = 'ON_RENEWAL_DAY',
  VIPPS_RECURRING_CHARGE_CREATED = 'VIPPS_RECURRING_CHARGE_CREATED',
  INVOICE_ALREADY_PAID_FOR_NEXT_PERIOD = 'INVOICE_ALREADY_PAID_FOR_NEXT_PERIOD',
  INVOICE_NOT_PAID_FOR_CURRENT_PERIOD = 'INVOICE_NOT_PAID_FOR_CURRENT_PERIOD',
}

export interface ChangeSubscriptionDetails {
  id: number;
  currentPlanName: string;
  newPlanName: string;
  currentProducts: ProductPackage[];
  newProducts: ProductPackage[];
  currentPaymentProviderInfo: PaymentInfo;
  currentBillingPeriod: BillingPeriodInfo;
  newBillingPeriod: BillingPeriodInfo;
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  newPeriodStart: string;
  changeInPrice: number;
  currentRecurringPrice: number;
  nextRenewalPrice: number;
  autoRenew: boolean;
  newPackageAutoRenew: boolean;
  orderId: number;
}

export interface SubscriptionDetails {
  id: number;
  packageId: number;
  name: string;
  slug: string;
  subscriptionPlanId: number;
  subscriptionPlanName: string;
  recurringPrice: number;
  autoRenew: boolean;
  paymentInfo: PaymentInfo;
  paymentProvider?: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  isOwner: boolean;
  groupInfo?: GroupSubscriptionResponse;
  status: MEMBER_PACKAGE_STATUS;
  groupOwnerName: string;
  products: ProductPackage[];
  currentPeriodBillingInfo: BillingPeriodInfo;
  nextPeriodBillingInfo: BillingPeriodInfo;
  currentPeriodPrice: number;
  nextPeriodPrice: number;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  expiresAt: string;
  changeBlockReason?: SUBSCRIPTION_CHANGE_BLOCK_REASON | null;
  allowSameSubscriptionChange: boolean;
  allowDifferentSubscriptionSwitch: boolean;
  enableGiftSubscription: boolean;
  allowFutureStartDate: boolean;
  allowAutoRenewChange: boolean;
  changeData?: ChangeSubscriptionDetails | null;
  primaryAddress: ProfileAddress;
  invoiceAddress: ProfileAddress | null;
  groupOwnerMemberName: string;
  groupOwnerMemberId: string;
  groupOwnerMemberNumber: number;
  groupOwnerPhoneNumber: string;
  /** @format date-time */
  activeSince: string;
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  currentPeriodEnd: string;
  /** @format date-time */
  scheduledActivationDate: string;
  hasOptionalProductsInPlan: boolean;
  inviteAcceptedProducts: MemberPackageProductSeat[];
  recipientAttachedProducts: MemberPackageProduct[];
}

export interface SubscriptionProduct {
  productId: number;
  name: string;
  price: number;
  currency: string;
  isOptional: boolean;
  basePrice: number;
  properties: OptionalProductProperties;
  shippingCharges: ShippingCharge[];
  productCategory:
    | 'digital_subscription'
    | 'physical_subscription'
    | 'physical'
    | 'event_ticket'
    | 'PHYSICAL_PRODUCT';
  tax: number;
  description: string;
}

export interface SubscriptionPlanResponse {
  paymentProviders: PAYMENT_PROVIDER[];
  name: string;
  uuid: string;
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency: number;
  autoRenew: boolean;
  status: 'draft' | 'published' | 'unpublished';
  tenantId: number;
  allowSameSubscriptionChange: boolean;
  allowDifferentSubscriptionSwitch: boolean;
  enableGiftSubscription: boolean;
  allowFutureStartDate: boolean;
  showAsOptionOnSubscriptionSwitch: boolean;
  tenant: Tenant;
  entityTags: EntityTag[];
  subscriptionPlanProducts: SubscriptionPlanProduct[];
  packages: Package[];
  memberPackages: MemberPackage[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
  subscriptionCount: number;
  products: SubscriptionProduct[];
  tags?: string[];
  price: number;
}

export enum ProductCategory {
  DigitalSubscription = 'digital_subscription',
  PhysicalSubscription = 'physical_subscription',
  Physical = 'physical',
  EventTicket = 'event_ticket',
  PHYSICAL_PRODUCT = 'PHYSICAL_PRODUCT',
}

export enum SHIPPING_PROVIDER {
  Helthjem = 'Helthjem',
  BringPosten = 'Bring - Posten',
}

export interface DeliveryAddress {
  id: number;
  line1: string;
  line2: string;
  city: string;
  postCode: string;
  country: string;
  name: string;
  email: string;
  companyName: string;
  organizationNo: string;
  invoiceReference?: string;
}

export interface GiftReceiverResponse {
  ownerHasAccess: boolean;
  seatsAllowed: number;
  seatsActive: number;
  seatsRemaining: number;
  maxQuantityPerOrder: number;
  groupOwnerMemberName: string;
  groupOwnerMemberId: string;
  groupOwnerMemberNumber: number;
  seats: SeatData[];
}

export interface MemberSubscribedProduct {
  id: number;
  productId: number;
  name: string;
  productCategory: ProductCategory;
  quantity: number;
  price: number;
  recurringPrice: number;
  isOptional: boolean;
  shippingCountry: string;
  shippingProvider: SHIPPING_PROVIDER;
  allowDistributorToUpdateDeliveryAddress: boolean;
  deliveryAddresses?: DeliveryAddress[];
  groupInfo?: GroupSubscriptionResponse;
  giftReceiverInfo?: GiftReceiverResponse;
  primaryAddress?: ProfileAddress;
  emailDomains?: string[];
}

export interface CreateAdditionalMemberDto {
  fullName?: string;
  nickName?: string;
  /** @format date-time */
  createdAt?: string;
  avatar?: string;
  countryCode?: string;
  /** @format date-time */
  birthDate?: string;
  deleteAfterExpiration?: boolean;
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  customPropertyValues?: object;
  emailVerified?: string;
  phoneVerified?: string;
  memberNumber?: number;
  userId?: number;
  memberPackageProductId: number;
  /** @format email */
  email?: string;
  phone?: string;
  address?: ProfileAddress;
}

export interface CreateGiftReceiverDto {
  fullName: string;
  /** @format email */
  email: string;
  phone: string;
  memberPackageProductId: number;
}

export interface UpdateMemberPackageDto {
  autoRenew?: boolean;
  /** @format date-time */
  nextRenewal?: string;
  /** @format date-time */
  scheduledActivationDate?: string;
}

export interface MemberPackageProductSeatRecipientProductsResponseDto {
  /**
   * The ID of the member package product
   * @example 123
   */
  memberPackageProductId: number;
  /**
   * The name of the product
   * @example "Premium Subscription"
   */
  productName: string;
}

export interface MemberAddressDto {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  name: string;
  email: string;
  organizationNo: string;
  companyName: string;
  invoiceReference?: string;
}

export interface UpdateMemberDto {
  fullName?: string;
  deleteAfterExpiration?: boolean;
  address?: MemberAddressDto;
  /** @format email */
  email?: string;
  /** @format date-time */
  birthDate?: string;
  nickName?: string;
  phone?: string;
  countryCode?: string;
  isCompany?: boolean;
  companyName?: string;
  isVatLiable?: boolean;
  customPropertyValues?: object;
}

export interface InviteSeatDto {
  /** @format email */
  email: string;
  id: number;
}

export interface ConsentUpdateDto {
  channel: 'mypage' | 'onboarding' | 'newsletter' | 'admin' | 'mailchimp' | 'make' | 'm2m';
  note: string;
}

export interface ChangeSubscriptionDto {
  planId?: number;
  isImmediate: boolean;
  products?: OptionalProductWithQuantity[];
}

export interface ChangeSubscriptionResponse {
  subscriptionChangeId: number;
  orderId?: number;
}

export enum MISSING_INFO {
  MemberDetails = 'member_details',
  InvitedMemberDetails = 'invited_member_details',
  MemberNotInvited = 'member_not_invited',
  GiftReceiverNotAdded = 'gift_receiver_not_added',
  ActivationDate = 'activation_date',
  AvailableSubscriptionsToJoin = 'available_subscriptions_to_join',
  ActiveSubscriptions = 'active_subscriptions',
}

export interface InvitedMemberInfo {
  subscriptionId: number;
  seatId: number;
  memberPackageProductId: number;
  productName: string;
  invitedMemberEmail: string;
}

export interface SubscriptionProductInfo {
  memberPackageProductId: number;
  productName: string;
}

export interface MemberNotInvitedInfo {
  subscriptionId: number;
  packageName: string;
  subscriptionProductInfo: SubscriptionProductInfo[];
}

export interface GiftReceiverNotAddedInfo {
  subscriptionId: number;
  planName: string;
  subscriptionProductInfo: SubscriptionProductInfo[];
}

export interface ActivationDateMissingInfo {
  subscriptionId: number;
  planName: string;
}

export interface MissingInfoResponse {
  missingInfoType: MISSING_INFO;
  alertIndex: string;
  missingFields: string[];
  invitedMemberInfo: InvitedMemberInfo;
  memberNotInvitedInfo: MemberNotInvitedInfo;
  giftReceiverNotAddedInfo: GiftReceiverNotAddedInfo;
  activationDateMissingInfo: ActivationDateMissingInfo;
  availableSubscriptionsToJoin: MemberPackageProduct[];
  defaultPackageSlug: string;
}

export interface LoginAccountsResponse {
  id: string;
  provider: string;
  providerAccountId: string;
  email?: string;
  phone?: string;
  userId: number;
}

export enum LANGUAGE {
  En = 'en',
  No = 'no',
}

export interface SubscriptionActionHelpTextRequestDto {
  language?: LANGUAGE;
  autoRenew?: boolean;
  isRestart?: boolean;
}

export interface SubscriptionActionHelpTextResponse {
  helpText: string;
}

export interface CreateMemberDto {
  fullName: string;
  /** @format email */
  email: string;
  /** @format date-time */
  birthDate: string;
  nickName: string;
  phone: string;
  countryCode?: string;
  isCompany: boolean;
  companyName: string;
  isVatLiable: boolean;
  address: MemberAddressDto;
  customPropertyValues?: object;
}

export interface MemberPersonalInfoPaginated {
  items: MemberPersonalInfo[];
  meta: PageMeta;
}

export enum MEMBER_FILTER_FIELD {
  Email = 'email',
  Id = 'id',
  UpdatedAt = 'updatedAt',
  SubscriptionStatus = 'subscriptionStatus',
  SubscriptionPlanId = 'subscriptionPlanId',
  CustomProperty = 'customProperty',
}

export enum MEMBER_FILTER_OPERATOR {
  Eq = 'eq',
  Neq = 'neq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
}

export interface MemberFilter {
  field: MEMBER_FILTER_FIELD;
  operator: MEMBER_FILTER_OPERATOR;
  value: object;
}

export interface MemberFilterDto {
  filters: MemberFilter[];
}

export interface SearchResponseDto {
  entityType: object;
  id: string;
  fullName: string;
  email: string;
  companyName: string;
  memberNumber: number;
}

export interface PaymentAndRefundResponse {
  id: number;
  type: TransactionResponseType;
  /** @format date-time */
  paymentDate: string;
  amount: number;
  paymentMethod: 'card' | 'vipps' | 'manual_registration' | 'efaktura' | 'ehf' | 'avtalegiro';
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  memberPackageId: number;
  paymentReference: string;
  invoiceNumber: number;
  invoiceId: number;
  orderNumber: number;
  orderId: number;
  refundNumber?: number;
  status: 'pending' | 'succeeded' | 'failed';
  note: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  registrationDate: string;
}

export interface PaymentAndRefundResponsePaginated {
  items: PaymentAndRefundResponse[];
  meta: PageMeta;
}

export interface NoteResponse {
  id: number;
  note: string;
  memberId: string;
  adminUserId: number;
  adminUserName: string;
  /** @format date-time */
  createdAt: string;
}

export interface NoteResponsePaginated {
  items: NoteResponse[];
  meta: PageMeta;
}

export enum COMMUNICATION_CHANNEL {
  Sms = 'sms',
  Email = 'email',
}

export enum SENDGRID_MAIL_EVENTS {
  Processed = 'processed',
  Dropped = 'dropped',
  Deferred = 'deferred',
  Bounce = 'bounce',
  Delivered = 'delivered',
  Open = 'open',
  Failed = 'failed',
  Click = 'click',
}

export interface MemberCommunicationActivitiesResponseDto {
  communicationChannel: COMMUNICATION_CHANNEL;
  status: SENDGRID_MAIL_EVENTS;
  memberId: string;
  /** @format date-time */
  lastUpdatedAt: string;
  subject: string;
  deliveredAt: number;
  firstOpenedAt: number;
  communicationId: number;
  id: number;
  showCommunicationDetails: boolean;
  messageId?: string;
}

export interface MemberCommunicationActivitiesResponseDtoPaginated {
  items: MemberCommunicationActivitiesResponseDto[];
  meta: PageMeta;
}

export enum ActivityLogAction {
  InitialPurchase = 'initial_purchase',
  SubscriptionRenewed = 'subscription_renewed',
  AutoRenewalTurnedOff = 'auto_renewal_turned_off',
  AutoRenewalTurnedOn = 'auto_renewal_turned_on',
  SubscriptionExpired = 'subscription_expired',
  PaymentFailed = 'payment_failed',
  SubscriptionActivated = 'subscription_activated',
  SubscriptionDeactivated = 'subscription_deactivated',
  SubscriptionReactivated = 'subscription_reactivated',
  SubscriptionStopped = 'subscription_stopped',
  SubscriptionCanceledBeforeActivation = 'subscription_canceled_before_activation',
  ActivationDateUpdated = 'activation_date_updated',
  NextRenewalUpdated = 'next_renewal_updated',
  RecurringPriceUpdated = 'recurring_price_updated',
  ChangeInitiated = 'change_initiated',
  ChangeCompleted = 'change_completed',
  ChangeCancelled = 'change_cancelled',
  SeatInvitationSent = 'seat_invitation_sent',
  SeatInvitationRemoved = 'seat_invitation_removed',
  SeatInvitationAccepted = 'seat_invitation_accepted',
  SeatMemberAdded = 'seat_member_added',
  SeatGiftReceiverAdded = 'seat_gift_receiver_added',
  SeatGiftReceiverRemoved = 'seat_gift_receiver_removed',
  SeatGiftReceiverAccepted = 'seat_gift_receiver_accepted',
  SeatGiftReceiverInvitationSent = 'seat_gift_receiver_invitation_sent',
  InvoiceSent = 'invoice_sent',
  PaymentMethodUpdated = 'payment_method_updated',
  PaymentProviderUpdated = 'payment_provider_updated',
  InvoiceAddressUpdated = 'invoice_address_updated',
  DeliveryAddressUpdated = 'delivery_address_updated',
  CreditNoteCreated = 'credit_note_created',
  RefundRegistered = 'refund_registered',
  PaymentRegistered = 'payment_registered',
  VippsRecurringChargeInitiated = 'vipps_recurring_charge_initiated',
  UpdateMemberProfile = 'update_member_profile',
  UpdateConsent = 'update_consent',
  Login = 'login',
  Signup = 'signup',
  GdprDeleted = 'gdpr_deleted',
}

export interface ActivityLogResponse {
  action: ActivityLogAction;
  feed: object;
  /** @format date-time */
  createdAt: string;
  memberId: string;
  memberNumber: number;
  id: number;
}

export interface ActivityLogResponsePaginated {
  items: ActivityLogResponse[];
  meta: PageMeta;
}

export interface MemberSettings {
  id: string;
  userType: string;
  isTestUser: boolean;
  fixedOTP: string;
}

export interface MemberSettingsUpdate {
  isTestUser: boolean;
  fixedOTP: string;
}

export interface VippsPaymentInfo {
  agreementId: string;
  phone: string;
}

export interface MemberSubscribedPackage {
  stripeCardInfo: StripeCardInfo;
  vippsPaymentInfo: VippsPaymentInfo;
  netsCardInfo: NetsCardInfo;
  paymentInfo: Payment;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  id: number;
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'paused'
    | 'stopped'
    | 'expired'
    | 'waiting_for_activation';
  planName: string;
  packName: string;
  packageId: number;
  slug: string;
  recurringPrice: number;
  currentPrice: number;
  introPeriodInfo: BillingPeriodInfo;
  recurringPeriodInfo: BillingPeriodInfo;
  products: MemberSubscribedProduct[];
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodFrequency: number;
  billingPeriodUnit: 'day' | 'week' | 'month' | 'year';
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  currentPeriodEnd: string;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  cancelledAt: string;
  autoRenew: boolean;
  /** @format date-time */
  activeSince: string;
  isOwner: boolean;
  groupOwnerMemberId: string;
  groupOwnerMemberNumber: number;
  groupOwnerMemberName: string;
  groupInfo: GroupSubscriptionResponse | null;
  isPayable: boolean;
  change: MemberPackageChange | null;
  subscriptionPlanId: number;
  subscriptionPlanName: string;
}

export interface ConfirmChangeSubscriptionDto {
  isImmediate: boolean;
}

export interface UpdateRecurringPriceDto {
  /** @min 1 */
  recurringPrice: number;
}

export interface UpdateShippingProviderInfoDto {
  shippingProvider: 'Helthjem' | 'Bring - Posten';
  allowDistributorToUpdateDeliveryAddress: boolean;
}

export interface UpdateEmailDomainsDto {
  emailDomains?: string[];
}

export interface FreePackageRequestDto {
  packageId: number;
  email: string;
}

export interface FakturaCheckoutUser {
  email: string;
  fullName: string;
  phone?: string;
  countryCode?: 'NO' | 'SE' | 'DK' | 'FI' | 'FO' | 'GB';
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  reference?: string;
  onCheckoutCompletedUrl?: string;
}

export interface BillingAddress {
  address: string;
  addressTwo?: string;
  organizationNo?: string;
  postCode: string;
  city?: string;
  country: string;
  invoiceReference?: string;
}

export interface FakturaPackageSubscriptionDto {
  packageId: number;
  /** @format date-time */
  paymentDate?: string;
  isPaid?: boolean;
  optionalProducts?: OptionalProductWithQuantity[];
  userData: FakturaCheckoutUser;
  billingAddress?: BillingAddress;
}

export interface FakturaSubscriptionUpdateDto {
  memPackId: number;
  /** @format date-time */
  paymentDate?: string;
  isPaid?: boolean;
  note?: string;
  paymentProvider?: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
}

export interface CreateNoteDto {
  note: string;
  memberId: string;
}

export interface UpdateNoteDto {
  note: string;
}

export interface CreateProductDto {
  productCategory: ProductCategory;
  hasInternationalShipping?: boolean;
  name: string;
  price: number;
  currency: string;
  /**
   * @min 0
   * @max 1
   */
  tax: number;
  stock: number;
  maxQuantityPerOrder: number;
  allowFutureStartDate: boolean;
  status: 'draft' | 'published' | 'unpublished';
  isOptional: boolean;
  tags: string[];
  ean?: string;
  description?: string;
}

export interface ProductResponse {
  productCategory:
    | 'digital_subscription'
    | 'physical_subscription'
    | 'physical'
    | 'event_ticket'
    | 'PHYSICAL_PRODUCT';
  tenantId: number;
  name: string;
  uuid: string;
  isOptional: boolean;
  price: number;
  currency: string;
  tax: number;
  stock: number;
  maxQuantityPerOrder: number;
  ean: string;
  allowFutureStartDate: boolean;
  status: 'draft' | 'published' | 'unpublished';
  properties: object;
  shippingCharges: ShippingCharge[];
  description: string;
  tenant: Tenant;
  entityTags: EntityTag[];
  subscriptionPlanProducts: SubscriptionPlanProduct[];
  packageProducts: PackageProduct[];
  memberPackageProducts: MemberPackageProduct[];
  orderItem: OrderItem[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
  tags?: string[];
  memberFields?: ('email' | 'fullName' | 'phone' | 'address')[];
  hasInternationalShipping?: boolean;
}

export interface ProductResponsePaginated {
  items: ProductResponse[];
  meta: PageMeta;
}

export interface UpdateProductDto {
  productCategory?: ProductCategory;
  hasInternationalShipping?: boolean;
  memberFields?: ('email' | 'fullName' | 'phone' | 'address')[];
  name?: string;
  price?: number;
  currency?: string;
  /**
   * @min 0
   * @max 1
   */
  tax?: number;
  stock?: number;
  maxQuantityPerOrder?: number;
  allowFutureStartDate?: boolean;
  status?: 'draft' | 'published' | 'unpublished';
  isOptional?: boolean;
  tags?: string[];
  ean?: string;
  description?: string;
}

export interface SubscriptionPlanProductDto {
  productId: number;
  price: number;
  properties: OptionalProductProperties;
}

export interface CreateSubscriptionPlanDto {
  /** @minItems 1 */
  paymentProviders: PAYMENT_PROVIDER[];
  allowSameSubscriptionChange?: boolean;
  allowDifferentSubscriptionSwitch?: boolean;
  enableGiftSubscription?: boolean;
  allowFutureStartDate?: boolean;
  showAsOptionOnSubscriptionSwitch?: boolean;
  name: string;
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit: string;
  billingPeriodFrequency: number;
  status: 'draft' | 'published' | 'unpublished';
  autoRenew: boolean;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  products: SubscriptionPlanProductDto[];
  tags: string[];
}

export interface SubscriptionPlanResponsePaginated {
  items: SubscriptionPlanResponse[];
  meta: PageMeta;
}

export interface SubscriptionStatistic {
  activeMembers: number;
  soldToday: number;
  soldYesterday: number;
  soldLast7Days: number;
}

export interface SubscriptionPlanPriceByQuantityDto {
  planId: number;
  products: OptionalProductWithQuantity[];
}

export interface UpdateSubscriptionPlanDto {
  /** @minItems 1 */
  paymentProviders?: PAYMENT_PROVIDER[];
  allowSameSubscriptionChange?: boolean;
  allowDifferentSubscriptionSwitch?: boolean;
  enableGiftSubscription?: boolean;
  allowFutureStartDate?: boolean;
  showAsOptionOnSubscriptionSwitch?: boolean;
  name?: string;
  billingPeriod?: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit?: string;
  billingPeriodFrequency?: number;
  status?: 'draft' | 'published' | 'unpublished';
  autoRenew?: boolean;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  products?: SubscriptionPlanProductDto[];
  tags?: string[];
}

export interface PackageProductDto {
  productId: number;
  price: number;
  properties?: OptionalProductProperties;
}

export interface CreatePackageDto {
  salesTitle: string;
  slug?: string;
  subscriptionPlanId?: number;
  name: string;
  /** @minItems 1 */
  paymentProviders: PAYMENT_PROVIDER[];
  description?: string;
  /** @format binary */
  image?: File;
  billingPeriod?: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit?: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency?: number;
  status: 'draft' | 'published' | 'unpublished';
  isAvailableOnMyPage?: boolean;
  isAvailableViaSlug?: boolean;
  isAvailableForManualOrderViaAdmin?: boolean;
  onboardingWelcomeRedirectCTAText: Translation;
  products?: PackageProductDto[];
  /** @format date-time */
  introPeriodFixedEndDate?: string;
}

export interface PackProduct {
  productId: number;
  name: string;
  price: number;
  currency: string;
  tax: number;
  basePrice: number;
  recurringPrice: number;
  isOptional: boolean;
  productCategory:
    | 'digital_subscription'
    | 'physical_subscription'
    | 'physical'
    | 'event_ticket'
    | 'PHYSICAL_PRODUCT';
  properties: OptionalProductProperties | null;
  recurringProperties: OptionalProductProperties | null;
  shippingCharges: ShippingCharge[];
  description: string;
}

export interface CustomInputFields {
  memberType: boolean;
  invoiceAddress: boolean;
  city: boolean;
}

export interface PackageResponse {
  paymentProviders: PAYMENT_PROVIDER[];
  onboardingWelcomeRedirectCTAText: Translation | null;
  subscriptionCount: number;
  products: PackProduct[] | null;
  /** @default 0 */
  price: number;
  recurringPrice: number;
  isAvailableOnMyPage: boolean;
  isAvailableForManualOrderViaAdmin: boolean;
  customInputFields: CustomInputFields;
  salesTitle: string;
  uuid: string;
  subscriptionPlanId: number;
  slug: string;
  image: string;
  name: string;
  description: object;
  billingPeriod: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency: number;
  status: 'draft' | 'published' | 'unpublished';
  isAvailableViaSlug: boolean;
  allowSameSubscriptionChange: boolean;
  allowDifferentSubscriptionSwitch: boolean;
  tenantId: number;
  /** @format date-time */
  introPeriodFixedEndDate: string;
  tenant: Tenant;
  packageProducts: PackageProduct[];
  subscriptionPlan: SubscriptionPlan;
  payments: Payment[];
  memberPackages: MemberPackage[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface MinimalPackageResponse {
  packName: string;
  name: string;
  id: number;
  slug: string;
}

export interface PackageResponsePaginated {
  items: PackageResponse[];
  meta: PageMeta;
}

export interface UpdatePackageDto {
  salesTitle?: string;
  slug?: string;
  subscriptionPlanId?: number;
  name?: string;
  /** @minItems 1 */
  paymentProviders?: PAYMENT_PROVIDER[];
  description?: string;
  /** @format binary */
  image?: File;
  billingPeriod?: 'monthly' | 'thirty_days' | 'quarterly' | 'half_yearly' | 'yearly' | 'custom';
  billingPeriodUnit?: 'day' | 'week' | 'month' | 'year';
  billingPeriodFrequency?: number;
  status?: 'draft' | 'published' | 'unpublished';
  isAvailableOnMyPage?: boolean;
  isAvailableViaSlug?: boolean;
  isAvailableForManualOrderViaAdmin?: boolean;
  onboardingWelcomeRedirectCTAText?: Translation;
  products?: PackageProductDto[];
  /** @format date-time */
  introPeriodFixedEndDate?: string;
  imagePreview?: string;
  previousImageUrl?: string;
}

export interface PriceByQuantityDto {
  packageId: number;
  products: OptionalProductWithQuantity[];
}

export interface PrePurchasePackageSubscriptionDto {
  packageId: number;
  optionalProducts?: OptionalProductWithQuantity[];
  /** @format date-time */
  paymentDate?: string;
  memberId: string;
  reference: string;
}

export interface PrePurchasePackageResponseDto {
  memberId: string;
  packageId: number;
  subscriptionPlanId: number;
  recurringPrice: number;
  currentPrice: number;
  status:
    | 'active'
    | 'inactive'
    | 'pending'
    | 'paused'
    | 'stopped'
    | 'expired'
    | 'waiting_for_activation';
  autoRenew: boolean;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  currentPeriodStart: string;
  /** @format date-time */
  forcedStopDate: string;
  /** @format date-time */
  cancelledAt: string;
  isCustomized: boolean;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  reference: string;
  /** @format date-time */
  lastActiveAt: string;
  isOnIntroPeriod: boolean;
  /** @format date-time */
  nextOrderDate: string;
  /** @format date-time */
  scheduledActivationDate: string | null;
  package: Package;
  subscriptionPlan: SubscriptionPlan;
  member: Member;
  memberPackageProducts: MemberPackageProduct[];
  orders: Order[];
  memberPackageProviderPayment: MemberPackageProviderPayment;
  changes: MemberPackageChange[];
  histories: MemberPackageHistory[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
  planName: string;
  packageName: string;
  email: string;
  fullName: string;
  paymentDate: string;
  paymentMethod: string;
}

export interface MinimalMemberPackageResponseDto {
  packageName: string;
  memberEmail: string;
  status: string;
  /** @format date-time */
  nextRenewal: string;
  /** @format date-time */
  expiresAt: string;
  /** @format date-time */
  currentPeriodStart: string;
  autoRenew: boolean;
}

export interface MinimalMemberPackageResponseWithPlanDto {
  packageName: string;
  memberEmail: string;
  status: string;
  planName: string;
}

export enum NewsletterProvider {
  Mailchimp = 'mailchimp',
  Make = 'make',
}

export interface NewsletterListsReqDto {
  provider: NewsletterProvider;
  apiKey: string;
  userName: string;
  password: string;
}

export interface NewsletterListsResponseDto {
  id: string;
  name: string;
}

export interface ExternalProviderNewsLetterDto {
  name: string;
  provider: 'mailchimp' | 'make';
  config?: NewsletterConfig;
}

export interface ConsentExternalProviderResponseDto {
  provider: 'mailchimp' | 'make';
  name: string;
  tenantId: number;
  config: NewsletterConfig;
  tenant: Tenant;
  consents: Consent[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CreateOidcClientDto {
  name: string;
  applicationType: string;
  platform: string;
  callbackUrl: string;
  /** @minItems 1 */
  postLogoutRedirectUris: string[];
  disablePKCE: boolean;
  debugMode: boolean;
}

export type PatchOidcClientDto = object;

export interface M2MScopes {
  sectionId:
    | 'member'
    | 'subscription'
    | 'consent'
    | 'push-subscription'
    | 'push-content'
    | 'content'
    | 'communication'
    | 'segment'
    | 'custom-order';
  sectionName: string;
  readPermission: boolean;
  updatePermission: boolean;
}

export interface M2MClientResponseDto {
  scopes: M2MScopes[];
  name: string;
  description: string;
  isActive: boolean;
  id: number;
  clientIdentifier: string;
  /** @format date-time */
  createdAt: string;
  tokenSuffix: string;
}

export interface CreateM2MClientRequestDto {
  name: string;
  scopes: M2MScopes[];
  description: string;
  isActive: boolean;
}

export interface CreateM2MClientResponseDto {
  scopes: M2MScopes[];
  name: string;
  description: string;
  isActive: boolean;
  id: number;
  clientIdentifier: string;
  /** @format date-time */
  createdAt: string;
  tokenSuffix: string;
  token: string;
}

export interface UpdateM2MClientRequestDto {
  name?: string;
  scopes?: M2MScopes[];
  description?: string;
  isActive?: boolean;
}

export enum MypageCardsType {
  SubriteStandard = 'subrite_standard',
  Custom = 'custom',
}

export interface CreateMypageCardsSettingRequestDto {
  title: Translation;
  link: string;
  cardType: MypageCardsType;
  description: Translation;
  showOnMyPage: boolean;
  /**
   * The order in which the card should appear on the page
   * @min 0
   */
  display_order: number;
}

export interface CreateMypageCardsSettingsResponseDto {
  title: Translation | null;
  description: Translation | null;
  id: number;
  link: string;
  cardType: 'subrite_standard' | 'custom';
  showOnMyPage: boolean;
  display_order: number;
}

export interface UpdateMypageCardSettingsRequestDto {
  title?: Translation;
  link?: string;
  cardType?: MypageCardsType;
  description?: Translation;
  showOnMyPage?: boolean;
  /**
   * The order in which the card should appear on the page
   * @min 0
   */
  display_order?: number;
}

export interface UpdateMypageCardSettingsDisplayOrderRequestDto {
  title?: Translation;
  link?: string;
  cardType?: MypageCardsType;
  description?: Translation;
  showOnMyPage?: boolean;
  /**
   * The order in which the card should appear on the page
   * @min 0
   */
  display_order?: number;
  id: number;
}

export interface GetWebhookResponseDto {
  webhook: Webhook;
  events: Record<string, string[]>;
}

export enum INTERNAL_WEBHOOK_AUTHENTICATION_METHOD {
  Bearer = 'bearer',
}

export enum INTERNAL_WEBHOOK_REQUEST_METHOD {
  POST = 'POST',
  GET = 'GET',
  DELETE = 'DELETE',
}

export enum INTERNAL_WEBHOOK_EVENT_TYPE {
  MemberDeleted = 'member.deleted',
  MemberUpdated = 'member.updated',
  SubscriptionCreated = 'subscription.created',
  SubscriptionRenewed = 'subscription.renewed',
  MemberSubscriptionActivated = 'member.subscription.activated',
  MemberSubscriptionDeactivated = 'member.subscription.deactivated',
}

export interface CreateWebhookDto {
  name: string;
  description: string;
  /** @format uri */
  url: string;
  authenticationMethod: INTERNAL_WEBHOOK_AUTHENTICATION_METHOD;
  authenticationConfig: WebhookAuthenticationBearerConfig;
  /** @default "POST" */
  requestMethod: INTERNAL_WEBHOOK_REQUEST_METHOD;
  /** @minItems 1 */
  events: INTERNAL_WEBHOOK_EVENT_TYPE[];
}

export interface LinkSpotifyDto {
  code: string;
  redirect_uri: string;
}

export interface LinkSpotifyResponseDto {
  completion_url: string;
}

export interface Podcast {
  id: number;
  name: string;
  rssFeedUrl: string;
  imageUrl: string;
  tenant: Tenant;
  tenantId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CreatePodcastDto {
  /** @maxLength 1024 */
  name: string;
  /**
   * @format uri
   * @maxLength 1024
   */
  rssFeedUrl?: string;
}

export interface UpdatePodcastDto {
  /** @maxLength 1024 */
  name?: string;
  /**
   * @format uri
   * @maxLength 1024
   */
  rssFeedUrl?: string;
}

export interface ContentProductDto {
  productId: number;
  productName: string;
}

export interface SpotifyPartner {
  spotifyPartnerId: string;
  sandbox: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  tenantId: number;
  tenant: Tenant;
}

export interface FeedSpotifyResponseDto {
  signature: string;
}

export interface CreateContentChannelDto {
  /** @maxLength 1024 */
  name: string;
  /** @maxLength 1024 */
  description?: string;
}

export interface UpdateContentChannelDto {
  /** @maxLength 1024 */
  name?: string;
  /** @maxLength 1024 */
  description?: string;
}

export interface ContentChannelDto {
  /** Unique identifier of the content channel */
  id: number;
  /**
   * Name of the content channel
   * @maxLength 1024
   */
  name: string;
  /** Description of the content channel */
  description?: string;
}

export enum PermissionLevelForBuyingSamePackage {
  Allow = 'allow',
  Warn = 'warn',
  Block = 'block',
}

export enum PermissionLevelForBuyingMultipleSubscriptions {
  Allow = 'allow',
  Warn = 'warn',
  Block = 'block',
}

export interface PreferenceResponseDto {
  eInvoicePaymentPreference: EInvoicePaymentPreference;
  systemUpgradeNotification: Translation | null;
  inputFieldConfig: PageInputFieldConfig[];
  maintenanceModeConfig: MaintenanceModeConfig | null;
  permissionLevelForBuyingSamePackage: PermissionLevelForBuyingSamePackage;
  permissionLevelForBuyingMultipleSubscriptions: PermissionLevelForBuyingMultipleSubscriptions;
  customFieldsOnInvoice: CustomFieldsOnInvoiceDto[] | null;
  welcomeImage: string | null;
  headerText: string | null;
  welcomePrimaryText: string | null;
  welcomeSecondaryText: string | null;
  memberInfoText: string | null;
  paymentConfirmationImage: string | null;
  subscriptionChangeCompleteScreenImage: string | null;
  paymentConfirmationPrimaryText: string | null;
  paymentConfirmationSecondaryTextLoggedOut: string | null;
  paymentConfirmationSecondaryTextLoggedIn: string | null;
  headerColor: string | null;
  headerTextColor: string | null;
  primaryButtonColor: string | null;
  primaryButtonHoverColor: string | null;
  primaryButtonTextColor: string | null;
  primaryStepColor: string | null;
  onboardingFlow: boolean;
  invoiceLogo: string | null;
  automationTemplateId: number;
  allowedDaysAfterExpiry: number;
  onNewUserCompletedProductPackageSlug: string | null;
  allowBuyNewSubsFromMypage: boolean;
  allowBuyGiftSubsFromMypage: boolean;
  onNewUserCompletedNewsletterAndConsent: boolean;
  showMinSideCTAOnCheckoutWelcome: boolean;
  giftSubscriptionConfirmationTextLoggedIn: string | null;
  giftSubscriptionWelcomeHelpText: string | null;
  theme: ThemeConfig | null;
  customFieldsOnMemberCard: string[];
}

export interface PublicOAuthProvider {
  id: string;
  clientId: string;
  name: string;
}

export interface Address {
  entityId: string;
  entity: string;
  companyName: string;
  organizationNo: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  addressType: 'primary' | 'delivery' | 'billing' | 'not_set';
  name: string;
  email: string;
  invoiceReference?: string;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface TenantResponse {
  id: number;
  name: string;
  isActive: boolean;
  language: 'en' | 'no';
  hostName: string;
  logo: string;
  favicon: string;
  siteUrl: string;
  termsUrl: string;
  privacyUrl: string;
  gtm: string;
  taxRates?: number[];
  smsOtp: boolean;
  smsSenderName: string;
  tenantContact: string;
  tenantSenderName: string;
  tenantSenderEmail: string;
  registeredBusinessNo: string;
  bankAccountNo: string;
  swiftCode: string;
  iban: string;
  subriteTrackerId: string;
  defaultLogoutURL: string;
  postalAddress: string;
  preference: PreferenceResponseDto;
  oauthProviders: PublicOAuthProvider[];
  emailProvider: 'brevo' | 'sendgrid';
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  address?: Address;
}

export interface TenantPreferenceUpdateDto {
  eInvoicePaymentPreference?: EInvoicePaymentPreference;
  systemUpgradeNotification?: Translation | null;
  inputFieldConfig?: PageInputFieldConfig[];
  maintenanceModeConfig?: MaintenanceModeConfig | null;
  permissionLevelForBuyingSamePackage?: PermissionLevelForBuyingSamePackage;
  permissionLevelForBuyingMultipleSubscriptions?: PermissionLevelForBuyingMultipleSubscriptions;
  customFieldsOnInvoice?: CustomFieldsOnInvoiceDto[] | null;
  welcomeImage?: string | null;
  headerText?: string | null;
  welcomePrimaryText?: string | null;
  welcomeSecondaryText?: string | null;
  memberInfoText?: string | null;
  paymentConfirmationImage?: string | null;
  subscriptionChangeCompleteScreenImage?: string | null;
  paymentConfirmationPrimaryText?: string | null;
  paymentConfirmationSecondaryTextLoggedOut?: string | null;
  paymentConfirmationSecondaryTextLoggedIn?: string | null;
  headerColor?: string | null;
  headerTextColor?: string | null;
  primaryButtonColor?: string | null;
  primaryButtonHoverColor?: string | null;
  primaryButtonTextColor?: string | null;
  primaryStepColor?: string | null;
  onboardingFlow?: boolean;
  invoiceLogo?: string | null;
  automationTemplateId?: number;
  allowedDaysAfterExpiry?: number;
  onNewUserCompletedProductPackageSlug?: string | null;
  allowBuyNewSubsFromMypage?: boolean;
  allowBuyGiftSubsFromMypage?: boolean;
  onNewUserCompletedNewsletterAndConsent?: boolean;
  showMinSideCTAOnCheckoutWelcome?: boolean;
  giftSubscriptionConfirmationTextLoggedIn?: string | null;
  giftSubscriptionWelcomeHelpText?: string | null;
  theme?: ThemeConfig | null;
  customFieldsOnMemberCard?: string[];
}

export interface UpdateTenantSettingsDto {
  preference?: TenantPreferenceUpdateDto;
  name?: string;
  language?: 'en' | 'no';
  hostName?: string;
  logo?: string;
  favicon?: string;
  siteUrl?: string;
  termsUrl?: string;
  privacyUrl?: string;
  gtm?: string;
  taxRates?: number[];
  smsOtp?: boolean;
  smsSenderName?: string;
  tenantContact?: string;
  tenantSenderName?: string;
  tenantSenderEmail?: string;
  registeredBusinessNo?: string;
  bankAccountNo?: string;
  swiftCode?: string;
  iban?: string;
  subriteTrackerId?: string;
  defaultLogoutURL?: string;
  postalAddress?: string;
  address?: Address;
  otpTemplateId?: Translation;
}

export enum TenantImageProperty {
  Logo = 'logo',
  Favicon = 'favicon',
  WelcomeImage = 'welcomeImage',
  PaymentConfirmationImage = 'paymentConfirmationImage',
  InvoiceLogo = 'invoiceLogo',
  SubscriptionChangeCompleteScreenImage = 'subscriptionChangeCompleteScreenImage',
}

export interface UploadTenantImageDto {
  propertyName: TenantImageProperty;
  /** @format binary */
  image?: File;
  removePreviousImageUrl?: boolean;
}

export enum FontType {
  PrimaryFont = 'PrimaryFont',
  SecondaryFont = 'SecondaryFont',
}

export interface UploadFontDto {
  fontType: FontType;
  fontConfig: FontConfig;
  /** @format binary */
  font?: File;
  removePreviousFontUrl?: boolean;
}

export interface UpdateTenantDto {
  name?: string;
  language?: 'en' | 'no';
  hostName?: string;
  logo?: string;
  favicon?: string;
  siteUrl?: string;
  termsUrl?: string;
  privacyUrl?: string;
  gtm?: string;
  taxRates?: number[];
  smsOtp?: boolean;
  smsSenderName?: string;
  tenantContact?: string;
  tenantSenderName?: string;
  tenantSenderEmail?: string;
  registeredBusinessNo?: string;
  bankAccountNo?: string;
  swiftCode?: string;
  iban?: string;
  subriteTrackerId?: string;
  defaultLogoutURL?: string;
  postalAddress?: string;
  address?: Address;
  otpTemplateId?: Translation;
}

export interface TenantDetailsResponse {
  id: number;
  name: string;
  isActive: boolean;
  language: 'en' | 'no';
  hostName: string;
  logo: string;
  favicon: string;
  siteUrl: string;
  termsUrl: string;
  privacyUrl: string;
  gtm: string;
  taxRates?: number[];
  smsOtp: boolean;
  smsSenderName: string;
  tenantContact: string;
  tenantSenderName: string;
  tenantSenderEmail: string;
  subriteTrackerId: string;
  defaultLogoutURL: string;
  postalAddress: string;
  preference: PreferenceResponseDto;
  oauthProviders: PublicOAuthProvider[];
  emailProvider: 'brevo' | 'sendgrid';
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  address?: Address;
  otpTemplateId?: Translation;
  brandKitId?: string;
}

export interface TenantAdditionalHostnameDto {
  id: number;
  hostName: string;
  tenantId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  brandKitId: string;
  brandKit?: BrandKitResponseDto;
}

export interface BrandKitResponseDto {
  id: string;
  name: string;
  brandKitSenderName?: string;
  brandKitSenderEmail?: string;
  smsOtp?: boolean;
  smsSenderName?: string;
  favicon?: string;
  siteUrl?: string;
  termsUrl?: string;
  privacyUrl?: string;
  defaultLogoutUrl?: string;
  pageHeader?: PageHeaderConfig;
  primaryButton?: ButtonConfig;
  primaryFont?: BrandKitFontConfig;
  secondaryFont?: BrandKitFontConfig;
  otpTemplateId?: Translation;
  tenantId: number;
  isDefault: boolean;
  hostnames: TenantAdditionalHostnameDto[];
}

export interface NewTenantAdditionalHostnameDto {
  hostName: string;
  brandKitId?: string | null;
}

export interface UpdateTenantAdditionalHostnameDto {
  newHostName: string;
  hostName: string;
  brandKitId?: string | null;
}

export interface RemoveTenantAdditionalHostnameDto {
  id: number;
  hostName: string;
}

export interface BrandKitCreateDto {
  name: string;
  hostnameIds?: number[];
}

export interface BrandKitUpdateDto {
  name?: string;
  brandKitSenderName?: string;
  brandKitSenderEmail?: string;
  smsOtp?: boolean;
  smsSenderName?: string;
  favicon?: string;
  siteUrl?: string;
  termsUrl?: string;
  privacyUrl?: string;
  defaultLogoutUrl?: string;
  pageHeader?: PageHeaderConfig;
  primaryButton?: ButtonConfig;
  primaryFont?: BrandKitFontConfig;
  secondaryFont?: BrandKitFontConfig;
  otpTemplateId?: Translation;
  /** Array of hostname IDs to update. Pass empty array to remove all hostnames. */
  hostnameIds?: number[];
  /** @format binary */
  logoImage?: File;
  /** @format binary */
  faviconImage?: File;
  /** @format binary */
  primaryFontFile?: File;
  /** @format binary */
  secondaryFontFile?: File;
}

export interface UsageCostDto {
  /** @format date-time */
  month: string;
  emailSubritePrice: number;
  smsSubritePrice: number;
  totalPrice: number;
  emailQty: number;
  smsQty: number;
}

export interface CreateCommunicationDto {
  communicationType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel: 'sms' | 'email';
  name: string;
  senderId: number;
  consentId?: number;
  segmentId: number;
  smsContent?: string;
  subject?: string;
  emailEditorRawContent?: object;
  templateId?: number;
  emailPreviewText?: string;
  deliveryMethod?: string;
  externalEmailBody?: string;
}

export interface CommunicationResponseDto {
  id: number;
  name: string;
  communicationType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  smsContent: string | null;
  subject: string | null;
  emailEditorRawContent: object | null;
  emailPreviewText: string | null;
  status: 'draft' | 'ready' | 'scheduled' | 'completed' | 'failed' | 'processing';
  communicationChannel: 'sms' | 'email';
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  senderId: number;
  sender: string;
  segmentId: number;
  segmentName: string;
  consentId: number;
  consentName: string;
  tenantId: number;
  adminUserId: number;
  adminUserName: string;
  emailHtmlPreview: string | null;
  template: CommunicationTemplate | null;
  /** @format date-time */
  scheduledAt: string | null;
  /** @format date-time */
  completedAt: string | null;
  deliveryMethod: string;
  externalEmailBody: string | null;
  senderEmail: string | null;
}

export interface UpdateCommunicationDto {
  communicationType?:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel?: 'sms' | 'email';
  /**
   * Email content in HTML format
   * @example "<p>Hello {{name}},</p><p>Your email content here...</p>"
   */
  emailContent?: string;
  name?: string;
  senderId?: number;
  consentId?: number;
  segmentId?: number;
  smsContent?: string;
  subject?: string;
  emailEditorRawContent?: object;
  templateId?: number;
  emailPreviewText?: string;
  deliveryMethod?: string;
  externalEmailBody?: string;
}

export interface CommunicationPaginated {
  items: Communication[];
  meta: PageMeta;
}

export interface SendOneOffEmailDto {
  /** @format email */
  email?: string;
  memberId?: string;
  subject: string;
  /** Message content - supports plain text or HTML (auto-detected). When using HTML with attributes containing double quotes, escape them or use single quotes. */
  message: string;
}

export interface SendEmailThirdPartyDto {
  /** Name of the communication */
  name: string;
  /**
   * The ID of the sender
   * @min 1
   */
  senderId: number;
  /**
   * The type of communication
   * @example "marketing"
   */
  communicationType: 'marketing' | 'information';
  /**
   * The ID of the consent
   * @min 1
   * @example 1
   */
  consentId?: number;
  /**
   * The ID of the segment
   * @min 1
   */
  segmentId: number;
  /** The subject of the communication */
  subject?: string;
  /** The preview text of the communication */
  emailPreviewText?: string;
  /**
   * The ID of the template
   * @min 1
   * @example 1
   */
  templateId?: number;
  /** The content of the communication */
  emailContent: string;
}

export interface ThirdPartyEmailResponseDto {
  /** @example true */
  success: boolean;
  /** @example "Email sent successfully" */
  message: string;
  /** @example 123 */
  id: number;
}

export enum COMMUNICATION_TYPE {
  Automation = 'automation',
  Crm = 'crm',
  Marketing = 'marketing',
  Otp = 'otp',
  Information = 'information',
  EmailStandard = 'emailStandard',
  JobCompletion = 'jobCompletion',
  OneOff = 'oneOff',
}

export interface CreateSendSingleSmsDto {
  communicationType: COMMUNICATION_TYPE;
  phoneNumber: string;
  message: string;
  senderId: number;
  memberId: string;
}

export interface PreviewThirdPartyEmailDto {
  /** Name of the communication */
  name: string;
  /**
   * The ID of the sender
   * @min 1
   */
  senderId: number;
  /**
   * The type of communication
   * @example "marketing"
   */
  communicationType: 'marketing' | 'information';
  /**
   * The ID of the consent
   * @min 1
   * @example 1
   */
  consentId?: number;
  /**
   * The ID of the segment
   * @min 1
   */
  segmentId: number;
  /** The subject of the communication */
  subject?: string;
  /** The preview text of the communication */
  emailPreviewText?: string;
  /**
   * The ID of the template
   * @min 1
   * @example 1
   */
  templateId?: number;
  /** The content of the communication */
  emailContent: string;
  /**
   * List of email recipients for the test email
   * @maxItems 5
   * @minItems 1
   * @example ["recipient1@example.com","recipient2@example.com"]
   */
  recipients: string[];
  /**
   * Communication ID
   * @example 1
   */
  id?: number;
}

export interface EmailTestResponseDto {
  /** @example true */
  success: boolean;
  /** @example "Email sent successfully" */
  message: string;
  /** @example 123 */
  id: number;
}

export interface ScheduleThirdPartyEmailDto {
  /** Name of the communication */
  name: string;
  /**
   * The ID of the sender
   * @min 1
   */
  senderId: number;
  /**
   * The type of communication
   * @example "marketing"
   */
  communicationType: 'marketing' | 'information';
  /**
   * The ID of the consent
   * @min 1
   * @example 1
   */
  consentId?: number;
  /**
   * The ID of the segment
   * @min 1
   */
  segmentId: number;
  /** The subject of the communication */
  subject?: string;
  /** The preview text of the communication */
  emailPreviewText?: string;
  /**
   * The ID of the template
   * @min 1
   * @example 1
   */
  templateId?: number;
  /** The content of the communication */
  emailContent: string;
  /**
   * The date and time to schedule the email
   * @format date-time
   */
  scheduledAt: string;
  /**
   * The timezone for the scheduled date and time
   * @example "Europe/Oslo"
   */
  timeZone: string;
}

export interface ScheduleEmailDto {
  /**
   * The date and time to schedule the email
   * @format date-time
   */
  scheduledAt: string;
  /**
   * The timezone for the scheduled date and time
   * @example "Europe/Oslo"
   */
  timeZone?: string;
  /** Name of the communication */
  name?: string;
  /**
   * The ID of the sender
   * @min 1
   */
  senderId?: number;
  /**
   * The type of communication
   * @example "marketing"
   */
  communicationType?: 'marketing' | 'information';
  /**
   * The ID of the consent
   * @min 1
   * @example 1
   */
  consentId?: number;
  /**
   * The ID of the segment
   * @min 1
   */
  segmentId?: number;
  /** The subject of the communication */
  subject?: string;
  /** The preview text of the communication */
  emailPreviewText?: string;
  /**
   * The ID of the template
   * @min 1
   * @example 1
   */
  templateId?: number;
  /** The content of the communication */
  emailContent?: string;
}

export interface EmailScheduleResponseDto {
  /** @example true */
  success: boolean;
  /** @example "Email sent successfully" */
  message: string;
  /** @example 123 */
  id: number;
  /** @example "Communication" */
  communication: CommunicationResponseDto;
}

export interface CommunicationPersonalizedTokenDto {
  memberInfo: string[];
  myPageLink: string[];
}

export interface UpdateEmailM2MDto {
  communicationType?:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel?: 'sms' | 'email';
  /**
   * Email content in HTML format
   * @example "<p>Hello {{name}},</p><p>Your email content here...</p>"
   */
  emailContent?: string;
  /**
   * The date and time to schedule the email
   * @format date-time
   */
  scheduledAt: string;
  /**
   * The timezone for the scheduled date and time
   * @example "Europe/Oslo"
   */
  timeZone: string;
  name?: string;
  senderId?: number;
  consentId?: number;
  segmentId?: number;
  smsContent?: string;
  subject?: string;
  emailEditorRawContent?: object;
  templateId?: number;
  emailPreviewText?: string;
  deliveryMethod?: string;
  externalEmailBody?: string;
}

export interface ScheduleCommunicationDto {
  /** @format date-time */
  scheduledAt?: string;
}

export interface TestCommunicateDto {
  /** @maxItems 5 */
  phoneNumbers: string[];
}

export interface PreviewEmailDto {
  /**
   * List of email recipients for the test email
   * @maxItems 5
   * @minItems 1
   * @example ["recipient1@example.com","recipient2@example.com"]
   */
  recipients: string[];
  /** Name of the communication */
  name?: string;
  /**
   * The ID of the sender
   * @min 1
   */
  senderId?: number;
  /**
   * The type of communication
   * @example "marketing"
   */
  communicationType?: 'marketing' | 'information';
  /**
   * The ID of the consent
   * @min 1
   * @example 1
   */
  consentId?: number;
  /**
   * The ID of the segment
   * @min 1
   */
  segmentId?: number;
  /** The subject of the communication */
  subject?: string;
  /** The preview text of the communication */
  emailPreviewText?: string;
  /**
   * The ID of the template
   * @min 1
   * @example 1
   */
  templateId?: number;
  /** The content of the communication */
  emailContent?: string;
}

export interface CommunicationMembersResponseDto {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  status?: string;
  memberNumber: number;
}

export interface CommunicationMembersResponseDtoPaginated {
  items: CommunicationMembersResponseDto[];
  meta: PageMeta;
}

export interface CommunicationStatsResponseDto {
  success: number;
  processed: number;
  failed: number;
  total: number;
}

export interface UploadTemplateImageDto {
  /** @format binary */
  image?: File;
}

export interface TemplateImageUploadResponseDto {
  imageUrl: string;
}

export interface UrlStatDto {
  url: string;
  totalClicks: number;
  uniqueClicks: number;
  shareOfClicks: number;
  shareOfUniqueClicks: number;
}

export interface EmailStatsResponseDto {
  totalProcessed: number;
  totalDelivered: number;
  totalNotDelivered: number;
  totalOpened: number;
  totalUniqueOpened: number;
  totalClicked: number;
  totalUniqueClicked: number;
  totalDeliveredPercentage: number;
  totalNotDeliveredPercentage: number;
  totalOpenedPercentage: number;
  totalClickedPercentage: number;
  totalNotOpened: number;
  urlStats: UrlStatDto[];
}

export interface NewsletterMessageIdResponseDto {
  messageId: string;
}

export interface NewsletterResponseDto {
  htmlContent: string;
}

export interface CreateSegmentDto {
  name: string;
  description?: string;
  status: 'draft' | 'published';
  query?: JsonQuery;
  type: 'static' | 'dynamic';
}

export interface SegmentResponse {
  id: number;
  name: string;
  description: string;
  query: JsonQuery;
  type: string;
  tenantId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: 'draft' | 'published';
  adminUserName: string;
  adminUserEmail: string;
  adminUserId: number;
}

export interface SegmentResponsePaginated {
  items: SegmentResponse[];
  meta: PageMeta;
}

export interface SegmentMemberResponse {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  memberNumber: number;
}

export interface SegmentMemberResponsePaginated {
  items: SegmentMemberResponse[];
  meta: PageMeta;
}

export interface MemberPaginated {
  items: Member[];
  meta: PageMeta;
}

export interface PublishableKeyResponse {
  publishableKey: string;
}

export interface CheckoutUser {
  email: string;
  fullName: string;
  phone?: string;
  countryCode?: 'NO' | 'SE' | 'DK' | 'FI' | 'FO' | 'GB';
  isCompany?: boolean;
  companyName?: string;
  organizationNo?: string;
  reference?: string;
  onCheckoutCompletedUrl?: string;
}

export interface CreateIntentDto {
  packageId: number;
  isSaved: boolean;
  optionalProducts?: OptionalProductWithQuantity[];
  userData: CheckoutUser;
  billingAddress?: BillingAddress;
}

export interface StripeCreateIntentResponse {
  clientSecret: string;
  checkoutStateUuid?: string;
}

export interface CreateIntentFromOrderDto {
  orderId: number;
  phone?: string;
}

export interface CreateSetupIntentDto {
  subscriptionId: number;
}

export interface WebhookResponse {
  checkoutStateUuid: string;
  status: 'pending' | 'succeeded' | 'failed';
}

export interface FakturaPaymentResponseDto {
  checkoutStateUuid: string;
  memberPackage: MemberPackage;
}

export interface CreatePaymentDto {
  /** @format date-time */
  paymentDate: string;
  amount: number;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  note: string;
  invoiceNumber?: number;
  memberPackageId?: number;
  memberId: string;
}

export interface UpdatePaymentDateDto {
  paymentId: number;
  /** @format date-time */
  paymentDate: string;
}

export interface CreateRefundDto {
  invoiceNumber?: number;
  amount: number;
  /** @format date-time */
  refundedAt: string;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
  note: string;
  memberId: string;
}

export interface RestartSubscriptionDto {
  subscriptionId: number;
  /** @format date-time */
  paymentDate?: string;
}

export interface SubscriptionAutoRenewWithPaymentDto {
  subscriptionId: number;
  /** @format date-time */
  paymentDate?: string;
}

export interface VippsCreateIntentResponse {
  vippsConfirmationUrl: string;
  id: string;
  checkoutStateUuid?: string;
}

export enum CHECKOUT_STATE_STATUS {
  Created = 'created',
  PaymentCompleted = 'payment_completed',
  PaymentFailed = 'payment_failed',
  MemberInfo = 'member_info',
  AdditionalMemberInfo = 'additional_member_info',
  PhysicalProductInfo = 'physical_product_info',
  GiftReceiverInfo = 'gift_receiver_info',
  GiftReceiverDeliveryInfo = 'gift_receiver_delivery_info',
  ConsentInfo = 'consent_info',
  Completed = 'completed',
  NotSet = 'not_set',
  Pending = 'pending',
}

export interface CheckoutStateResponse {
  uuid: string;
  status: CHECKOUT_STATE_STATUS;
  paymentData: object;
  memberData: MemberPersonalInfo;
  additionalMemberData: ProductAdditionalMemberData[];
  physicalProductData: CheckoutStatePhysicalProductData;
  giftReceiverData: ProductGiftReceiverData[];
  giftReceiverDeliveryData: CheckoutStateGiftReceiverDeliveryData;
  steps: CHECKOUT_STATE_STATUS[];
  orderNumber: number;
}

export interface AccountCheckDto {
  /** @format email */
  email: string;
  data: CreateIntentDto;
}

export enum AccountCheckStatus {
  NEW_MEMBER = 'NEW_MEMBER',
  EXISTING_MEMBER = 'EXISTING_MEMBER',
}

export interface AccountCheckResponse {
  status: AccountCheckStatus;
  checkoutStateUUID: string;
}

export interface CompleteGiftReceiverDto {
  /** @format date-time */
  scheduledActivationDate?: string;
}

export interface CheckoutStatePhysicalProduct {
  memberId: string;
  memberPackageProductId: number;
  productName: string;
  shippingCountry: string;
  address: ProfileAddress;
}

export interface SaveDeliveryAddressDto {
  physicalProducts: CheckoutStatePhysicalProduct[];
}

export interface NetsCreateIntentResponse {
  hostedPaymentPageUrl: string;
  checkoutStateUuid?: string;
  id: string;
}

export interface NetsUpdateCardResponse {
  hostedPaymentPageUrl: string;
}

export interface NetsCreateSubscriptionResponse {
  hostedPaymentPageUrl: string;
}

export interface UpdatePaymentProviderConfigDto {
  config: object;
  paymentProvider: 'stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf';
}

export interface InvoiceInfo {
  fullName: string;
  address: string;
  city: string;
  postCode: string;
  organizationNo: string;
  companyName: string;
  country: string;
}

export interface ChangePaymentProviderAsExternalReqDto {
  memberPackageId: number;
  invoiceInfo: InvoiceInfo;
}

export interface PaymentProviderResponse {
  name: string;
  showOnMyPage: boolean;
  showOnAdmin: boolean;
}

export interface StripeConfig {
  secretKey: string;
  publishableKey: string;
  webhookSecret?: string;
}

export interface VippsConfig {
  clientId: string;
  clientSecret: string;
  ocpApimSubscriptionKey: string;
  merchantSerialNumber: string;
  webhookSecret?: string;
}

export interface NetsConfig {
  secretKey: string;
  webhookSecret?: string;
  termsUrl: string;
}

export interface OrbytConfig {
  clientId: string;
  clientSecret: string;
  webhookSecret?: string;
}

export interface PaymentProviderSettingsResponse {
  id: number;
  name: PAYMENT_PROVIDER;
  showOnMyPage: boolean;
  showOnAdmin: boolean;
  config: StripeConfig | VippsConfig | NetsConfig | OrbytConfig;
  webhookEvents: string[];
  allowedDaysAfterExpiry?: number;
  eInvoicePaymentPreference?: EInvoicePaymentPreference;
}

export interface PaymentProviderSettingsDto {
  id?: number;
  name?: PAYMENT_PROVIDER;
  showOnMyPage?: boolean;
  showOnAdmin?: boolean;
  config?: StripeConfig | VippsConfig | NetsConfig | OrbytConfig;
  webhookEvents?: string[];
  allowedDaysAfterExpiry?: number;
}

export interface EInvoiceUsageMonthlyDto {
  sent_via_einvoice: number;
  sent_via_email: number;
  sent_manually: number;
  total_sent: number;
  month: string;
}

export interface EInvoiceUsageTotalDto {
  sent_via_einvoice: number;
  sent_via_email: number;
  sent_manually: number;
  total_sent: number;
}

export interface EInvoiceUsageResponseDto {
  monthly: EInvoiceUsageMonthlyDto[];
  total: EInvoiceUsageTotalDto;
}

export interface InvoiceResponsePaginated {
  items: InvoiceResponse[];
  meta: PageMeta;
}

export enum ComparisonOperator {
  EQUALS = 'EQUALS',
  BETWEEN = 'BETWEEN',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
}

export interface AmountFilter {
  operator: ComparisonOperator;
  amount: number;
  secondAmount?: number;
}

export interface InvoiceFilter {
  invoiceStatus?: INVOICE_STATUS[];
  invoiceNumber?: number;
  memberEmail?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  amountFilter?: AmountFilter;
  deliveryStatus?: INVOICE_DELIVERY_STATUS[];
  types?: TransactionResponseType[];
  memberPackageStatus?: MEMBER_PACKAGE_STATUS[];
}

export interface CreditNoteOrderItem {
  productId?: number;
  quantity: number;
  amount: number;
  orderItemId?: number;
}

export interface CreateCreditNoteDto {
  memberId: string;
  referenceInvoiceNumber?: number;
  orderLines?: CreditNoteOrderItem[];
  note?: string;
  creditFullAmount?: boolean;
  /** @format date-time */
  date: string;
}

export interface InvoiceBatchOperationDto {
  invoiceNumbers?: number[];
  filter?: InvoiceFilter;
  selectAll?: boolean;
  invoiceNumbersToUpdate?: number[];
}

export interface UpdateInvoiceDueDateDto {
  /** @format date-time */
  dueDate: string;
}

export interface ValidatedBatchInvoiceOperationResponse {
  validInvoiceNumbers: string[];
  invalidInvoiceNumbers: string[];
}

export interface CreateInvoiceForOverPaymentDto {
  orderLines: CreditNoteOrderItem[];
  referenceInvoiceNumber: number;
  /** @format date-time */
  periodStartDate: string;
  /** @format date-time */
  periodEndDate: string;
  amount: number;
  note?: string;
}

export enum TRANSACTION_RESPONSE_STATUS {
  Open = 'open',
  Matched = 'matched',
  Ignored = 'ignored',
}

export interface TransactionResponse {
  transactionGroupId?: number;
  transactionId: number;
  memberId: string;
  memberEmail: string;
  type: TransactionResponseType;
  /** @format date-time */
  registrationDate: string;
  /** @format date-time */
  accountingDate: string;
  invoiceNumber?: number;
  invoiceStatus: INVOICE_STATUS;
  reference: string;
  amount: number;
  status: TRANSACTION_RESPONSE_STATUS;
  memberPackageId: number;
  memberNumber: number;
}

export interface TransactionResponsePaginated {
  items: TransactionResponse[];
  meta: PageMeta;
}

export interface TransactionFilter {
  status?: 'open' | 'matched' | 'ignored';
  types?: TransactionResponseType[];
  invoiceStatus?: INVOICE_STATUS[];
  invoiceNumber?: number;
  reference?: string;
  memberEmail?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  amountFilter?: AmountFilter;
}

export enum TRANSACTION_GROUP_ACTION {
  Match = 'match',
  Open = 'open',
}

export interface UpdateTransactionGroupStatusDto {
  transactionIds: number[];
  /** @default "match" */
  action: TRANSACTION_GROUP_ACTION;
}

export interface TransactionWithAmount {
  transactionId: number;
  amount: number;
  type: TransactionResponseType;
}

export interface MatchSummary {
  transactions: TransactionWithAmount[];
  roundingAdjustmentAmount?: number;
  transactionGroupId?: number;
}

export enum TRANSACTION_STATUS {
  Ignored = 'ignored',
}

export interface UpdateTransactionStatusDto {
  status?: TRANSACTION_STATUS | null;
}

export enum FilteredActivityLogAction {
  InitialPurchase = 'initial_purchase',
  SubscriptionRenewed = 'subscription_renewed',
  AutoRenewalTurnedOff = 'auto_renewal_turned_off',
  AutoRenewalTurnedOn = 'auto_renewal_turned_on',
  SubscriptionExpired = 'subscription_expired',
  PaymentFailed = 'payment_failed',
  SubscriptionDeactivated = 'subscription_deactivated',
  SubscriptionReactivated = 'subscription_reactivated',
  SubscriptionStopped = 'subscription_stopped',
  NextRenewalUpdated = 'next_renewal_updated',
  RecurringPriceUpdated = 'recurring_price_updated',
  ActivationDateUpdated = 'activation_date_updated',
  SubscriptionActivated = 'subscription_activated',
  SubscriptionCanceledBeforeActivation = 'subscription_canceled_before_activation',
  UpdateMemberProfile = 'update_member_profile',
  UpdateConsent = 'update_consent',
  Login = 'login',
  ChangeInitiated = 'change_initiated',
  ChangeCompleted = 'change_completed',
  ChangeCancelled = 'change_cancelled',
  SeatInvitationSent = 'seat_invitation_sent',
  SeatInvitationRemoved = 'seat_invitation_removed',
  SeatInvitationAccepted = 'seat_invitation_accepted',
  SeatMemberAdded = 'seat_member_added',
  SeatGiftReceiverAdded = 'seat_gift_receiver_added',
  SeatGiftReceiverRemoved = 'seat_gift_receiver_removed',
  SeatGiftReceiverAccepted = 'seat_gift_receiver_accepted',
  SeatGiftReceiverInvitationSent = 'seat_gift_receiver_invitation_sent',
  InvoiceSent = 'invoice_sent',
  PaymentMethodUpdated = 'payment_method_updated',
  PaymentProviderUpdated = 'payment_provider_updated',
  InvoiceAddressUpdated = 'invoice_address_updated',
  DeliveryAddressUpdated = 'delivery_address_updated',
  CreditNoteCreated = 'credit_note_created',
  RefundRegistered = 'refund_registered',
  PaymentRegistered = 'payment_registered',
  VippsRecurringChargeInitiated = 'vipps_recurring_charge_initiated',
  Signup = 'signup',
}

export interface EventTypeWithTokens {
  id: number;
  emitterName: string;
  personalisedToken: string[];
}

export interface EventTypeDto {
  eventTypeId: number;
  name: string;
  description: string;
  emitterName: string;
  personalisedToken: string[];
}

export interface ExternalEmailDto {
  id: number;
  /**
   * @minLength 2
   * @maxLength 40
   */
  name: string;
  /**
   * @minLength 3
   * @maxLength 180
   */
  subject: string;
  content: string;
  emailTemplateId: number;
  senderId: number;
  conditions: object[];
}

export interface InternalEmailDto {
  id: number;
  /**
   * @minLength 2
   * @maxLength 40
   */
  name: string;
  /**
   * @minLength 3
   * @maxLength 180
   */
  subject: string;
  content: string;
  internalReceivers: string[];
}

export interface SegmentDto {
  externalEmails: ExternalEmailDto[];
  internalEmails: InternalEmailDto[];
  eventTypeId: number;
}

export interface WorkflowDto {
  /**
   * @minLength 5
   * @maxLength 150
   */
  name: string;
  isPublished: boolean;
  actionTypeId: number;
  segments: SegmentDto[];
}

export interface CommunicationTemplateDto {
  name: string;
  templateType:
    | 'automation'
    | 'crm'
    | 'marketing'
    | 'otp'
    | 'information'
    | 'emailStandard'
    | 'jobCompletion'
    | 'oneOff';
  communicationChannel: 'sms' | 'email';
  locale: 'en' | 'no';
  template: string;
}

export interface CommunicationSenderCreateDto {
  /** The name of the sender */
  senderName?: string;
  /** The email of the sender */
  senderEmail?: string;
  /** The reply to email of the sender */
  replyTo?: string;
  /** The communication channel of the sender */
  communicationChannel: COMMUNICATION_CHANNEL;
}

export interface CommunicationSenderUpdateDto {
  /** The name of the sender */
  senderName?: string;
  /** The email of the sender */
  senderEmail?: string;
  /** The reply to email of the sender */
  replyTo?: string;
  /** The communication channel of the sender */
  communicationChannel: COMMUNICATION_CHANNEL;
}

export interface StatsDTO {
  totalActiveSubcriptions: number;
  totalActivePaidSubcriptions: number;
  totalActiveMembers: number;
  totalActivePaidMembers: number;
  totalRegisteredMembers: number;
  totalLoginYesterday: number;
  totalWaitingForActivationSubscriptions: number;
}

export interface StatsForNthDaysDTO {
  totalNewPaidSubscriptions: number;
  totalPaidRenewals: number;
  totalCanceledPaidSubscriptions: number;
  totalStoppedPaidSubscriptions: number;
  totalReactivatedSubscriptions: number;
}

export interface ReferrerStatsDto {
  referrer: string;
  count: number;
  /** @format date-time */
  lastPurchasedAt: string;
}

export interface ReferrerStatsDtoPaginated {
  items: ReferrerStatsDto[];
  meta: PageMeta;
}

export interface StatsTenantIdsDTO {
  /** @default [] */
  tenantIds?: number[];
}

export interface StatsCronDTO {
  /** @default [] */
  tenantIds?: number[];
  /**
   * @format date-time
   * @example "yyyy-MM-dd"
   */
  dataDate?: string;
}

export enum DataSelectionPeriod {
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export enum SubscriptionType {
  All = 'all',
  Free = 'free',
  Paid = 'paid',
}

export enum GroupByType {
  SubscriptionPlan = 'subscriptionPlan',
  Package = 'package',
  PaymentProvider = 'paymentProvider',
}

export enum NoOfLine {
  Value3 = '3',
  Value5 = '5',
  Value7 = '7',
  Value100 = '100',
}

export interface StatsGraphData {
  id: number;
  name: string;
  count: number;
  additionalData?: number;
}

export interface HistoricalStatsData {
  label: number;
  entities: StatsGraphData[];
  year: number;
}

export interface HistoricalStatsResDto {
  data: HistoricalStatsData[];
  period: DataSelectionPeriod;
}

export enum ProductType {
  All = 'all',
  Free = 'free',
  Paid = 'paid',
}

export enum MemberType {
  All = 'all',
  Paid = 'paid',
}

export enum RevenueEstimationOption {
  Mrr = 'mrr',
  Arr = 'arr',
}

export enum RevenueType {
  SubscriptionPlan = 'subscriptionPlan',
  ProductPackage = 'productPackage',
}

export enum RevenuePeriod {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum ChurnType {
  Gross = 'gross',
  Net = 'net',
}

export interface HistoricalChurnRateResDto {
  detailsChurn: HistoricalStatsResDto;
  totalChurn: HistoricalStatsResDto;
}

export enum CUSTOM_PROPERTY_ENTITY {
  Member = 'Member',
  MemberPackageProduct = 'MemberPackageProduct',
  MemberPackage = 'MemberPackage',
  Order = 'Order',
  OrderItem = 'OrderItem',
  CustomOrder = 'CustomOrder',
  CustomOrderItem = 'CustomOrderItem',
}

export enum CUSTOM_PROPERTY_DATA_TYPE {
  String = 'string',
  Numeric = 'numeric',
  Boolean = 'boolean',
  Date = 'date',
  Text = 'text',
}

export enum CUSTOM_PROPERTY_FIELD_TYPE {
  Text = 'text',
  Date = 'date',
  Radio = 'radio',
  Checkbox = 'checkbox',
  Select = 'select',
  Sequence = 'sequence',
}

export interface CreateCustomPropertyDto {
  name: string;
  displayName: string;
  entity: CUSTOM_PROPERTY_ENTITY;
  dataType: CUSTOM_PROPERTY_DATA_TYPE;
  fieldType: CUSTOM_PROPERTY_FIELD_TYPE;
  description: string;
  settings?: CustomPropertySettings;
  permissions?: CustomPropertyPermissions;
}

export interface CustomPropertyResponse {
  name: string;
  displayName: string;
  entity:
    | 'Member'
    | 'MemberPackageProduct'
    | 'MemberPackage'
    | 'Order'
    | 'OrderItem'
    | 'CustomOrder'
    | 'CustomOrderItem';
  dataType: 'string' | 'numeric' | 'boolean' | 'date' | 'text';
  fieldType: 'text' | 'date' | 'radio' | 'checkbox' | 'select' | 'sequence';
  description: string;
  settings: CustomPropertySettings;
  permissions: CustomPropertyPermissions;
  order: number;
  tenantId: number;
  createdBy: number;
  updatedBy: number;
  tenant: Tenant;
  eventTypeMappings: EventTypeCustomProperty[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface CustomPropertyResponsePaginated {
  items: CustomPropertyResponse[];
  meta: PageMeta;
}

export interface CustomPropertyViewResponse {
  permissions: CustomPropertyPermissions;
  helpText?: Translation;
  name: string;
  displayName: string;
  fieldType: 'text' | 'date' | 'radio' | 'checkbox' | 'select' | 'sequence';
  dataType: 'string' | 'numeric' | 'boolean' | 'date' | 'text';
  order: number;
  isRequired: boolean;
  options?: CustomPropertyOption[];
}

export interface UpdateCustomPropertyDto {
  displayName?: string;
  entity?: CUSTOM_PROPERTY_ENTITY;
  dataType?: CUSTOM_PROPERTY_DATA_TYPE;
  fieldType?: CUSTOM_PROPERTY_FIELD_TYPE;
  description?: string;
  settings?: CustomPropertySettings;
  permissions?: CustomPropertyPermissions;
}

export interface CreateCustomOrderSourceDto {
  name: string;
}

export interface CustomOrderSourceResponse {
  id: string;
  name: string;
  tenantId: number;
}

export interface UpdateCustomOrderSourceDto {
  name: string;
}

export interface CreateCustomOrderItemDto {
  productId: string;
  productName: string;
  categoryId: string;
  categoryName: string;
  quantity: number;
  price: number;
  priceVat: number;
  customPropertyValues?: object;
}

export interface CreateCustomOrderDto {
  /** @format uuid */
  sourceId: string;
  sourceRef: string;
  memberId: string;
  totalPrice: number;
  totalPriceVat: number;
  currency: string;
  items: CreateCustomOrderItemDto[];
  customPropertyValues?: object;
}

export interface ConsentResponseDto {
  integrationId: string;
  title: string;
  description: string;
  image: string;
  showOnCheckoutPage: boolean;
  showOnMyPage: boolean;
  status: boolean;
  purpose: 'marketing_and_newsletter' | 'consent';
  frequency: string;
  defaultSubscribed: boolean;
  newsletterProviderConfig: NewsletterProviderConfig;
  newsletterProviderConfigId: number;
  tenant: Tenant;
  communications: Communication[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface ConsentDto {
  imagePreview?: string;
  previousImageUrl?: string;
  /** @format binary */
  image?: File;
  purpose: 'marketing_and_newsletter' | 'consent';
  /** @maxLength 100 */
  title: string;
  /** @maxLength 255 */
  description: string;
  status: boolean;
  frequency: string;
  showOnCheckoutPage: boolean;
  showOnMyPage: boolean;
  defaultSubscribed: boolean;
  externalProvider?: ExternalProviderNewsLetterDto;
}

export interface UnsubscribeTokenDto {
  token: string;
}

export interface UpdateConsentDto {
  imagePreview?: string;
  previousImageUrl?: string;
  /** @format binary */
  image?: File;
  removeExternalProvider?: boolean;
  purpose?: 'marketing_and_newsletter' | 'consent';
  /** @maxLength 100 */
  title?: string;
  /** @maxLength 255 */
  description?: string;
  status?: boolean;
  frequency?: string;
  showOnCheckoutPage?: boolean;
  showOnMyPage?: boolean;
  defaultSubscribed?: boolean;
  externalProvider?: ExternalProviderNewsLetterDto;
}

export interface ConsentRequestDto {
  /** @format email */
  email: string;
  status: 'accepted' | 'withdrawn' | 'subscribed' | 'unsubscribed';
}

export interface ExportHistoryResponse {
  fileLink: string;
  fileName: string;
  status: 'started' | 'completed' | 'failed' | 'queued';
  exportType:
    | 'subscriptions'
    | 'subscription_products'
    | 'subscription_users'
    | 'payments'
    | 'invoices'
    | 'all_members'
    | 'segments'
    | 'ledger';
  systemGenerated: boolean;
  adminUserId: number;
  tenantId: number;
  adminUser: User;
  tenant: Tenant;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
  createdBy: string;
  refreshStatus: boolean;
}

export interface ExportHistoryResponsePaginated {
  items: ExportHistoryResponse[];
  meta: PageMeta;
}

export enum PaymentAndRefundType {
  Payment = 'payment',
  Refund = 'refund',
  RoundingAdjustment = 'rounding_adjustment',
}

export enum InvoiceType {
  Invoice = 'invoice',
  CreditNote = 'creditNote',
}

export interface SegmentExportDto {
  segmentId: number;
  fileName: string;
}

export interface LedgerExportFilterDto {
  status?: 'open' | 'matched' | 'ignored';
  types?: TransactionResponseType[];
  invoiceStatus?: INVOICE_STATUS[];
  invoiceNumber?: number;
  reference?: string;
  memberEmail?: string;
  /** @format date-time */
  dateFrom?: string;
  /** @format date-time */
  dateTo?: string;
  amountFilter?: AmountFilter;
  /** @format date-time */
  createdAt?: string;
}

export interface ProviderCredentials {
  type: string;
  project_id: string;
  private_key_id: string;
  private_key: string;
  client_email: string;
  client_id: string;
  auth_uri: string;
  token_uri: string;
  auth_provider_x509_cert_url: string;
  client_x509_cert_url: string;
  universe_domain: string;
}

export interface PushDataAttributeSchema {
  name: string;
  label: Translation;
  type: string;
  required: boolean;
}

export interface PushTopic {
  slug: string;
  label: Translation;
}

export interface PushSetupResponseDto {
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  provider: 'fcm';
  providerCredentials: ProviderCredentials;
  tenantId: number;
  dataAttributes: PushDataAttributeSchema[];
  topics: PushTopic[];
}

export interface CreateFCMPushSetupRequestDto {
  providerCredentials: string;
  dataAttributes: PushDataAttributeSchema[];
  topics: PushTopic[];
}

export interface UpdateFCMPushSetupRequestDto {
  providerCredentials: string;
  dataAttributes: PushDataAttributeSchema[];
  topics: PushTopic[];
}

export interface SubscribeToPushRequestDto {
  token: string;
  provider: 'fcm';
  /** @minItems 0 */
  topics: string[];
}

export interface PushSubscriber {
  token: string;
  provider: 'fcm';
  tenant: Tenant;
  tenantId: number;
  memberId: string;
  member: Member;
  topics: string[];
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface LinkSubscriberToMemberRequestDto {
  token: string;
  provider: 'fcm';
}

export interface TrackOpenMessageRequestDto {
  itemKey: string;
}

export interface UnsubscribeFromPushRequestDto {
  token: string;
  provider: 'fcm';
}

export interface PushContentRequestDto {
  title: string;
  body: string;
  topic?: string;
  topics?: string[];
}

export interface PushContent {
  title: string;
  body: string;
  data: object;
  tenantId: number;
  segmentId: number;
  status: 'draft' | 'scheduled' | 'created' | 'queuing' | 'queued' | 'failed' | 'skipped';
  /** @format date-time */
  scheduledAt: string;
  topics: string[];
  tenant: Tenant;
  segment: Segment;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  metaData: object;
}

export interface PushCampaignResponseDto {
  /**
   * The data to be sent with the push notification
   * @example {"key":"value"}
   */
  data: object;
  id: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  title: string;
  body: string;
  tenantId: number;
  status: 'draft' | 'scheduled' | 'created' | 'queuing' | 'queued' | 'failed' | 'skipped';
  topics: string[];
  segmentId: number;
  /** @format date-time */
  scheduledAt: string;
}

export interface PushCampaignResponseDtoPaginated {
  items: PushCampaignResponseDto[];
  meta: PageMeta;
}

export interface CreatePushCampaignDto {
  /**
   * The title of the push notification
   * @example "This is the title of the push notification"
   */
  title: string;
  /**
   * The body of the push notification
   * @example "This is the body of the push notification"
   */
  body: string;
  /**
   * The data to be sent with the push notification
   * @example {"key":"value"}
   */
  data: object;
  /**
   * The topics to send the push campaign to
   * @example ["topic1","topic2"]
   */
  topics?: string[];
  /**
   * The ID of the segment to send the push campaign to
   * @example 1
   */
  segmentId?: number;
}

export interface PushCampaignDraftUpdateDto {
  /**
   * The title of the push notification
   * @example "This is the title of the push notification"
   */
  title?: string;
  /**
   * The body of the push notification
   * @example "This is the body of the push notification"
   */
  body?: string;
  /**
   * The data to be sent with the push notification
   * @example {"key":"value"}
   */
  data: object;
  /**
   * The topics to send the push campaign to
   * @example ["topic1","topic2"]
   */
  topics?: string[] | null;
  /**
   * The ID of the segment to send the push campaign to
   * @example 1
   */
  segmentId?: number | null;
}

export interface SchedulePushCampaignDto {
  /**
   * The title of the push notification
   * @example "This is the title of the push notification"
   */
  title?: string;
  /**
   * The body of the push notification
   * @example "This is the body of the push notification"
   */
  body?: string;
  /**
   * The data to be sent with the push notification
   * @example {"key":"value"}
   */
  data: object;
  /**
   * The topics to send the push campaign to
   * @example ["topic1","topic2"]
   */
  topics?: string[] | null;
  /**
   * The ID of the segment to send the push campaign to
   * @example 1
   */
  segmentId?: number | null;
  /** @format date-time */
  scheduledAt: string;
}

export interface PushSubscriberResponseDto {
  /**
   * The ID of the push subscriber
   * @example 1
   */
  id: number;
  /**
   * The created at of the push subscriber
   * @format date-time
   * @example "2025-07-04T06:38:33.809Z"
   */
  createdAt: string;
  /**
   * The updated at of the push subscriber
   * @format date-time
   * @example "2025-07-04T06:38:33.809Z"
   */
  updatedAt: string;
  /**
   * The meta data of the push subscriber
   * @example {}
   */
  metaData: object;
  /**
   * The provider of the push subscriber
   * @example "fcm"
   */
  provider: 'fcm';
  /**
   * The member id of the push subscriber
   * @example "3879d563-8f6c-4a8c-a7a1-1cd94d0a64e5"
   */
  memberId: string;
  /**
   * The topics of the push subscriber
   * @example ["topic1","topic2"]
   */
  topics: string[];
  /**
   * The first name of the member
   * @example "John"
   */
  fullName: string | null;
  /**
   * The email of the member
   * @example "john.doe@example.com"
   */
  email: string | null;
  status: 'queued' | 'dispatching' | 'dispatched' | 'failed' | null;
  /** @format date-time */
  sentAt: string | null;
  /** @format date-time */
  openedAt: string | null;
}

export interface PushSubscriberResponseDtoPaginated {
  items: PushSubscriberResponseDto[];
  meta: PageMeta;
}

export interface SendTestPushResponse {
  success: boolean;
  error?: object;
  invalidToken?: boolean;
}

export interface PushStats {
  total: number;
  sending: number;
  sent: number;
  failed: number;
  opened: number;
}

export interface ImportHistoryResponse {
  id: number;
  /** @format date-time */
  createdAt: string;
  createdBy: string;
  adminUserId: number;
  type: 'update_members' | 'ocr' | 'external_payment' | 'subscriptions';
  fileName: string;
}

export interface ImportHistoryResponsePaginated {
  items: ImportHistoryResponse[];
  meta: PageMeta;
}

export interface BatchUpdateRequest {
  identifier: string;
  /** @format binary */
  file: File;
}

export interface FailedUpdates {
  identifier: object;
  fieldName?: string;
  errorMessage: string;
  detail?: string;
  errorType?: string;
}

export interface ImportSummary {
  /** @default 0 */
  successCount: number;
  /** @default 0 */
  failureCount: number;
  /** @default [] */
  failedUpdates: FailedUpdates[];
}

export interface OnlyFileUploadDto {
  /** @format binary */
  file?: File;
}

export interface ImportMemberFieldsResponse {
  availableFields: string[];
  availableIdentifiers: string[];
  notUpdatableFields: string[];
  consentKeys: ConsentResponseDto[];
}

export interface SubscriptionImportValidationResponseDto {
  /**
   * List of existing emails found in the system
   * @example ["john@example.com","jane@example.com"]
   */
  existingMembers: string[];
}

export interface TriggerCronDto {
  jobName:
    | 'expire-subscription'
    | 'schedule-activate-subscription'
    | 'deactivate-external-subscriptions'
    | 'execute-scheduled-communications'
    | 'handle-workflow-events'
    | 'refresh-spotify-entitlements'
    | 'enqueue-recurring-invoice-subscriptions'
    | 'renew-e-invoice-subscriptions'
    | 'update-in-progress-e-invoice-status'
    | 'queue-nets-recurring-payments'
    | 'queue-stripe-recurring-payments'
    | 'queue-vipps-recurring-payments'
    | 'pause-due-subscriptions'
    | 'queue-update-due-charges'
    | 'fetch-and-store-podcast-feeds'
    | 'check-queue-health'
    | 'update-over-due-invoices'
    | 'process-dispatch-queue'
    | 'cleanup-invited-members-not-accepted-expired'
    | 'check-push-queue'
    | 'import-ocr-files'
    | 'enqueue-cleanup-invited-members-not-accepted-expired'
    | 'cleanup-old-webhook-event-logs'
    | 'cleanup-old-s3-files'
    | 'cleanup-old-request-logs'
    | 'subscription-summary'
    | 'product-summary'
    | 'member-summary'
    | 'subscription-activity-summary'
    | 'recurring-revenue-summary';
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      return data;
    });
  };
}

/**
 * @title Subrite API
 * @version 1.0
 * @contact
 *
 * API Documentation for Subrite
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Authentication
     * @name AuthControllerGetProfileV1
     * @summary Get logged in user details with role and permissions.
     * @request GET:/api/v1/auth/profile
     * @secure
     */
    authControllerGetProfileV1: (params: RequestParams = {}) =>
      this.request<UserResponse, void>({
        path: `/api/v1/auth/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name AuthControllerUpdateProfileV1
     * @summary Update logged in user profile
     * @request PATCH:/api/v1/auth/profile
     * @secure
     */
    authControllerUpdateProfileV1: (data: UpdateProfileDto, params: RequestParams = {}) =>
      this.request<UserResponse, void>({
        path: `/api/v1/auth/profile`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserControllerCreateV1
     * @summary Create a new user
     * @request POST:/api/v1/users
     * @secure
     */
    userControllerCreateV1: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserResponse, ErrorResponse | void>({
        path: `/api/v1/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserControllerFindAllV1
     * @summary Get all users of the tenant
     * @request GET:/api/v1/users
     * @secure
     */
    userControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<UserResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserControllerFindOneV1
     * @summary Get user by id
     * @request GET:/api/v1/users/{id}
     * @secure
     */
    userControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<UserResponse, void | ErrorResponse>({
        path: `/api/v1/users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserControllerUpdateV1
     * @summary Update user
     * @request PATCH:/api/v1/users/{id}
     * @secure
     */
    userControllerUpdateV1: (id: string, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserResponse, void | ErrorResponse>({
        path: `/api/v1/users/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserControllerRemoveV1
     * @summary Delete user
     * @request DELETE:/api/v1/users/{id}
     * @secure
     */
    userControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/users/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerCreateV1
     * @summary Create a new role
     * @request POST:/api/v1/roles
     * @secure
     */
    roleControllerCreateV1: (data: CreateRoleDto, params: RequestParams = {}) =>
      this.request<RoleResponse, ErrorResponse | void>({
        path: `/api/v1/roles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerFindAllV1
     * @summary Get all roles of the tenant
     * @request GET:/api/v1/roles
     * @secure
     */
    roleControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<RolePaginated, void | ErrorResponse>({
        path: `/api/v1/roles`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerGetSectionsV1
     * @summary Get all sections with permissions
     * @request GET:/api/v1/roles/sections
     * @secure
     */
    roleControllerGetSectionsV1: (params: RequestParams = {}) =>
      this.request<SectionPermission[], void | ErrorResponse>({
        path: `/api/v1/roles/sections`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerFindOneV1
     * @summary Get a role by id with its section permissions
     * @request GET:/api/v1/roles/{id}
     * @secure
     */
    roleControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<RoleResponse, void | ErrorResponse>({
        path: `/api/v1/roles/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerUpdateV1
     * @summary Update a role
     * @request PATCH:/api/v1/roles/{id}
     * @secure
     */
    roleControllerUpdateV1: (id: string, data: UpdateRoleDto, params: RequestParams = {}) =>
      this.request<RoleResponse, ErrorResponse | void>({
        path: `/api/v1/roles/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Role Permission
     * @name RoleControllerRemoveV1
     * @summary Delete role
     * @request DELETE:/api/v1/roles/{id}
     * @secure
     */
    roleControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/roles/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerFindAllMypageCardsSettingsV1
     * @summary Get mypage cards settings of a tenant
     * @request GET:/api/v1/members/profile/mypage-cards-settings
     * @secure
     */
    profileControllerFindAllMypageCardsSettingsV1: (
      query?: {
        showOnMyPage?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MypageCardsSettingsResponseDto[], ErrorResponse>({
        path: `/api/v1/members/profile/mypage-cards-settings`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetAvailableSubscriptionsByEmailDomainV1
     * @summary Get subscriptions available to join based on email domain
     * @request GET:/api/v1/members/profile/available-subscriptions-to-join
     * @secure
     */
    profileControllerGetAvailableSubscriptionsByEmailDomainV1: (params: RequestParams = {}) =>
      this.request<MemberPackageProduct[], ErrorResponse>({
        path: `/api/v1/members/profile/available-subscriptions-to-join`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerJoinAvailableSubscriptionsV1
     * @summary Join selected available subscriptions (create product seats)
     * @request POST:/api/v1/members/profile/join-subscriptions
     * @secure
     */
    profileControllerJoinAvailableSubscriptionsV1: (
      data: JoinSubscriptionsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPackageProductSeat[], ErrorResponse>({
        path: `/api/v1/members/profile/join-subscriptions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetProfileV1
     * @summary Get logged in member personal info
     * @request GET:/api/v1/members/profile
     * @secure
     */
    profileControllerGetProfileV1: (params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateProfileV1
     * @summary Update logged in member profile
     * @request PATCH:/api/v1/members/profile
     * @secure
     */
    profileControllerUpdateProfileV1: (
      data: UpdateMemberPersonalInfo,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetSubscriptionsV1
     * @summary Get logged in member subscriptions
     * @request GET:/api/v1/members/profile/subscriptions
     * @secure
     */
    profileControllerGetSubscriptionsV1: (
      query?: {
        status?: MemberPackageStatusEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionListItem[], ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetInvoicesV1
     * @summary Get logged in member invoices
     * @request GET:/api/v1/members/profile/invoices
     * @secure
     */
    profileControllerGetInvoicesV1: (params: RequestParams = {}) =>
      this.request<InvoiceResponse[], ErrorResponse>({
        path: `/api/v1/members/profile/invoices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetOrdersV1
     * @summary Get logged in member orders
     * @request GET:/api/v1/members/profile/orders
     * @secure
     */
    profileControllerGetOrdersV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderResponsePaginated, ErrorResponse>({
        path: `/api/v1/members/profile/orders`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberInfoWithContentAccessV1
     * @summary Get logged in member info with content access
     * @request GET:/api/v1/members/profile/info-with-content-access
     * @secure
     */
    profileControllerGetMemberInfoWithContentAccessV1: (params: RequestParams = {}) =>
      this.request<MemberWithSubscriptions, ErrorResponse>({
        path: `/api/v1/members/profile/info-with-content-access`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberInfoV1
     * @summary Get logged in members basic info and active packages
     * @request GET:/api/v1/members/profile/info-with-active-subscriptions
     * @secure
     */
    profileControllerGetMemberInfoV1: (params: RequestParams = {}) =>
      this.request<MemberWithSubscriptions, ErrorResponse>({
        path: `/api/v1/members/profile/info-with-active-subscriptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerSetAvatarV1
     * @summary Set logged in member avatar or profile picture
     * @request POST:/api/v1/members/profile/avatar
     * @secure
     */
    profileControllerSetAvatarV1: (data: UpdateAvatarDto, params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse | void>({
        path: `/api/v1/members/profile/avatar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRequestEmailUpdateV1
     * @summary Request email pre-verification
     * @request POST:/api/v1/members/profile/email/pre-verify
     * @secure
     */
    profileControllerRequestEmailUpdateV1: (
      data: UpdateMemberEmailBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<OTPSendResponseDto, ErrorResponse>({
        path: `/api/v1/members/profile/email/pre-verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateEmailV1
     * @summary Update email
     * @request PATCH:/api/v1/members/profile/email
     * @secure
     */
    profileControllerUpdateEmailV1: (data: UpdateMemberEmailDto, params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile/email`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRequestPhoneUpdateV1
     * @summary Request phone pre-verification
     * @request POST:/api/v1/members/profile/phone/pre-verify
     * @secure
     */
    profileControllerRequestPhoneUpdateV1: (
      data: UpdateMemberPhoneBodyDto,
      params: RequestParams = {},
    ) =>
      this.request<OTPSendResponseDto, ErrorResponse>({
        path: `/api/v1/members/profile/phone/pre-verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdatePhoneV1
     * @summary Update phone
     * @request PATCH:/api/v1/members/profile/phone
     * @secure
     */
    profileControllerUpdatePhoneV1: (data: UpdateMemberPhoneDto, params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile/phone`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRequestAccountDeletionV1
     * @summary Request deletion of a member by its own
     * @request POST:/api/v1/members/profile/request-account-deletion
     * @secure
     */
    profileControllerRequestAccountDeletionV1: (params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile/request-account-deletion`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberSubscriptionV1
     * @summary Get member subscription details
     * @request GET:/api/v1/members/profile/subscriptions/{id}
     * @secure
     */
    profileControllerGetMemberSubscriptionV1: (id: number, params: RequestParams = {}) =>
      this.request<SubscriptionDetails, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetFilteredSubscriptionPlansV1
     * @summary Get subscription plans by filters
     * @request GET:/api/v1/members/profile/subscription-plans/all
     * @secure
     */
    profileControllerGetFilteredSubscriptionPlansV1: (
      query?: {
        status?: string;
        allowSameSubscriptionChange?: boolean;
        allowDifferentSubscriptionSwitch?: boolean;
        showAsOptionOnSubscriptionSwitch?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponse[], ErrorResponse>({
        path: `/api/v1/members/profile/subscription-plans/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetSubscriptionPlansV1
     * @summary Get subscription plan settings details
     * @request GET:/api/v1/members/profile/subscription-plans/{id}
     * @secure
     */
    profileControllerGetSubscriptionPlansV1: (id: string, params: RequestParams = {}) =>
      this.request<SubscriptionPlanResponse, ErrorResponse>({
        path: `/api/v1/members/profile/subscription-plans/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberSubscribedProductV1
     * @summary Get subscribed product details
     * @request GET:/api/v1/members/profile/subscriptions/product/{id}
     * @secure
     */
    profileControllerGetMemberSubscribedProductV1: (id: number, params: RequestParams = {}) =>
      this.request<MemberSubscribedProduct, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerCreateAdditionalMemberV1
     * @summary Create additional member for a product seat
     * @request POST:/api/v1/members/profile/subscriptions/product/{id}/create-member
     * @secure
     */
    profileControllerCreateAdditionalMemberV1: (
      id: number,
      data: CreateAdditionalMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}/create-member`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerCreateGiftReceiverV1
     * @summary Create gift receiver for a product seat
     * @request POST:/api/v1/members/profile/subscriptions/product/{id}/create-gift-receiver
     * @secure
     */
    profileControllerCreateGiftReceiverV1: (
      id: number,
      data: CreateGiftReceiverDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}/create-gift-receiver`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberOrderInvoiceV1
     * @summary Get invoice of a order
     * @request GET:/api/v1/members/profile/invoice/{id}
     * @secure
     */
    profileControllerGetMemberOrderInvoiceV1: (id: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/invoice/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberRefundV1
     * @summary Get a refund note pdf
     * @request GET:/api/v1/members/profile/refund/{id}
     * @secure
     */
    profileControllerGetMemberRefundV1: (id: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/refund/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateSubscriptionAutoRenewalV1
     * @summary Toggle auto renewal of subscription
     * @request PATCH:/api/v1/members/profile/subscriptions/{id}/auto-renewal/{activate}
     * @secure
     */
    profileControllerUpdateSubscriptionAutoRenewalV1: (
      id: number,
      activate: boolean,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/auto-renewal/${activate}`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateSubscriptionActivationDateV1
     * @summary Update member package scheduled activation date
     * @request PATCH:/api/v1/members/profile/subscriptions/{id}/activation-date
     * @secure
     */
    profileControllerUpdateSubscriptionActivationDateV1: (
      id: number,
      data: UpdateMemberPackageDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/activation-date`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMemberProductSeatV1
     * @summary Get product seat details
     * @request GET:/api/v1/members/profile/seats/{id}
     * @secure
     */
    profileControllerGetMemberProductSeatV1: (id: number, params: RequestParams = {}) =>
      this.request<SeatData, ErrorResponse>({
        path: `/api/v1/members/profile/seats/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateMemberProductSeatV1
     * @summary Update product seat details
     * @request PATCH:/api/v1/members/profile/seats/{id}
     * @secure
     */
    profileControllerUpdateMemberProductSeatV1: (
      id: number,
      data: UpdateMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<SeatData, ErrorResponse>({
        path: `/api/v1/members/profile/seats/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRemoveProductSeatInvitationV1
     * @summary Remove invitation to a product seat
     * @request DELETE:/api/v1/members/profile/seats/{id}
     * @secure
     */
    profileControllerRemoveProductSeatInvitationV1: (id: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/seats/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetProductSeatsRecipientAttachedProductsV1
     * @summary Get product seat recipient attached products
     * @request GET:/api/v1/members/profile/seats/{id}/recipient/attached-products
     * @secure
     */
    profileControllerGetProductSeatsRecipientAttachedProductsV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<MemberPackageProductSeatRecipientProductsResponseDto[], ErrorResponse>({
        path: `/api/v1/members/profile/seats/${id}/recipient/attached-products`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerInviteToProductSeatV1
     * @summary Invite member to a product seat
     * @request POST:/api/v1/members/profile/seats/invite
     * @secure
     */
    profileControllerInviteToProductSeatV1: (data: InviteSeatDto, params: RequestParams = {}) =>
      this.request<MemberPackageProductSeat, void | ErrorResponse>({
        path: `/api/v1/members/profile/seats/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerAcceptProductSeatInvitationV1
     * @summary Accept invitation to a product seat
     * @request POST:/api/v1/members/profile/seats/{uuid}/accept
     * @secure
     */
    profileControllerAcceptProductSeatInvitationV1: (uuid: string, params: RequestParams = {}) =>
      this.request<MemberPackageProductSeat, void | ErrorResponse>({
        path: `/api/v1/members/profile/seats/${uuid}/accept`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerAcceptGiftProductSeatInvitationV1
     * @summary Accept gift invitation to a product seat
     * @request POST:/api/v1/members/profile/seats/{uuid}/accept-gift
     * @secure
     */
    profileControllerAcceptGiftProductSeatInvitationV1: (
      uuid: string,
      params: RequestParams = {},
    ) =>
      this.request<MemberPackageProductSeat, void | ErrorResponse>({
        path: `/api/v1/members/profile/seats/${uuid}/accept-gift`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerCreateInvoiceAddressV1
     * @summary Add invoice address of a subscribed product
     * @request POST:/api/v1/members/profile/subscriptions/{id}/invoice-address
     * @secure
     */
    profileControllerCreateInvoiceAddressV1: (
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<ProfileAddress, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/invoice-address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateInvoiceAddressV1
     * @summary Update invoice address of a subscribed product
     * @request PATCH:/api/v1/members/profile/subscriptions/{id}/invoice-address
     * @secure
     */
    profileControllerUpdateInvoiceAddressV1: (
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<ProfileAddress, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/invoice-address`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerCreateDeliveryAddressV1
     * @summary Add delivery address of a subscribed product
     * @request POST:/api/v1/members/profile/subscriptions/product/{id}/delivery-address
     * @secure
     */
    profileControllerCreateDeliveryAddressV1: (
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}/delivery-address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateOwnerAccessV1
     * @summary Trigger own access of a product
     * @request PATCH:/api/v1/members/profile/subscriptions/product/{id}/owner-access/{activate}
     * @secure
     */
    profileControllerUpdateOwnerAccessV1: (
      id: number,
      activate: boolean,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}/owner-access/${activate}`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetDeliveryAddressV1
     * @summary Get delivery address of a subscribed product
     * @request GET:/api/v1/members/profile/subscriptions/product/{productId}/delivery-address/{addressId}
     * @secure
     */
    profileControllerGetDeliveryAddressV1: (
      productId: number,
      addressId: number,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${productId}/delivery-address/${addressId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateDeliveryAddressV1
     * @summary Update delivery address of a subscribed product
     * @request PATCH:/api/v1/members/profile/subscriptions/product/{productId}/delivery-address/{addressId}
     * @secure
     */
    profileControllerUpdateDeliveryAddressV1: (
      productId: number,
      addressId: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${productId}/delivery-address/${addressId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRemoveDeliveryAddressV1
     * @summary Soft Remove delivery address of a subscribed product
     * @request DELETE:/api/v1/members/profile/subscriptions/product/{id}/delivery-address/{addressId}
     * @secure
     */
    profileControllerRemoveDeliveryAddressV1: (
      id: number,
      addressId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/product/${id}/delivery-address/${addressId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetConsentsV1
     * @summary Get consents
     * @request GET:/api/v1/members/profile/consents
     * @secure
     */
    profileControllerGetConsentsV1: (params: RequestParams = {}) =>
      this.request<MemberConsentDto[], ErrorResponse>({
        path: `/api/v1/members/profile/consents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerUpdateConsentV1
     * @summary Toggle member consent status by id
     * @request PATCH:/api/v1/members/profile/consents/toggle/{id}
     * @secure
     */
    profileControllerUpdateConsentV1: (
      id: number,
      data: ConsentUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberConsentDto, ErrorResponse>({
        path: `/api/v1/members/profile/consents/toggle/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerSubscribeDefaultConsentsV1
     * @summary Subscribe default consents for current member
     * @request POST:/api/v1/members/profile/consents/default-subscribe
     * @secure
     */
    profileControllerSubscribeDefaultConsentsV1: (params: RequestParams = {}) =>
      this.request<boolean, ErrorResponse>({
        path: `/api/v1/members/profile/consents/default-subscribe`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerChangeSubscriptionV1
     * @summary Change subscription package and products
     * @request POST:/api/v1/members/profile/subscriptions/{id}/change
     * @secure
     */
    profileControllerChangeSubscriptionV1: (
      id: number,
      data: ChangeSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<ChangeSubscriptionResponse, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/change`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetSubscriptionChangeV1
     * @summary Get subscription change details
     * @request GET:/api/v1/members/profile/subscriptions/{id}/change/{changeId}
     * @secure
     */
    profileControllerGetSubscriptionChangeV1: (
      id: number,
      changeId: number,
      params: RequestParams = {},
    ) =>
      this.request<ChangeSubscriptionDetails, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/change/${changeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerCancelSubscriptionChangeV1
     * @summary Cancel subscription change details
     * @request PATCH:/api/v1/members/profile/subscriptions/{id}/change/{changeId}/cancel
     * @secure
     */
    profileControllerCancelSubscriptionChangeV1: (
      id: number,
      changeId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/change/${changeId}/cancel`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerConfirmSubscriptionChangeV1
     * @summary Confirm subscription change for next renewal
     * @request PATCH:/api/v1/members/profile/subscriptions/{id}/change/{changeId}/confirm
     * @secure
     */
    profileControllerConfirmSubscriptionChangeV1: (
      id: number,
      changeId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/subscriptions/${id}/change/${changeId}/confirm`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetMissingInfoV1
     * @summary Get missing info alerts for member info, invited member info
     * @request GET:/api/v1/members/profile/missing-info
     * @secure
     */
    profileControllerGetMissingInfoV1: (params: RequestParams = {}) =>
      this.request<MissingInfoResponse[], ErrorResponse>({
        path: `/api/v1/members/profile/missing-info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetLoginAccountsOfAmemberV1
     * @summary Get all login linked accounts of a member
     * @request GET:/api/v1/members/profile/login-accounts
     * @secure
     */
    profileControllerGetLoginAccountsOfAmemberV1: (params: RequestParams = {}) =>
      this.request<LoginAccountsResponse[], ErrorResponse>({
        path: `/api/v1/members/profile/login-accounts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerRemoveLinkedAccountV1
     * @summary Remove a linked account of a member
     * @request DELETE:/api/v1/members/profile/login-accounts/{id}
     * @secure
     */
    profileControllerRemoveLinkedAccountV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/members/profile/login-accounts/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Profile
     * @name ProfileControllerGetSubscriptionActionHelpTextV1
     * @summary Get help text for subscription action
     * @request POST:/api/v1/members/profile/subscription-action-help-text/{id}
     * @secure
     */
    profileControllerGetSubscriptionActionHelpTextV1: (
      id: number,
      data: SubscriptionActionHelpTextRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionActionHelpTextResponse, ErrorResponse>({
        path: `/api/v1/members/profile/subscription-action-help-text/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerCreateV1
     * @summary Create a new member
     * @request POST:/api/v1/members
     * @secure
     */
    memberControllerCreateV1: (data: CreateMemberDto, params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, ErrorResponse | void>({
        path: `/api/v1/members`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindAllV1
     * @summary Get all members of the tenant with filter & pagination
     * @request POST:/api/v1/members/filter
     * @secure
     */
    memberControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        /** @default "createdAt" */
        orderBy?: 'email' | 'createdAt' | 'id' | 'updatedAt';
        legacySupport?: boolean;
      },
      data?: MemberFilterDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfoPaginated, void | ErrorResponse>({
        path: `/api/v1/members/filter`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerUpdateV1
     * @summary Update a member
     * @request PATCH:/api/v1/members/{id}
     * @secure
     */
    memberControllerUpdateV1: (
      id: string,
      data: UpdateMemberDto,
      query?: {
        legacySupport?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse | void>({
        path: `/api/v1/members/${id}`,
        method: 'PATCH',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerRemoveV1
     * @summary Delete a member
     * @request DELETE:/api/v1/members/{id}
     * @secure
     */
    memberControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindOneV1
     * @summary Get a member by id
     * @request GET:/api/v1/members/{id}
     * @secure
     */
    memberControllerFindOneV1: (
      id: string,
      query?: {
        legacySupport?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, void | ErrorResponse>({
        path: `/api/v1/members/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetMembersInvoicesV1
     * @summary Get all invoices of a member
     * @request GET:/api/v1/members/{id}/invoices
     * @secure
     */
    memberControllerGetMembersInvoicesV1: (id: string, params: RequestParams = {}) =>
      this.request<InvoiceResponse[], void | ErrorResponse>({
        path: `/api/v1/members/${id}/invoices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerSearchV1
     * @summary Search members, orders, and invoices
     * @request GET:/api/v1/members/search
     * @secure
     */
    memberControllerSearchV1: (
      query: {
        take: number;
        query: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchResponseDto[], void | ErrorResponse>({
        path: `/api/v1/members/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerEnqueueCleanupS3FilesV1
     * @summary Enqueue cleanup s3 files
     * @request GET:/api/v1/members/enqueue-cleanup-s3-files
     * @secure
     */
    memberControllerEnqueueCleanupS3FilesV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/enqueue-cleanup-s3-files`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindByMemberNumberV1
     * @summary Get a member by member number
     * @request GET:/api/v1/members/by-member-number/{memberNumber}
     * @secure
     */
    memberControllerFindByMemberNumberV1: (memberNumber: string, params: RequestParams = {}) =>
      this.request<MemberPersonalInfo, void | ErrorResponse>({
        path: `/api/v1/members/by-member-number/${memberNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetMembersOrdersV1
     * @summary Get all orders of a member
     * @request GET:/api/v1/members/{id}/orders
     * @secure
     */
    memberControllerGetMembersOrdersV1: (
      id: string,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/members/${id}/orders`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetMembersPaymentsV1
     * @summary Get all payments and refunds of a member
     * @request GET:/api/v1/members/{id}/payments
     * @secure
     */
    memberControllerGetMembersPaymentsV1: (
      id: string,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        type?: 'payment' | 'refund' | 'invoice' | 'credit_note' | 'rounding_adjustment';
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentAndRefundResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/members/${id}/payments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetNotesOfAMemberV1
     * @summary Get all notes of a member
     * @request GET:/api/v1/members/{id}/notes
     * @secure
     */
    memberControllerGetNotesOfAMemberV1: (
      id: string,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<NoteResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/members/${id}/notes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetCommunicationActivitiesOfAMemberV1
     * @summary Get all communication activities of a member
     * @request GET:/api/v1/members/{id}/communication-activities
     * @secure
     */
    memberControllerGetCommunicationActivitiesOfAMemberV1: (
      id: string,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberCommunicationActivitiesResponseDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/members/${id}/communication-activities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetConsentsOfAMemberV1
     * @summary Get all consents of a member
     * @request GET:/api/v1/members/{id}/consents
     * @secure
     */
    memberControllerGetConsentsOfAMemberV1: (id: string, params: RequestParams = {}) =>
      this.request<MemberConsentDto[], void | ErrorResponse>({
        path: `/api/v1/members/${id}/consents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetConsentHistoryOfAMemberV1
     * @summary Get a specific consent history of a member
     * @request GET:/api/v1/members/{id}/consents/history/{consentId}
     * @secure
     */
    memberControllerGetConsentHistoryOfAMemberV1: (
      id: string,
      consentId: number,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/members/${id}/consents/history/${consentId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerUpdateConsentOfAMemberV1
     * @summary Update consent of a member
     * @request PATCH:/api/v1/members/{id}/consents/{consentId}
     * @secure
     */
    memberControllerUpdateConsentOfAMemberV1: (
      id: string,
      consentId: number,
      data: ConsentUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberConsentDto, void | ErrorResponse>({
        path: `/api/v1/members/${id}/consents/${consentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetSettingsV1
     * @summary Get all settings of a member
     * @request GET:/api/v1/members/{id}/settings
     * @secure
     */
    memberControllerGetSettingsV1: (id: string, params: RequestParams = {}) =>
      this.request<MemberSettings, void | ErrorResponse>({
        path: `/api/v1/members/${id}/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerUpdateSettingsV1
     * @summary Update settings of a member
     * @request PATCH:/api/v1/members/{id}/settings
     * @secure
     */
    memberControllerUpdateSettingsV1: (
      id: string,
      data: MemberSettingsUpdate,
      params: RequestParams = {},
    ) =>
      this.request<MemberSettings, void | ErrorResponse>({
        path: `/api/v1/members/${id}/settings`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetSubscriptionsV1
     * @summary Get all subscriptions of a member
     * @request GET:/api/v1/members/{memberId}/subscriptions
     * @secure
     */
    memberSubscriptionControllerGetSubscriptionsV1: (
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionListItem[], void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetMembersSubscriptionsV1
     * @summary Get all subscriptions along with products of a member
     * @request GET:/api/v1/members/{memberId}/subscriptions/list-with-products
     * @secure
     */
    memberSubscriptionControllerGetMembersSubscriptionsV1: (
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<MemberSubscribedPackage[], void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/list-with-products`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetMissingInfoV1
     * @summary Get missing info alerts for member info, invited member info
     * @request GET:/api/v1/members/{memberId}/subscriptions/missing-info
     * @secure
     */
    memberSubscriptionControllerGetMissingInfoV1: (memberId: string, params: RequestParams = {}) =>
      this.request<MissingInfoResponse[], void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/missing-info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetMemberSubscriptionV1
     * @summary Get subscription details
     * @request GET:/api/v1/members/{memberId}/subscriptions/{id}
     * @secure
     */
    memberSubscriptionControllerGetMemberSubscriptionV1: (
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionDetails, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateMemberSubscriptionV1
     * @summary Update particular subscription of a member
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/{id}
     * @secure
     */
    memberSubscriptionControllerUpdateMemberSubscriptionV1: (
      memberId: string,
      id: number,
      data: UpdateMemberPackageDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerStopMemberSubscriptionV1
     * @summary Stop particular subscription of a member
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/{id}/stop
     * @secure
     */
    memberSubscriptionControllerStopMemberSubscriptionV1: (
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/stop`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerChangeSubscriptionV1
     * @summary Switch,Upgrade,downgrade particular subscription of a member
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/{id}/change
     * @secure
     */
    memberSubscriptionControllerChangeSubscriptionV1: (
      id: number,
      memberId: string,
      data: ChangeSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<ChangeSubscriptionResponse, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/change`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetSubscriptionChangeV1
     * @summary Get subscription change details
     * @request GET:/api/v1/members/{memberId}/subscriptions/subscriptions/{id}/change/{changeId}
     * @secure
     */
    memberSubscriptionControllerGetSubscriptionChangeV1: (
      memberId: string,
      id: number,
      changeId: number,
      params: RequestParams = {},
    ) =>
      this.request<ChangeSubscriptionDetails, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/subscriptions/${id}/change/${changeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerCancelSubscriptionChangeV1
     * @summary Cancel subscription change details
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/subscriptions/{subscriptionPlanId}/change/{changeId}/cancel
     * @secure
     */
    memberSubscriptionControllerCancelSubscriptionChangeV1: (
      memberId: string,
      subscriptionPlanId: number,
      changeId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/subscriptions/${subscriptionPlanId}/change/${changeId}/cancel`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerConfirmSubscriptionChangeV1
     * @summary Confirm subscription change
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/subscriptions/{subscriptionPlanId}/change/{changeId}/confirm
     * @secure
     */
    memberSubscriptionControllerConfirmSubscriptionChangeV1: (
      memberId: string,
      subscriptionPlanId: number,
      changeId: number,
      data: ConfirmChangeSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/subscriptions/${subscriptionPlanId}/change/${changeId}/confirm`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateSubscriptionActivationDateV1
     * @summary Change activation date of a subscription
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/{id}/activation-date
     * @secure
     */
    memberSubscriptionControllerUpdateSubscriptionActivationDateV1: (
      memberId: string,
      id: number,
      data: UpdateMemberPackageDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/activation-date`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetMemberSubscribedProductV1
     * @summary Get subscribed product details
     * @request GET:/api/v1/members/{memberId}/subscriptions/product/{id}
     * @secure
     */
    memberSubscriptionControllerGetMemberSubscribedProductV1: (
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<MemberSubscribedProduct, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerCreateAdditionalMemberV1
     * @summary Create additional member for a product seat
     * @request POST:/api/v1/members/{memberId}/subscriptions/product/{id}/create-member
     * @secure
     */
    memberSubscriptionControllerCreateAdditionalMemberV1: (
      memberId: string,
      id: number,
      data: CreateAdditionalMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/create-member`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerAssignExistingMemberToProductSeatV1
     * @summary Assign existing member to a product seat
     * @request POST:/api/v1/members/{memberId}/subscriptions/product/{id}/assign-member/{userId}
     * @secure
     */
    memberSubscriptionControllerAssignExistingMemberToProductSeatV1: (
      memberId: string,
      id: number,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/assign-member/${userId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerCreateGiftReceiverV1
     * @summary Create gift receiver for a product seat
     * @request POST:/api/v1/members/{memberId}/subscriptions/product/{id}/create-gift-receiver
     * @secure
     */
    memberSubscriptionControllerCreateGiftReceiverV1: (
      memberId: string,
      id: number,
      data: CreateGiftReceiverDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPersonalInfo, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/create-gift-receiver`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerCreateDeliveryAddressV1
     * @summary Add delivery address of a subscribed product
     * @request POST:/api/v1/members/{memberId}/subscriptions/product/{id}/delivery-address
     * @secure
     */
    memberSubscriptionControllerCreateDeliveryAddressV1: (
      memberId: string,
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/delivery-address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateProductRecurringPriceV1
     * @summary Update recurring price of a product
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/product/{id}/recurring-price
     * @secure
     */
    memberSubscriptionControllerUpdateProductRecurringPriceV1: (
      id: number,
      memberId: string,
      data: UpdateRecurringPriceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/recurring-price`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerCreateInvoiceAddressV1
     * @summary Add delivery address of a subscribed package
     * @request POST:/api/v1/members/{memberId}/subscriptions/{id}/invoice-address
     * @secure
     */
    memberSubscriptionControllerCreateInvoiceAddressV1: (
      memberId: string,
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<ProfileAddress, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/invoice-address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateInvoiceAddressV1
     * @summary Update invoice address of a subscribed package
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/{id}/invoice-address
     * @secure
     */
    memberSubscriptionControllerUpdateInvoiceAddressV1: (
      memberId: string,
      id: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<ProfileAddress, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/invoice-address`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateOwnerAccessV1
     * @summary Trigger own access of a product
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/product/{id}/owner-access/{activate}
     * @secure
     */
    memberSubscriptionControllerUpdateOwnerAccessV1: (
      id: number,
      activate: boolean,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/owner-access/${activate}`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetDeliveryAddressV1
     * @summary Get delivery address of a subscribed product
     * @request GET:/api/v1/members/{memberId}/subscriptions/product/{id}/delivery-address/{addressId}
     * @secure
     */
    memberSubscriptionControllerGetDeliveryAddressV1: (
      memberId: string,
      addressId: number,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/delivery-address/${addressId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerRemoveDeliveryAddressV1
     * @summary Soft Remove delivery address of a subscribed product
     * @request DELETE:/api/v1/members/{memberId}/subscriptions/product/{id}/delivery-address/{addressId}
     * @secure
     */
    memberSubscriptionControllerRemoveDeliveryAddressV1: (
      addressId: number,
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/delivery-address/${addressId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateDeliveryAddressV1
     * @summary Update delivery address of a subscribed product
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/product/{productId}/delivery-address/{addressId}
     * @secure
     */
    memberSubscriptionControllerUpdateDeliveryAddressV1: (
      memberId: string,
      productId: number,
      addressId: number,
      data: MemberAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryAddress, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${productId}/delivery-address/${addressId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateShippingProviderInfoV1
     * @summary Update shipping provider of a subscribed product
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/product/{id}/shipping-provider
     * @secure
     */
    memberSubscriptionControllerUpdateShippingProviderInfoV1: (
      memberId: string,
      id: number,
      data: UpdateShippingProviderInfoDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/shipping-provider`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateEmailDomainsV1
     * @summary Update email domains of a subscribed product
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/product/{id}/email-domains
     * @secure
     */
    memberSubscriptionControllerUpdateEmailDomainsV1: (
      id: number,
      memberId: string,
      data: UpdateEmailDomainsDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPackageProduct, ErrorResponse | void>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/email-domains`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerRemoveEmailDomainV1
     * @summary Remove a specific email domain from a subscribed product
     * @request DELETE:/api/v1/members/{memberId}/subscriptions/product/{id}/email-domains/{domain}
     * @secure
     */
    memberSubscriptionControllerRemoveEmailDomainV1: (
      id: number,
      domain: string,
      memberId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/product/${id}/email-domains/${domain}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetMemberProductSeatV1
     * @summary Get product seat details
     * @request GET:/api/v1/members/{memberId}/subscriptions/seats/{id}
     * @secure
     */
    memberSubscriptionControllerGetMemberProductSeatV1: (
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<SeatData, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/seats/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerRemoveProductSeatInvitationV1
     * @summary Remove invitation to a product seat
     * @request DELETE:/api/v1/members/{memberId}/subscriptions/seats/{id}
     * @secure
     */
    memberSubscriptionControllerRemoveProductSeatInvitationV1: (
      memberId: string,
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/seats/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerInviteToProductSeatV1
     * @summary Invite member to a product seat
     * @request POST:/api/v1/members/{memberId}/subscriptions/seats/invite
     * @secure
     */
    memberSubscriptionControllerInviteToProductSeatV1: (
      memberId: string,
      data: InviteSeatDto,
      params: RequestParams = {},
    ) =>
      this.request<MemberPackageProductSeat, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/seats/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerSubscribeForFreeV1
     * @summary Subscribe to a free subscription with 0 payment
     * @request POST:/api/v1/members/{memberId}/subscriptions/free
     * @secure
     */
    memberSubscriptionControllerSubscribeForFreeV1: (
      memberId: string,
      data: FreePackageRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/free`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerSubscribeViaFakturaV1
     * @summary Subscribe to a faktura subscription
     * @request POST:/api/v1/members/{memberId}/subscriptions/faktura
     * @secure
     */
    memberSubscriptionControllerSubscribeViaFakturaV1: (
      memberId: string,
      data: FakturaPackageSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/faktura`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerUpdateExternalSubscriptionV1
     * @summary Update a faktura subscription
     * @request PATCH:/api/v1/members/{memberId}/subscriptions/faktura/update
     * @secure
     */
    memberSubscriptionControllerUpdateExternalSubscriptionV1: (
      memberId: string,
      data: FakturaSubscriptionUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<Payment, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/faktura/update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member Subscriptions
     * @name MemberSubscriptionControllerGetSubscriptionActionHelpTextV1
     * @summary Get help text for subscription action
     * @request POST:/api/v1/members/{memberId}/subscriptions/{id}/subscription-action-help-text
     * @secure
     */
    memberSubscriptionControllerGetSubscriptionActionHelpTextV1: (
      memberId: string,
      id: number,
      data: SubscriptionActionHelpTextRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionActionHelpTextResponse, void | ErrorResponse>({
        path: `/api/v1/members/${memberId}/subscriptions/${id}/subscription-action-help-text`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Note
     * @name NoteControllerCreateNoteV1
     * @summary Create a note on member
     * @request POST:/api/v1/note
     * @secure
     */
    noteControllerCreateNoteV1: (data: CreateNoteDto, params: RequestParams = {}) =>
      this.request<NoteResponse, ErrorResponse | void>({
        path: `/api/v1/note`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Note
     * @name NoteControllerUpdateNoteV1
     * @summary update a note
     * @request PATCH:/api/v1/note/{id}
     * @secure
     */
    noteControllerUpdateNoteV1: (id: string, data: UpdateNoteDto, params: RequestParams = {}) =>
      this.request<NoteResponse, void | ErrorResponse>({
        path: `/api/v1/note/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Note
     * @name NoteControllerDeleteNoteV1
     * @summary delete a note
     * @request DELETE:/api/v1/note/{id}
     * @secure
     */
    noteControllerDeleteNoteV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/note/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerCreateV1
     * @summary Create a new product
     * @request POST:/api/v1/products
     * @secure
     */
    productControllerCreateV1: (data: CreateProductDto, params: RequestParams = {}) =>
      this.request<ProductResponse, ErrorResponse | void>({
        path: `/api/v1/products`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerFindAllV1
     * @summary Get all products of the tenant
     * @request GET:/api/v1/products
     * @secure
     */
    productControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerGetFilteredProductsV1
     * @summary Get products by filters
     * @request GET:/api/v1/products/all
     * @secure
     */
    productControllerGetFilteredProductsV1: (
      query?: {
        isOptional?: boolean;
        status?: 'draft' | 'published' | 'unpublished';
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductResponse[], void | ErrorResponse>({
        path: `/api/v1/products/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerFindOneV1
     * @summary Get a product by id
     * @request GET:/api/v1/products/{id}
     * @secure
     */
    productControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<ProductResponse, void | ErrorResponse>({
        path: `/api/v1/products/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerUpdateV1
     * @summary Update a product
     * @request PATCH:/api/v1/products/{id}
     * @secure
     */
    productControllerUpdateV1: (id: string, data: UpdateProductDto, params: RequestParams = {}) =>
      this.request<ProductResponse, void | ErrorResponse>({
        path: `/api/v1/products/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product
     * @name ProductControllerRemoveV1
     * @summary Delete a product
     * @request DELETE:/api/v1/products/{id}
     * @secure
     */
    productControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/products/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerCreateV1
     * @summary Create a new subscription plan
     * @request POST:/api/v1/subscription-plans
     * @secure
     */
    subscriptionPlanControllerCreateV1: (
      data: CreateSubscriptionPlanDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponse, ErrorResponse | void>({
        path: `/api/v1/subscription-plans`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerFindAllV1
     * @summary Get all subscription plans of the tenant
     * @request GET:/api/v1/subscription-plans
     * @secure
     */
    subscriptionPlanControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/subscription-plans`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerGetStatisticV1
     * @summary Get statistic of subscription plans
     * @request GET:/api/v1/subscription-plans/statistic
     * @secure
     */
    subscriptionPlanControllerGetStatisticV1: (params: RequestParams = {}) =>
      this.request<SubscriptionStatistic, void | ErrorResponse>({
        path: `/api/v1/subscription-plans/statistic`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerGetFilteredV1
     * @summary Get subscription plans by filters
     * @request GET:/api/v1/subscription-plans/all
     * @secure
     */
    subscriptionPlanControllerGetFilteredV1: (
      query?: {
        status?: string;
        allowSameSubscriptionChange?: boolean;
        allowDifferentSubscriptionSwitch?: boolean;
        showAsOptionOnSubscriptionSwitch?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponse[], void | ErrorResponse>({
        path: `/api/v1/subscription-plans/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerEnqueueCleanupInvitedMembersNotAcceptedExpiredV1
     * @summary Enqueue cleanup invited members not accepted expired
     * @request GET:/api/v1/subscription-plans/enqueue-cleanup-invited-members-not-accepted-expired
     * @secure
     */
    subscriptionPlanControllerEnqueueCleanupInvitedMembersNotAcceptedExpiredV1: (
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/subscription-plans/enqueue-cleanup-invited-members-not-accepted-expired`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerFindOneV1
     * @summary Get a subscription plan by id
     * @request GET:/api/v1/subscription-plans/{id}
     * @secure
     */
    subscriptionPlanControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<SubscriptionPlanResponse, void | ErrorResponse>({
        path: `/api/v1/subscription-plans/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerUpdateV1
     * @summary Update a subscription plan
     * @request PATCH:/api/v1/subscription-plans/{id}
     * @secure
     */
    subscriptionPlanControllerUpdateV1: (
      id: string,
      data: UpdateSubscriptionPlanDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponse, ErrorResponse | void>({
        path: `/api/v1/subscription-plans/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerRemoveV1
     * @summary Delete a subscription plan
     * @request DELETE:/api/v1/subscription-plans/{id}
     * @secure
     */
    subscriptionPlanControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/subscription-plans/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscription Plan
     * @name SubscriptionPlanControllerGetPriceByQuantityV1
     * @summary Get recurring price by quantity of optional products
     * @request POST:/api/v1/subscription-plans/price-by-quantity
     * @secure
     */
    subscriptionPlanControllerGetPriceByQuantityV1: (
      data: SubscriptionPlanPriceByQuantityDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionPlanResponse, ErrorResponse>({
        path: `/api/v1/subscription-plans/price-by-quantity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerCreateV1
     * @summary Create a new package
     * @request POST:/api/v1/product-packages
     * @secure
     */
    packageControllerCreateV1: (data: CreatePackageDto, params: RequestParams = {}) =>
      this.request<PackageResponse, ErrorResponse | void>({
        path: `/api/v1/product-packages`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerFindAllV1
     * @summary Get all packages of the tenant
     * @request GET:/api/v1/product-packages
     * @secure
     */
    packageControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<PackageResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/product-packages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetFreePackagesV1
     * @summary Get free packages
     * @request GET:/api/v1/product-packages/free
     * @secure
     */
    packageControllerGetFreePackagesV1: (params: RequestParams = {}) =>
      this.request<MinimalPackageResponse[], void | ErrorResponse>({
        path: `/api/v1/product-packages/free`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetManualOrderPackagesV1
     * @summary Get packages available for manual order by admin
     * @request GET:/api/v1/product-packages/manual-order
     * @secure
     */
    packageControllerGetManualOrderPackagesV1: (params: RequestParams = {}) =>
      this.request<MinimalPackageResponse[], void | ErrorResponse>({
        path: `/api/v1/product-packages/manual-order`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetFilteredPackagesV1
     * @summary Get packages by filters
     * @request GET:/api/v1/product-packages/all
     * @secure
     */
    packageControllerGetFilteredPackagesV1: (
      query?: {
        isAvailableViaSlug?: boolean;
        isAvailableOnMyPage?: boolean;
        isAvailableForManualOrderViaAdmin?: boolean;
        enableGiftSubscription?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PackageResponse[], ErrorResponse>({
        path: `/api/v1/product-packages/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerFindOneV1
     * @summary Get a package by id
     * @request GET:/api/v1/product-packages/{id}
     * @secure
     */
    packageControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<PackageResponse, void | ErrorResponse>({
        path: `/api/v1/product-packages/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerUpdateV1
     * @summary Update a package
     * @request PATCH:/api/v1/product-packages/{id}
     * @secure
     */
    packageControllerUpdateV1: (id: string, data: UpdatePackageDto, params: RequestParams = {}) =>
      this.request<PackageResponse, ErrorResponse | void>({
        path: `/api/v1/product-packages/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerRemoveV1
     * @summary Delete a package
     * @request DELETE:/api/v1/product-packages/{id}
     * @secure
     */
    packageControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/product-packages/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetBySlugV1
     * @summary Get a package by slug
     * @request GET:/api/v1/product-packages/slug/{tenantId}/{slug}
     * @secure
     */
    packageControllerGetBySlugV1: (tenantId: number, slug: string, params: RequestParams = {}) =>
      this.request<PackageResponse, ErrorResponse>({
        path: `/api/v1/product-packages/slug/${tenantId}/${slug}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetPriceByQuantityV1
     * @summary Get introductory & recurring price by quantity of optional products
     * @request POST:/api/v1/product-packages/price-by-quantity
     * @secure
     */
    packageControllerGetPriceByQuantityV1: (data: PriceByQuantityDto, params: RequestParams = {}) =>
      this.request<PackageResponse, ErrorResponse>({
        path: `/api/v1/product-packages/price-by-quantity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerOrderForPrePurchasedPackageV1
     * @summary Create a subscription for pre-puchased  package
     * @request POST:/api/v1/product-packages/subscribe
     * @secure
     */
    packageControllerOrderForPrePurchasedPackageV1: (
      data: PrePurchasePackageSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<PrePurchasePackageResponseDto, ErrorResponse | void>({
        path: `/api/v1/product-packages/subscribe`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetDuplicatedPackagesWithSlugV1
     * @summary get duplicated packages with slug
     * @request GET:/api/v1/product-packages/duplicated-packages-with-slug/{tenantId}/{slug}
     * @secure
     */
    packageControllerGetDuplicatedPackagesWithSlugV1: (
      tenantId: number,
      slug: string,
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinimalMemberPackageResponseDto[], ErrorResponse>({
        path: `/api/v1/product-packages/duplicated-packages-with-slug/${tenantId}/${slug}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Product Package
     * @name PackageControllerGetPackagesWithSubscriptionPlansV1
     * @summary get packages with subscription plans
     * @request GET:/api/v1/product-packages/packages-with-subscription-plans/{tenantId}
     * @secure
     */
    packageControllerGetPackagesWithSubscriptionPlansV1: (
      tenantId: number,
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinimalMemberPackageResponseWithPlanDto[], ErrorResponse>({
        path: `/api/v1/product-packages/packages-with-subscription-plans/${tenantId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Newsletter
     * @name NewsletterControllerGetAllProviderApiKeysV1
     * @summary Get all integrated providers
     * @request GET:/api/v1/newsletters/providers
     * @secure
     */
    newsletterControllerGetAllProviderApiKeysV1: (params: RequestParams = {}) =>
      this.request<object[], void | ErrorResponse>({
        path: `/api/v1/newsletters/providers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Newsletter
     * @name NewsletterControllerGetNewsletterListByApiKeyV1
     * @summary Get all newsletter by api key
     * @request POST:/api/v1/newsletters/lists
     * @secure
     */
    newsletterControllerGetNewsletterListByApiKeyV1: (
      data: NewsletterListsReqDto,
      params: RequestParams = {},
    ) =>
      this.request<NewsletterListsResponseDto[], void | ErrorResponse>({
        path: `/api/v1/newsletters/lists`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Newsletter
     * @name NewsletterControllerAddNewsletterProviderV1
     * @summary Add a new newsletter provider
     * @request POST:/api/v1/newsletters
     * @secure
     */
    newsletterControllerAddNewsletterProviderV1: (
      data: ExternalProviderNewsLetterDto,
      params: RequestParams = {},
    ) =>
      this.request<ConsentExternalProviderResponseDto, ErrorResponse | void>({
        path: `/api/v1/newsletters`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Newsletter
     * @name NewsletterControllerDeleteNewsletterProviderV1
     * @summary Delete a newsletter provider
     * @request DELETE:/api/v1/newsletters/{id}
     * @secure
     */
    newsletterControllerDeleteNewsletterProviderV1: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/newsletters/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerFindAllOidcClientsV1
     * @summary Get all OIDC clients of a tenant
     * @request GET:/api/v1/setting/oidc-clients
     * @secure
     */
    oidcClientControllerFindAllOidcClientsV1: (params: RequestParams = {}) =>
      this.request<OidcClient[], void | ErrorResponse>({
        path: `/api/v1/setting/oidc-clients`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerCreateOidcClientV1
     * @summary Create a new OIDC client for a tenant
     * @request POST:/api/v1/setting/oidc-clients
     * @secure
     */
    oidcClientControllerCreateOidcClientV1: (
      data: CreateOidcClientDto,
      params: RequestParams = {},
    ) =>
      this.request<OidcClient, ErrorResponse | void>({
        path: `/api/v1/setting/oidc-clients`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerPatchOidcClientV1
     * @summary Update an OIDC client
     * @request PATCH:/api/v1/setting/oidc-clients/{id}
     * @secure
     */
    oidcClientControllerPatchOidcClientV1: (
      id: number,
      data: PatchOidcClientDto,
      params: RequestParams = {},
    ) =>
      this.request<OidcClient, ErrorResponse | void>({
        path: `/api/v1/setting/oidc-clients/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerFindOidcClientByIdV1
     * @summary Find an OIDC client by Id
     * @request GET:/api/v1/setting/oidc-clients/{id}
     * @secure
     */
    oidcClientControllerFindOidcClientByIdV1: (id: number, params: RequestParams = {}) =>
      this.request<OidcClient, ErrorResponse | void>({
        path: `/api/v1/setting/oidc-clients/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerDeleteOidcClientV1
     * @summary Delete an OIDC client
     * @request DELETE:/api/v1/setting/oidc-clients/{id}
     * @secure
     */
    oidcClientControllerDeleteOidcClientV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/oidc-clients/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Oidc-Clients
     * @name OidcClientControllerGenerateNewOidcClientSecretV1
     * @summary Generate a new OIDC client secret
     * @request PATCH:/api/v1/setting/oidc-clients/{id}/secret
     * @secure
     */
    oidcClientControllerGenerateNewOidcClientSecretV1: (id: number, params: RequestParams = {}) =>
      this.request<OidcClient, void | ErrorResponse>({
        path: `/api/v1/setting/oidc-clients/${id}/secret`,
        method: 'PATCH',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerFindAllM2MClientsV1
     * @summary Get all M2m clients of a tenant
     * @request GET:/api/v1/setting/m2m-clients
     * @secure
     */
    m2MClientControllerFindAllM2MClientsV1: (params: RequestParams = {}) =>
      this.request<M2MClientResponseDto[], void | ErrorResponse>({
        path: `/api/v1/setting/m2m-clients`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerCreateM2MClientV1
     * @summary Create a new M2M client for a tenant
     * @request POST:/api/v1/setting/m2m-clients
     * @secure
     */
    m2MClientControllerCreateM2MClientV1: (
      data: CreateM2MClientRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateM2MClientResponseDto, ErrorResponse | void>({
        path: `/api/v1/setting/m2m-clients`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerGetAllM2MPermisionScopesV1
     * @summary Get all M2m permission scopes
     * @request GET:/api/v1/setting/m2m-clients/scopes
     * @secure
     */
    m2MClientControllerGetAllM2MPermisionScopesV1: (params: RequestParams = {}) =>
      this.request<M2MScopes[], void | ErrorResponse>({
        path: `/api/v1/setting/m2m-clients/scopes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerFindM2MClientByIdV1
     * @summary Get a M2M client of a tenant by id
     * @request GET:/api/v1/setting/m2m-clients/{id}
     * @secure
     */
    m2MClientControllerFindM2MClientByIdV1: (id: number, params: RequestParams = {}) =>
      this.request<M2MClientResponseDto, void | ErrorResponse>({
        path: `/api/v1/setting/m2m-clients/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerUpdateM2MClientV1
     * @summary Update a M2M client of a tenant by id
     * @request PATCH:/api/v1/setting/m2m-clients/{id}
     * @secure
     */
    m2MClientControllerUpdateM2MClientV1: (
      id: number,
      data: UpdateM2MClientRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<M2MClientResponseDto, ErrorResponse | void>({
        path: `/api/v1/setting/m2m-clients/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags M2M-Clients
     * @name M2MClientControllerDeleteM2MClientV1
     * @summary Delete a M2M client of a tenant
     * @request DELETE:/api/v1/setting/m2m-clients/{id}
     * @secure
     */
    m2MClientControllerDeleteM2MClientV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/m2m-clients/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerFindAllMypageCardsSettingsV1
     * @summary Get mypage cards settings of a tenant
     * @request GET:/api/v1/setting/mypage-cards
     * @secure
     */
    mypageCardSettingsControllerFindAllMypageCardsSettingsV1: (params: RequestParams = {}) =>
      this.request<MypageCardsSettingsResponseDto[], void | ErrorResponse>({
        path: `/api/v1/setting/mypage-cards`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerCreateMypageCardSettingsV1
     * @summary Create a new my page card settings for a tenant
     * @request POST:/api/v1/setting/mypage-cards
     * @secure
     */
    mypageCardSettingsControllerCreateMypageCardSettingsV1: (
      data: CreateMypageCardsSettingRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateMypageCardsSettingsResponseDto, ErrorResponse | void>({
        path: `/api/v1/setting/mypage-cards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerGetMypageCardSettingsByIdV1
     * @summary Get a mypage card settings of a tenant by id
     * @request GET:/api/v1/setting/mypage-cards/{id}
     * @secure
     */
    mypageCardSettingsControllerGetMypageCardSettingsByIdV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<MypageCardsSettingsResponseDto, void | ErrorResponse>({
        path: `/api/v1/setting/mypage-cards/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerUpdateMypageCardSettingsV1
     * @summary Update a mypage cards settings of a tenant by id
     * @request PATCH:/api/v1/setting/mypage-cards/{id}
     * @secure
     */
    mypageCardSettingsControllerUpdateMypageCardSettingsV1: (
      id: number,
      data: UpdateMypageCardSettingsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<MypageCardsSettingsResponseDto, ErrorResponse | void>({
        path: `/api/v1/setting/mypage-cards/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerDeleteMypageCardSettingsV1
     * @summary Delete a mypage card settings of a tenant
     * @request DELETE:/api/v1/setting/mypage-cards/{id}
     * @secure
     */
    mypageCardSettingsControllerDeleteMypageCardSettingsV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/mypage-cards/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mypage-Cards-Settings
     * @name MypageCardSettingsControllerUpdateMypageCardsDisplayOrdersV1
     * @summary Update a mypage cards settings display order of a tenant
     * @request PATCH:/api/v1/setting/mypage-cards/display-order/all
     * @secure
     */
    mypageCardSettingsControllerUpdateMypageCardsDisplayOrdersV1: (
      data: UpdateMypageCardSettingsDisplayOrderRequestDto[],
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/setting/mypage-cards/display-order/all`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerFindAllWebhooksV1
     * @summary Get all registered webhooks of a tenant
     * @request GET:/api/v1/setting/webhook
     * @secure
     */
    webhookControllerFindAllWebhooksV1: (params: RequestParams = {}) =>
      this.request<Webhook[], void | ErrorResponse>({
        path: `/api/v1/setting/webhook`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerCreateWebhookV1
     * @summary Create a new webhook setting for a tenant
     * @request POST:/api/v1/setting/webhook
     * @secure
     */
    webhookControllerCreateWebhookV1: (data: CreateWebhookDto, params: RequestParams = {}) =>
      this.request<GetWebhookResponseDto, ErrorResponse | void>({
        path: `/api/v1/setting/webhook`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerFindAvailableWebhookEventsV1
     * @summary Get available webhook events
     * @request GET:/api/v1/setting/webhook/events
     * @secure
     */
    webhookControllerFindAvailableWebhookEventsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/webhook/events`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerEnqueueCleanupOldWebhookEventLogsV1
     * @summary Enqueue cleanup old webhook event logs
     * @request GET:/api/v1/setting/webhook/enqueue-cleanup-old-webhook-event-logs
     * @secure
     */
    webhookControllerEnqueueCleanupOldWebhookEventLogsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/webhook/enqueue-cleanup-old-webhook-event-logs`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerFindWebhookByIdV1
     * @summary Get a webhook
     * @request GET:/api/v1/setting/webhook/{id}
     * @secure
     */
    webhookControllerFindWebhookByIdV1: (id: number, params: RequestParams = {}) =>
      this.request<GetWebhookResponseDto, void | ErrorResponse>({
        path: `/api/v1/setting/webhook/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerDeleteWebhookV1
     * @summary Delete a webhook setting
     * @request DELETE:/api/v1/setting/webhook/{id}
     * @secure
     */
    webhookControllerDeleteWebhookV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/webhook/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite Webhook
     * @name WebhookControllerTestWebhookV1
     * @summary Perform some actions to test webhook
     * @request POST:/api/v1/setting/webhook/test/{action}
     * @secure
     */
    webhookControllerTestWebhookV1: (action: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/setting/webhook/test/${action}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast
     * @name PodcastControllerGenerateLinkV1
     * @summary Generate link to podcast
     * @request GET:/api/v1/podcast/generate-link/{podcastId}
     */
    podcastControllerGenerateLinkV1: (podcastId: number, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/podcast/generate-link/${podcastId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast
     * @name PodcastControllerGetPodcastsForMemberV1
     * @summary Get podcasts for member
     * @request GET:/api/v1/podcast
     */
    podcastControllerGetPodcastsForMemberV1: (params: RequestParams = {}) =>
      this.request<PodcastDto[], any>({
        path: `/api/v1/podcast`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast
     * @name PodcastControllerLinkSpotifyAccountV1
     * @summary Create a Spotify link
     * @request POST:/api/v1/podcast/spotify-link
     */
    podcastControllerLinkSpotifyAccountV1: (data: LinkSpotifyDto, params: RequestParams = {}) =>
      this.request<LinkSpotifyResponseDto, ErrorResponse>({
        path: `/api/v1/podcast/spotify-link`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast
     * @name PodcastControllerGetFeedV1
     * @summary Get podcast feed
     * @request GET:/api/v1/podcast/{signature}
     */
    podcastControllerGetFeedV1: (signature: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/podcast/${signature}`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast
     * @name PodcastControllerIsSpotifySetupEnabledV1
     * @summary Check if Spotify setup is enabled
     * @request GET:/api/v1/podcast/spotify/spotify-setup-enabled
     */
    podcastControllerIsSpotifySetupEnabledV1: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/podcast/spotify/spotify-setup-enabled`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerGetPodcastsV1
     * @summary Get all podcasts
     * @request GET:/api/v1/podcast-admin
     * @secure
     */
    podcastAdminControllerGetPodcastsV1: (params: RequestParams = {}) =>
      this.request<Podcast[], void>({
        path: `/api/v1/podcast-admin`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerCreatePodcastV1
     * @summary Create a new podcast
     * @request POST:/api/v1/podcast-admin
     * @secure
     */
    podcastAdminControllerCreatePodcastV1: (data: CreatePodcastDto, params: RequestParams = {}) =>
      this.request<Podcast, ErrorResponse | void>({
        path: `/api/v1/podcast-admin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerUpdatePodcastV1
     * @request PUT:/api/v1/podcast-admin/{id}
     * @secure
     */
    podcastAdminControllerUpdatePodcastV1: (
      id: number,
      data: UpdatePodcastDto,
      params: RequestParams = {},
    ) =>
      this.request<Podcast, ErrorResponse | void>({
        path: `/api/v1/podcast-admin/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerGetProductsByPodcastIdV1
     * @request GET:/api/v1/podcast-admin/{id}/products
     */
    podcastAdminControllerGetProductsByPodcastIdV1: (id: number, params: RequestParams = {}) =>
      this.request<ContentProductDto[], any>({
        path: `/api/v1/podcast-admin/${id}/products`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerAddProductToPodcastV1
     * @request POST:/api/v1/podcast-admin/{podcastId}/products/{productId}
     * @secure
     */
    podcastAdminControllerAddProductToPodcastV1: (
      podcastId: number,
      productId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/podcast-admin/${podcastId}/products/${productId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerRemoveProductFromPodcastV1
     * @request DELETE:/api/v1/podcast-admin/{podcastId}/products/{productId}
     * @secure
     */
    podcastAdminControllerRemoveProductFromPodcastV1: (
      podcastId: number,
      productId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/podcast-admin/${podcastId}/products/${productId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerSetupSpotifyPartnerV1
     * @summary Set up Spotify partner integration
     * @request POST:/api/v1/podcast-admin/spotify-setup
     * @secure
     */
    podcastAdminControllerSetupSpotifyPartnerV1: (params: RequestParams = {}) =>
      this.request<SpotifyPartner, ErrorResponse | void>({
        path: `/api/v1/podcast-admin/spotify-setup`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerGetSpotifyPartnerV1
     * @summary Get Spotify partner integration details
     * @request GET:/api/v1/podcast-admin/spotify-setup
     * @secure
     */
    podcastAdminControllerGetSpotifyPartnerV1: (params: RequestParams = {}) =>
      this.request<SpotifyPartner, void>({
        path: `/api/v1/podcast-admin/spotify-setup`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Podcast Admin
     * @name PodcastAdminControllerGetSpotifyFeedV1
     * @request GET:/api/v1/podcast-admin/spotify-url/{podcastId}
     * @secure
     */
    podcastAdminControllerGetSpotifyFeedV1: (podcastId: number, params: RequestParams = {}) =>
      this.request<FeedSpotifyResponseDto, void | ErrorResponse>({
        path: `/api/v1/podcast-admin/spotify-url/${podcastId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerGetContentChannelsV1
     * @summary Get all content channels
     * @request GET:/api/v1/content-channel-admin
     * @secure
     */
    contentChannelAdminControllerGetContentChannelsV1: (params: RequestParams = {}) =>
      this.request<ContentChannel[], void>({
        path: `/api/v1/content-channel-admin`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerCreateContentChannelV1
     * @summary Create a new content channel
     * @request POST:/api/v1/content-channel-admin
     * @secure
     */
    contentChannelAdminControllerCreateContentChannelV1: (
      data: CreateContentChannelDto,
      params: RequestParams = {},
    ) =>
      this.request<ContentChannel, ErrorResponse | void>({
        path: `/api/v1/content-channel-admin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerUpdateContentChannelV1
     * @request PUT:/api/v1/content-channel-admin/{id}
     * @secure
     */
    contentChannelAdminControllerUpdateContentChannelV1: (
      id: number,
      data: UpdateContentChannelDto,
      params: RequestParams = {},
    ) =>
      this.request<ContentChannel, void | ErrorResponse>({
        path: `/api/v1/content-channel-admin/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerDeleteContentChannelV1
     * @summary Delete a content channel
     * @request DELETE:/api/v1/content-channel-admin/{id}
     * @secure
     */
    contentChannelAdminControllerDeleteContentChannelV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/content-channel-admin/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerGetProductsByContentChannelIdV1
     * @request GET:/api/v1/content-channel-admin/{id}/products
     */
    contentChannelAdminControllerGetProductsByContentChannelIdV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<ContentProductDto[], any>({
        path: `/api/v1/content-channel-admin/${id}/products`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerAddProductToContentChannelV1
     * @request POST:/api/v1/content-channel-admin/{contentChannelId}/products/{productId}
     * @secure
     */
    contentChannelAdminControllerAddProductToContentChannelV1: (
      contentChannelId: number,
      productId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/content-channel-admin/${contentChannelId}/products/${productId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel Admin
     * @name ContentChannelAdminControllerRemoveProductFromContentChannelV1
     * @request DELETE:/api/v1/content-channel-admin/{contentChannelId}/products/{productId}
     * @secure
     */
    contentChannelAdminControllerRemoveProductFromContentChannelV1: (
      contentChannelId: number,
      productId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/content-channel-admin/${contentChannelId}/products/${productId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content Channel
     * @name ContentChannelControllerGetContentChannelsV1
     * @summary Get all content channels
     * @request GET:/api/v1/content-channels
     * @secure
     */
    contentChannelControllerGetContentChannelsV1: (params: RequestParams = {}) =>
      this.request<ContentChannelDto[], void>({
        path: `/api/v1/content-channels`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerGetSettingsV1
     * @summary Get tenants settings
     * @request GET:/api/v1/tenants/settings
     * @secure
     */
    tenantControllerGetSettingsV1: (params: RequestParams = {}) =>
      this.request<TenantResponse, void | ErrorResponse>({
        path: `/api/v1/tenants/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerUpdateSettingsV1
     * @summary Update a tenant settings
     * @request PATCH:/api/v1/tenants/settings
     * @secure
     */
    tenantControllerUpdateSettingsV1: (data: UpdateTenantSettingsDto, params: RequestParams = {}) =>
      this.request<TenantResponse, void | ErrorResponse>({
        path: `/api/v1/tenants/settings`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerUploadSettingsImageV1
     * @summary Upload a tenant settings image
     * @request POST:/api/v1/tenants/settings/images
     * @secure
     */
    tenantControllerUploadSettingsImageV1: (
      data: UploadTenantImageDto,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void | ErrorResponse>({
        path: `/api/v1/tenants/settings/images`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerUploadSettingsFontV1
     * @summary Upload a tenant settings font
     * @request POST:/api/v1/tenants/settings/fonts
     * @secure
     */
    tenantControllerUploadSettingsFontV1: (data: UploadFontDto, params: RequestParams = {}) =>
      this.request<boolean, void | ErrorResponse>({
        path: `/api/v1/tenants/settings/fonts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerFindAllV1
     * @summary Get all tenants
     * @request GET:/api/v1/tenants
     * @secure
     */
    tenantControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/tenants`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerFindOneV1
     * @summary Get a tenant by id
     * @request GET:/api/v1/tenants/{id}
     * @secure
     */
    tenantControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<TenantResponse, ErrorResponse>({
        path: `/api/v1/tenants/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerUpdateV1
     * @summary Update a tenant
     * @request PATCH:/api/v1/tenants/{id}
     * @secure
     */
    tenantControllerUpdateV1: (id: string, data: UpdateTenantDto, params: RequestParams = {}) =>
      this.request<TenantResponse, ErrorResponse>({
        path: `/api/v1/tenants/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerUpdatePreferenceV1
     * @summary Update a tenants preferences
     * @request PATCH:/api/v1/tenants/{id}/preference
     * @secure
     */
    tenantControllerUpdatePreferenceV1: (
      id: string,
      data: TenantPreferenceUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<PreferenceResponseDto, ErrorResponse>({
        path: `/api/v1/tenants/${id}/preference`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantControllerGetTenantDetailsByHostNameV1
     * @summary Get a tenant details by hostname
     * @request GET:/api/v1/tenants/hostname/{hostname}
     * @secure
     */
    tenantControllerGetTenantDetailsByHostNameV1: (hostname: string, params: RequestParams = {}) =>
      this.request<TenantDetailsResponse, ErrorResponse>({
        path: `/api/v1/tenants/hostname/${hostname}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantHostnameControllerGetAvailableHostnamesV1
     * @summary Get all available hostnames. (Not occupied by any brand kit)
     * @request GET:/api/v1/tenants/additional-hostname/available
     * @secure
     */
    tenantHostnameControllerGetAvailableHostnamesV1: (params: RequestParams = {}) =>
      this.request<TenantAdditionalHostnameDto[], void | ErrorResponse>({
        path: `/api/v1/tenants/additional-hostname/available`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantHostnameControllerGetAdditionalHostnamesV1
     * @summary Get additional hostnames of a tenant
     * @request GET:/api/v1/tenants/additional-hostname/{id}
     * @secure
     */
    tenantHostnameControllerGetAdditionalHostnamesV1: (id: string, params: RequestParams = {}) =>
      this.request<TenantAdditionalHostnameDto[], void | ErrorResponse>({
        path: `/api/v1/tenants/additional-hostname/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantHostnameControllerAddAdditionalHostnameV1
     * @summary Add additional hostname to a tenant
     * @request POST:/api/v1/tenants/additional-hostname/{id}
     * @secure
     */
    tenantHostnameControllerAddAdditionalHostnameV1: (
      id: string,
      data: NewTenantAdditionalHostnameDto,
      params: RequestParams = {},
    ) =>
      this.request<TenantAdditionalHostnameDto[], void | ErrorResponse>({
        path: `/api/v1/tenants/additional-hostname/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantHostnameControllerUpdateAdditionalHostnameV1
     * @summary Update additional hostname of a tenant
     * @request PATCH:/api/v1/tenants/additional-hostname/{id}
     * @secure
     */
    tenantHostnameControllerUpdateAdditionalHostnameV1: (
      id: string,
      data: UpdateTenantAdditionalHostnameDto,
      params: RequestParams = {},
    ) =>
      this.request<TenantAdditionalHostnameDto[], void | ErrorResponse>({
        path: `/api/v1/tenants/additional-hostname/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tenant
     * @name TenantHostnameControllerDeleteAdditionalHostnameV1
     * @summary Remove additional hostname of a tenant
     * @request DELETE:/api/v1/tenants/additional-hostname/{id}
     * @secure
     */
    tenantHostnameControllerDeleteAdditionalHostnameV1: (
      id: string,
      data: RemoveTenantAdditionalHostnameDto,
      params: RequestParams = {},
    ) =>
      this.request<TenantAdditionalHostnameDto[], void | ErrorResponse>({
        path: `/api/v1/tenants/additional-hostname/${id}`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brand Kit
     * @name BrandKitControllerGetBrandKitV1
     * @summary Get a brand kit by id
     * @request GET:/api/v1/brand-kits/{id}
     * @secure
     */
    brandKitControllerGetBrandKitV1: (id: string, params: RequestParams = {}) =>
      this.request<BrandKitResponseDto, void | ErrorResponse>({
        path: `/api/v1/brand-kits/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brand Kit
     * @name BrandKitControllerUpdateBrandKitV1
     * @summary Update a brand kit
     * @request POST:/api/v1/brand-kits/{id}
     * @secure
     */
    brandKitControllerUpdateBrandKitV1: (
      id: string,
      data: BrandKitUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<BrandKitResponseDto, void | ErrorResponse>({
        path: `/api/v1/brand-kits/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brand Kit
     * @name BrandKitControllerDeleteBrandKitV1
     * @summary Delete a brand kit
     * @request DELETE:/api/v1/brand-kits/{id}
     * @secure
     */
    brandKitControllerDeleteBrandKitV1: (id: string, params: RequestParams = {}) =>
      this.request<boolean, void | ErrorResponse>({
        path: `/api/v1/brand-kits/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brand Kit
     * @name BrandKitControllerCreateBrandKitV1
     * @summary Create a brand kit
     * @request POST:/api/v1/brand-kits
     * @secure
     */
    brandKitControllerCreateBrandKitV1: (data: BrandKitCreateDto, params: RequestParams = {}) =>
      this.request<BrandKitResponseDto, void | ErrorResponse>({
        path: `/api/v1/brand-kits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brand Kit
     * @name BrandKitControllerGetAllBrandKitsV1
     * @summary Get all brand kits
     * @request GET:/api/v1/brand-kits
     * @secure
     */
    brandKitControllerGetAllBrandKitsV1: (params: RequestParams = {}) =>
      this.request<BrandKitResponseDto[], void | ErrorResponse>({
        path: `/api/v1/brand-kits`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name CacheControllerGetAllKeysV1
     * @summary Get all keys for all cache identifiers
     * @request GET:/api/v1/cache/all
     * @secure
     */
    cacheControllerGetAllKeysV1: (params: RequestParams = {}) =>
      this.request<NetsCardInfo, ErrorResponse>({
        path: `/api/v1/cache/all`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name CacheControllerGetCacheV1
     * @summary Get all keys for a cache identifier
     * @request GET:/api/v1/cache/get/{key}
     * @secure
     */
    cacheControllerGetCacheV1: (key: string, params: RequestParams = {}) =>
      this.request<NetsCardInfo, ErrorResponse>({
        path: `/api/v1/cache/get/${key}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name CacheControllerGetCacheForAnIdentifierV1
     * @summary Get value for a cache identifier
     * @request GET:/api/v1/cache/get/{key}/{identifier}
     * @secure
     */
    cacheControllerGetCacheForAnIdentifierV1: (
      key: string,
      identifier: number,
      params: RequestParams = {},
    ) =>
      this.request<NetsCardInfo, ErrorResponse>({
        path: `/api/v1/cache/get/${key}/${identifier}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name CacheControllerClearCacheV1
     * @summary Clear cache for a key
     * @request DELETE:/api/v1/cache/clear/{key}
     * @secure
     */
    cacheControllerClearCacheV1: (key: string, params: RequestParams = {}) =>
      this.request<string[], ErrorResponse>({
        path: `/api/v1/cache/clear/${key}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cache
     * @name CacheControllerClearCacheForTenantV1
     * @summary Clear cache for a key with identifier
     * @request DELETE:/api/v1/cache/clear/{key}/{identifier}
     * @secure
     */
    cacheControllerClearCacheForTenantV1: (
      key: string,
      identifier: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/cache/clear/${key}/${identifier}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication Activity
     * @name CommunicationActivityControllerHandleSendGridEmailWebhookV1
     * @summary Handle sendgrid email activity webhook and save activity to database
     * @request POST:/api/v1/communication-activity/sendgrid/webhook
     * @secure
     */
    communicationActivityControllerHandleSendGridEmailWebhookV1: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/communication-activity/sendgrid/webhook`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication Activity
     * @name CommunicationActivityControllerHandleSmsWebHookV1
     * @summary Handle teletopia sms activity webhook and save activity to database
     * @request POST:/api/v1/communication-activity/teletopia/webhook
     * @secure
     */
    communicationActivityControllerHandleSmsWebHookV1: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/communication-activity/teletopia/webhook`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication Usage
     * @name CommunicationUsageControllerGetUsageCostV1
     * @summary Get usage with price for emails and SMS, including cost
     * @request GET:/api/v1/communication-usage/cost
     * @secure
     */
    communicationUsageControllerGetUsageCostV1: (params: RequestParams = {}) =>
      this.request<UsageCostDto[], void | ErrorResponse>({
        path: `/api/v1/communication-usage/cost`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerCreateCommunicationSetupV1
     * @summary Create a communication set up
     * @request POST:/api/v1/communications
     * @secure
     */
    communicationControllerCreateCommunicationSetupV1: (
      data: CreateCommunicationDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetAllCommunicationsV1
     * @summary Get all communication set ups
     * @request GET:/api/v1/communications
     * @secure
     */
    communicationControllerGetAllCommunicationsV1: (
      query: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        communicationChannel: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunicationPaginated, void | ErrorResponse>({
        path: `/api/v1/communications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerUpdateCommunicationV1
     * @summary Update a communication set up
     * @request PATCH:/api/v1/communications/{id}
     * @secure
     */
    communicationControllerUpdateCommunicationV1: (
      id: number,
      data: UpdateCommunicationDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerDeleteCommunicationV1
     * @summary Delete a communication set up
     * @request DELETE:/api/v1/communications/{id}
     * @secure
     */
    communicationControllerDeleteCommunicationV1: (id: number, params: RequestParams = {}) =>
      this.request<NetsCardInfo, void | ErrorResponse>({
        path: `/api/v1/communications/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerCommunicateV1
     * @summary Send SMS/Email to members of a list by communication ID
     * @request POST:/api/v1/communications/{id}
     * @secure
     */
    communicationControllerCommunicateV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/communications/${id}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetCommunicationV1
     * @summary Get a communication set up
     * @request GET:/api/v1/communications/{id}
     * @secure
     */
    communicationControllerGetCommunicationV1: (id: number, params: RequestParams = {}) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetAllEmailsOfTenantV1
     * @summary Get all emails of users tenant
     * @request GET:/api/v1/communications/email/list
     * @secure
     */
    communicationControllerGetAllEmailsOfTenantV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunicationPaginated, void | ErrorResponse>({
        path: `/api/v1/communications/email/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerSendOneOffEmailV1
     * @summary Send a one off email
     * @request POST:/api/v1/communications/one-off/email
     * @secure
     */
    communicationControllerSendOneOffEmailV1: (
      data: SendOneOffEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/communications/one-off/email`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Allows authenticated tenants to send emails using the platform email service
     *
     * @tags Communications
     * @name CommunicationControllerHandleSendEmailRequestV1
     * @summary Email Service API
     * @request POST:/api/v1/communications/email/send
     * @secure
     */
    communicationControllerHandleSendEmailRequestV1: (
      data: SendEmailThirdPartyDto,
      params: RequestParams = {},
    ) =>
      this.request<ThirdPartyEmailResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Allows authenticated tenants to send sms using the platform email service
     *
     * @tags Communications
     * @name CommunicationControllerSendSingleSmsV1
     * @summary SMS Service API
     * @request POST:/api/v1/communications/send-single-sms
     * @secure
     */
    communicationControllerSendSingleSmsV1: (
      data: CreateSendSingleSmsDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/communications/send-single-sms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Allows authenticated tenants to send test email using the platform email service
     *
     * @tags Communications
     * @name CommunicationControllerSendThirdpartyPreviewEmailV1
     * @summary Test a third party email
     * @request POST:/api/v1/communications/email/test
     * @secure
     */
    communicationControllerSendThirdpartyPreviewEmailV1: (
      data: PreviewThirdPartyEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailTestResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/test`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerScheduleThirdPartyEmailV1
     * @summary Schedule a third party email
     * @request POST:/api/v1/communications/email/schedule
     * @secure
     */
    communicationControllerScheduleThirdPartyEmailV1: (
      data: ScheduleThirdPartyEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<ThirdPartyEmailResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/schedule`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerScheduleEmailV1
     * @summary Schedule an email by communication id
     * @request POST:/api/v1/communications/{id}/email/schedule
     * @secure
     */
    communicationControllerScheduleEmailV1: (
      id: number,
      data: ScheduleEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailScheduleResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/email/schedule`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetPersonalizedTokensForSendEmailToListV1
     * @summary Get personalized tokens for email communication
     * @request GET:/api/v1/communications/email/tokens
     * @secure
     */
    communicationControllerGetPersonalizedTokensForSendEmailToListV1: (
      params: RequestParams = {},
    ) =>
      this.request<CommunicationPersonalizedTokenDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/tokens`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetCommunicationTemplatesV1
     * @summary Get communication  email templates
     * @request GET:/api/v1/communications/email/templates
     * @secure
     */
    communicationControllerGetCommunicationTemplatesV1: (params: RequestParams = {}) =>
      this.request<CommunicationTemplate[], void | ErrorResponse>({
        path: `/api/v1/communications/email/templates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetSenderByChannelV1
     * @summary Get all email sender
     * @request GET:/api/v1/communications/email/senders
     * @secure
     */
    communicationControllerGetSenderByChannelV1: (params: RequestParams = {}) =>
      this.request<CommunicationSender[], void | ErrorResponse>({
        path: `/api/v1/communications/email/senders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerUpdateCommunicationThidpartyV1
     * @summary Update a communication set up for third party
     * @request PATCH:/api/v1/communications/email/edit/{id}
     * @secure
     */
    communicationControllerUpdateCommunicationThidpartyV1: (
      id: number,
      data: UpdateEmailM2MDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/edit/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerScheduleCommunicationV1
     * @summary Schedule a communication
     * @request POST:/api/v1/communications/{id}/schedule
     * @secure
     */
    communicationControllerScheduleCommunicationV1: (
      id: number,
      data: ScheduleCommunicationDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/schedule`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerCancelCommunicationV1
     * @summary Cancel a communication schedule
     * @request POST:/api/v1/communications/{id}/schedule/cancel
     * @secure
     */
    communicationControllerCancelCommunicationV1: (id: number, params: RequestParams = {}) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/schedule/cancel`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerSendPreviewSmsV1
     * @summary Send a test SMS using the given communication ID to verify SMS content
     * @request POST:/api/v1/communications/{id}/test/sms
     * @secure
     */
    communicationControllerSendPreviewSmsV1: (
      id: number,
      data: TestCommunicateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/test/sms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerSendPreviewEmailV1
     * @summary Send a test email using the given communication ID to verify email content
     * @request POST:/api/v1/communications/{id}/email/test
     * @secure
     */
    communicationControllerSendPreviewEmailV1: (
      id: number,
      data: PreviewEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<EmailTestResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/email/test`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerPreviewCommunicationMembersV1
     * @summary Preview communication members
     * @request GET:/api/v1/communications/{id}/members/preview
     * @secure
     */
    communicationControllerPreviewCommunicationMembersV1: (
      id: number,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunicationMembersResponseDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/members/preview`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetCommunicatedMembersV1
     * @summary Get communicated members
     * @request GET:/api/v1/communications/{id}/members/communicated
     * @secure
     */
    communicationControllerGetCommunicatedMembersV1: (
      id: number,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunicationMembersResponseDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/members/communicated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetCommunicationStatsV1
     * @summary Get communication stats
     * @request GET:/api/v1/communications/{id}/stats
     * @secure
     */
    communicationControllerGetCommunicationStatsV1: (id: number, params: RequestParams = {}) =>
      this.request<CommunicationStatsResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerUploadTemplateImageV1
     * @summary Upload template image
     * @request POST:/api/v1/communications/template-image/upload
     * @secure
     */
    communicationControllerUploadTemplateImageV1: (
      data: UploadTemplateImageDto,
      params: RequestParams = {},
    ) =>
      this.request<TemplateImageUploadResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/template-image/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetEmailActivityStatisticsV1
     * @summary Get email activity statistics
     * @request GET:/api/v1/communications/email/statistics/{id}
     * @secure
     */
    communicationControllerGetEmailActivityStatisticsV1: (id: number, params: RequestParams = {}) =>
      this.request<EmailStatsResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/email/statistics/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerCopyCommunicationV1
     * @summary Copy a communication setup
     * @request POST:/api/v1/communications/{id}/copy
     * @secure
     */
    communicationControllerCopyCommunicationV1: (id: number, params: RequestParams = {}) =>
      this.request<CommunicationResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/${id}/copy`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetNewsletterByCommunicationIdV1
     * @summary Get newsletter by communication id
     * @request GET:/api/v1/communications/newsletter/communication/{id}
     * @secure
     */
    communicationControllerGetNewsletterByCommunicationIdV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<NewsletterMessageIdResponseDto, void | ErrorResponse>({
        path: `/api/v1/communications/newsletter/communication/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communications
     * @name CommunicationControllerGetNewsletterByMessageIdV1
     * @summary Get newsletter by message id
     * @request GET:/api/v1/communications/newsletter/{id}
     * @secure
     */
    communicationControllerGetNewsletterByMessageIdV1: (id: string, params: RequestParams = {}) =>
      this.request<NewsletterResponseDto, ErrorResponse>({
        path: `/api/v1/communications/newsletter/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerCreateV1
     * @summary Create a new segment
     * @request POST:/api/v1/segments
     * @secure
     */
    segmentationControllerCreateV1: (data: CreateSegmentDto, params: RequestParams = {}) =>
      this.request<SegmentResponse, ErrorResponse | void>({
        path: `/api/v1/segments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetSegmentsV1
     * @summary Get segments
     * @request GET:/api/v1/segments
     * @secure
     */
    segmentationControllerGetSegmentsV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<SegmentResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/segments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerUpdateV1
     * @summary Update a segment
     * @request PATCH:/api/v1/segments/{id}
     * @secure
     */
    segmentationControllerUpdateV1: (
      id: number,
      data: CreateSegmentDto,
      params: RequestParams = {},
    ) =>
      this.request<SegmentResponse, ErrorResponse | void>({
        path: `/api/v1/segments/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetSegmentByIdV1
     * @summary Get a segment by id
     * @request GET:/api/v1/segments/{id}
     * @secure
     */
    segmentationControllerGetSegmentByIdV1: (id: number, params: RequestParams = {}) =>
      this.request<SegmentResponse, void | ErrorResponse>({
        path: `/api/v1/segments/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerDeleteSegmentV1
     * @summary Delete a segment
     * @request DELETE:/api/v1/segments/{id}
     * @secure
     */
    segmentationControllerDeleteSegmentV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/segments/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetAllPublishedSegmentsV1
     * @summary Get all published segments
     * @request GET:/api/v1/segments/published
     * @secure
     */
    segmentationControllerGetAllPublishedSegmentsV1: (params: RequestParams = {}) =>
      this.request<Segment[], void | ErrorResponse>({
        path: `/api/v1/segments/published`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetSegmentationEntityAndAttributesV1
     * @summary Get segmentation entity and attributes
     * @request GET:/api/v1/segments/attributes
     * @secure
     */
    segmentationControllerGetSegmentationEntityAndAttributesV1: (params: RequestParams = {}) =>
      this.request<NetsCardInfo, void | ErrorResponse>({
        path: `/api/v1/segments/attributes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetMembersV1
     * @summary Get members of a segment
     * @request GET:/api/v1/segments/{id}/members
     * @secure
     */
    segmentationControllerGetMembersV1: (
      id: number,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<SegmentMemberResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/segments/${id}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerGetMemberCountV1
     * @summary Get member count of a segment
     * @request GET:/api/v1/segments/{id}/member-count
     * @secure
     */
    segmentationControllerGetMemberCountV1: (id: number, params: RequestParams = {}) =>
      this.request<number, void | ErrorResponse>({
        path: `/api/v1/segments/${id}/member-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segments
     * @name SegmentationControllerPreviewV1
     * @summary Preview segment result
     * @request POST:/api/v1/segments/preview
     * @secure
     */
    segmentationControllerPreviewV1: (
      data: JsonQuery,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<MemberPaginated, void | ErrorResponse>({
        path: `/api/v1/segments/preview`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerGetPublishableKeyV1
     * @summary Get the publishable key for stripe
     * @request GET:/api/v1/payments/stripe/publishable-key
     * @secure
     */
    stripeControllerGetPublishableKeyV1: (
      query: {
        tenantId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublishableKeyResponse, ErrorResponse>({
        path: `/api/v1/payments/stripe/publishable-key`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerCreateIntentV1
     * @summary Create a new stripe payment intent
     * @request POST:/api/v1/payments/stripe/intent
     * @secure
     */
    stripeControllerCreateIntentV1: (data: CreateIntentDto, params: RequestParams = {}) =>
      this.request<StripeCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/stripe/intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerCreateIntentFromOrderV1
     * @request POST:/api/v1/payments/stripe/order-intent
     * @secure
     */
    stripeControllerCreateIntentFromOrderV1: (
      data: CreateIntentFromOrderDto,
      params: RequestParams = {},
    ) =>
      this.request<StripeCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/stripe/order-intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerCreateSetupIntentV1
     * @summary Create a new stripe setup intent
     * @request POST:/api/v1/payments/stripe/setup-intent
     * @secure
     */
    stripeControllerCreateSetupIntentV1: (data: CreateSetupIntentDto, params: RequestParams = {}) =>
      this.request<StripeCreateIntentResponse, void | ErrorResponse>({
        path: `/api/v1/payments/stripe/setup-intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerRecurrentPaymentsV1
     * @summary Queue recurrent payments
     * @request POST:/api/v1/payments/stripe/recurrent-payments
     * @secure
     */
    stripeControllerRecurrentPaymentsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payments/stripe/recurrent-payments`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Stripe Payment
     * @name StripeControllerWebhookV1
     * @summary Stripe webhook
     * @request POST:/api/v1/payments/stripe/webhook/{tenantId}
     * @secure
     */
    stripeControllerWebhookV1: (tenantId: number, params: RequestParams = {}) =>
      this.request<WebhookResponse, ErrorResponse>({
        path: `/api/v1/payments/stripe/webhook/${tenantId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerSubscribeViaFakturaV1
     * @summary Subscribe a package via external payment
     * @request POST:/api/v1/payment/subscription/external
     * @secure
     */
    paymentControllerSubscribeViaFakturaV1: (
      data: FakturaPackageSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<FakturaPaymentResponseDto, void | ErrorResponse>({
        path: `/api/v1/payment/subscription/external`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerDeactivateExternalSubscriptionsWithGracePeriodV1
     * @summary deactivate subscriptions for external payment of nth days of being unpaid
     * @request GET:/api/v1/payment/external/grace-deactivate
     * @secure
     */
    paymentControllerDeactivateExternalSubscriptionsWithGracePeriodV1: (
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/external/grace-deactivate`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerTurnOffExpiredSubscriptionsForAllV1
     * @summary Turn off subscriptions  with auto renewal turned off
     * @request POST:/api/v1/payment/turn-off-inactives
     * @secure
     */
    paymentControllerTurnOffExpiredSubscriptionsForAllV1: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payment/turn-off-inactives`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerEnqueueScheduleActivateSubscriptionsV1
     * @summary Activate scheduled subscriptions
     * @request GET:/api/v1/payment/enqueue-schedule-activate-subscriptions
     * @secure
     */
    paymentControllerEnqueueScheduleActivateSubscriptionsV1: (params: RequestParams = {}) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/enqueue-schedule-activate-subscriptions`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGetOrderDetailsV1
     * @summary Get order details
     * @request GET:/api/v1/payment/order/{orderId}
     * @secure
     */
    paymentControllerGetOrderDetailsV1: (orderId: number, params: RequestParams = {}) =>
      this.request<any, ErrorResponse | OrderResponse>({
        path: `/api/v1/payment/order/${orderId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerGeneratePaymentLinkV1
     * @summary Generate a payment link for a member package
     * @request GET:/api/v1/payment/generate-payment-link/{memberPackageId}
     * @secure
     */
    paymentControllerGeneratePaymentLinkV1: (memberPackageId: number, params: RequestParams = {}) =>
      this.request<any, ErrorResponse | void>({
        path: `/api/v1/payment/generate-payment-link/${memberPackageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerCreatePaymentFromAdminV1
     * @summary Create payment
     * @request POST:/api/v1/payment/create
     * @secure
     */
    paymentControllerCreatePaymentFromAdminV1: (
      data: CreatePaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorResponse | void>({
        path: `/api/v1/payment/create`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerUpdatePaymentDateFromAdminV1
     * @summary Update payment date
     * @request PATCH:/api/v1/payment/payment-date
     * @secure
     */
    paymentControllerUpdatePaymentDateFromAdminV1: (
      data: UpdatePaymentDateDto,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorResponse | void>({
        path: `/api/v1/payment/payment-date`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerCreateRefundV1
     * @summary Create refund
     * @request POST:/api/v1/payment/refund
     * @secure
     */
    paymentControllerCreateRefundV1: (data: CreateRefundDto, params: RequestParams = {}) =>
      this.request<any, ErrorResponse | void>({
        path: `/api/v1/payment/refund`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerRestartSubscriptionV1
     * @summary Restart a stopped/expired/inactive subscription
     * @request POST:/api/v1/payment/restart-subscription
     * @secure
     */
    paymentControllerRestartSubscriptionV1: (
      data: RestartSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorResponse | void>({
        path: `/api/v1/payment/restart-subscription`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddNewOrderEinvoiceUnpaid2DaysBeforeInvoiceDueDateEventToQueueV1
     * @summary Queue new order einvoice unpaid 2 days before invoice due date
     * @request POST:/api/v1/payment/new-order-einvoice-unpaid-2-days-before-invoice-due-date
     * @secure
     */
    paymentControllerAddNewOrderEinvoiceUnpaid2DaysBeforeInvoiceDueDateEventToQueueV1: (
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/new-order-einvoice-unpaid-2-days-before-invoice-due-date`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddNewOrderEinvoiceUnpaid0DaysBeforeInvoiceDueDateEventToQueueV1
     * @summary Queue new order einvoice unpaid 0 days before invoice due date
     * @request POST:/api/v1/payment/new-order-einvoice-unpaid-0-days-before-invoice-due-date
     * @secure
     */
    paymentControllerAddNewOrderEinvoiceUnpaid0DaysBeforeInvoiceDueDateEventToQueueV1: (
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/new-order-einvoice-unpaid-0-days-before-invoice-due-date`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddNewOrderEinvoiceUnpaid2DaysBeforeSubscriptionForcedStopDateEventToQueueV1
     * @summary Queue new order einvoice unpaid 2 days before subscription forced stop date
     * @request POST:/api/v1/payment/new-order-einvoice-unpaid-2-days-before-subscription-forced-stop-date
     * @secure
     */
    paymentControllerAddNewOrderEinvoiceUnpaid2DaysBeforeSubscriptionForcedStopDateEventToQueueV1: (
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/new-order-einvoice-unpaid-2-days-before-subscription-forced-stop-date`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddNewOrderEinvoiceUnpaid5DaysAfterSubscriptionForcedStopDateEventToQueueV1
     * @summary Queue new order einvoice unpaid 5 days after subscription forced stop date
     * @request POST:/api/v1/payment/new-order-einvoice-unpaid-5-days-after-subscription-forced-stop-date
     * @secure
     */
    paymentControllerAddNewOrderEinvoiceUnpaid5DaysAfterSubscriptionForcedStopDateEventToQueueV1: (
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/payment/new-order-einvoice-unpaid-5-days-after-subscription-forced-stop-date`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice2DaysBeforeSendRecurringInvoiceAutorenewTrueEventToQueueV1
     * @summary Queue recurring order invoice 2 days before send recurring invoice autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-2-days-before-send-recurring-invoice-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice2DaysBeforeSendRecurringInvoiceAutorenewTrueEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-2-days-before-send-recurring-invoice-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice1DayAfterSendRecurringInvoiceAutorenewTrueEventToQueueV1
     * @summary Queue recurring order invoice 1 day after send recurring invoice autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-1-day-after-send-recurring-invoice-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice1DayAfterSendRecurringInvoiceAutorenewTrueEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-1-day-after-send-recurring-invoice-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice2DaysBeforeInvoiceDueDateNotPaidInvoiceAutorenewTrueEventToQueueV1
     * @summary Queue recurring order invoice 2 days before invoice due date not paid autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-2-days-before-invoice-due-date-not-paid-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice2DaysBeforeInvoiceDueDateNotPaidInvoiceAutorenewTrueEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-2-days-before-invoice-due-date-not-paid-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice0DayBeforeSendRecurringInvoiceAutorenewTrueEventToQueueV1
     * @summary Queue recurring order invoice 0/ due date day before send recurring invoice autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-0-day-before-send-recurring-invoice-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice0DayBeforeSendRecurringInvoiceAutorenewTrueEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-0-day-before-send-recurring-invoice-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice1DayAfterSubscriptionStoppedDueToNonPaymentEventToQueueV1
     * @summary Queue recurring order invoice 1 day after subscription stopped due to non-payment autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-1-day-after-subscription-stopped-due-to-non-payment-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice1DayAfterSubscriptionStoppedDueToNonPaymentEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-1-day-after-subscription-stopped-due-to-non-payment-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAddRecurringOrderInvoice7DaysAfterSubscriptionStoppedDueToNonPaymentEventToQueueV1
     * @summary Queue recurring order invoice 7 days after subscription stopped due to non-payment autorenew true
     * @request POST:/api/v1/payment/recurring-order-invoice-7-days-after-subscription-stopped-due-to-non-payment-autorenew-true
     * @secure
     */
    paymentControllerAddRecurringOrderInvoice7DaysAfterSubscriptionStoppedDueToNonPaymentEventToQueueV1:
      (params: RequestParams = {}) =>
        this.request<any, void | ErrorResponse>({
          path: `/api/v1/payment/recurring-order-invoice-7-days-after-subscription-stopped-due-to-non-payment-autorenew-true`,
          method: 'POST',
          secure: true,
          ...params,
        }),

    /**
     * No description
     *
     * @tags Payment
     * @name PaymentControllerAutoRenewVippsSubscriptionWithPaymentV1
     * @summary Subscription auto renew with payment
     * @request POST:/api/v1/payment/subscription-auto-renew-with-payment
     * @secure
     */
    paymentControllerAutoRenewVippsSubscriptionWithPaymentV1: (
      data: SubscriptionAutoRenewWithPaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorResponse>({
        path: `/api/v1/payment/subscription-auto-renew-with-payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerCreateIntentV1
     * @request POST:/api/v1/payments/vipps/intent
     * @secure
     */
    vippsControllerCreateIntentV1: (data: CreateIntentDto, params: RequestParams = {}) =>
      this.request<VippsCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/vipps/intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerCreateIntentFromOrderV1
     * @request POST:/api/v1/payments/vipps/order-intent
     * @secure
     */
    vippsControllerCreateIntentFromOrderV1: (
      data: CreateIntentFromOrderDto,
      params: RequestParams = {},
    ) =>
      this.request<VippsCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/vipps/order-intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerCallBackV1
     * @request GET:/api/v1/payments/vipps/callback
     * @secure
     */
    vippsControllerCallBackV1: (
      query: {
        externalId: string;
        tenantId: number;
        packageId?: number;
        orderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/vipps/callback`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerWebhookV1
     * @request POST:/api/v1/payments/vipps/webhook/{tenantId}
     * @secure
     */
    vippsControllerWebhookV1: (tenantId: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/vipps/webhook/${tenantId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerQueueVippsRecurringPaymentsV1
     * @request POST:/api/v1/payments/vipps/recurrent-payments
     * @secure
     */
    vippsControllerQueueVippsRecurringPaymentsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payments/vipps/recurrent-payments`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Get agreement details from Vipps
     *
     * @tags Vipps Payment
     * @name VippsControllerGetAgreementV1
     * @summary Get agreement details
     * @request GET:/api/v1/payments/vipps/agreement/{agreementId}
     * @secure
     */
    vippsControllerGetAgreementV1: (agreementId: string, params: RequestParams = {}) =>
      this.request<NetsCardInfo, void | ErrorResponse>({
        path: `/api/v1/payments/vipps/agreement/${agreementId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerCancelChargeV1
     * @request GET:/api/v1/payments/vipps/agreement/{agreementId}/cancel/{chargeId}
     * @secure
     */
    vippsControllerCancelChargeV1: (
      agreementId: string,
      chargeId: string,
      params: RequestParams = {},
    ) =>
      this.request<NetsCardInfo, ErrorResponse | void>({
        path: `/api/v1/payments/vipps/agreement/${agreementId}/cancel/${chargeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerPauseDueSubscriptionsV1
     * @request GET:/api/v1/payments/vipps/pause-due-subscriptions
     * @secure
     */
    vippsControllerPauseDueSubscriptionsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payments/vipps/pause-due-subscriptions`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vipps Payment
     * @name VippsControllerQueueUpdateDueChargesV1
     * @request GET:/api/v1/payments/vipps/queue-update-due-charges
     * @secure
     */
    vippsControllerQueueUpdateDueChargesV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payments/vipps/queue-update-due-charges`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerFindByUuidV1
     * @summary Get a checkout-state by uuid
     * @request GET:/api/v1/checkout-state/{uuid}
     * @secure
     */
    checkoutStateControllerFindByUuidV1: (uuid: string, params: RequestParams = {}) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerAccountCheckV1
     * @summary check account and create checkout state for existing member
     * @request POST:/api/v1/checkout-state/account-check
     * @secure
     */
    checkoutStateControllerAccountCheckV1: (data: AccountCheckDto, params: RequestParams = {}) =>
      this.request<AccountCheckResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/account-check`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerAccountCheckUpdateV1
     * @summary check account and update checkout state for existing member
     * @request PATCH:/api/v1/checkout-state/{uuid}/account-check
     * @secure
     */
    checkoutStateControllerAccountCheckUpdateV1: (
      uuid: string,
      data: AccountCheckDto,
      params: RequestParams = {},
    ) =>
      this.request<AccountCheckResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/account-check`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerUpdateProfileV1
     * @summary Update logged in member profile and checkout state
     * @request PATCH:/api/v1/checkout-state/{uuid}/update-profile
     * @secure
     */
    checkoutStateControllerUpdateProfileV1: (
      uuid: string,
      data: UpdateMemberPersonalInfo,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/update-profile`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerPopulateGroupMemberAndPhysicalProductDataV1
     * @summary Populate group member and physical product data
     * @request PATCH:/api/v1/checkout-state/{uuid}/populate-group-and-product
     * @secure
     */
    checkoutStateControllerPopulateGroupMemberAndPhysicalProductDataV1: (
      uuid: string,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/populate-group-and-product`,
        method: 'PATCH',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerInviteToProductSeatV1
     * @summary Invite member to a product seat
     * @request POST:/api/v1/checkout-state/{uuid}/invite
     * @secure
     */
    checkoutStateControllerInviteToProductSeatV1: (
      uuid: string,
      data: InviteSeatDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, void | ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerCreateAdditionalMemberV1
     * @summary Create additional member for a product seat
     * @request POST:/api/v1/checkout-state/{uuid}/create-additional-member
     * @secure
     */
    checkoutStateControllerCreateAdditionalMemberV1: (
      uuid: string,
      data: CreateAdditionalMemberDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/create-additional-member`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerCompleteAdditionalMemberV1
     * @summary Complete additional members creation step
     * @request POST:/api/v1/checkout-state/{uuid}/complete-additional-member
     * @secure
     */
    checkoutStateControllerCompleteAdditionalMemberV1: (uuid: string, params: RequestParams = {}) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/complete-additional-member`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerAssignDefaultGiftReceiversV1
     * @summary Assign default gift receiver data and store it in the checkout state
     * @request POST:/api/v1/checkout-state/{uuid}/assign-default-gift-receivers
     * @secure
     */
    checkoutStateControllerAssignDefaultGiftReceiversV1: (
      uuid: string,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/assign-default-gift-receivers`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerCreateGiftReceiverV1
     * @summary Create gift receiver for a product seat
     * @request POST:/api/v1/checkout-state/{uuid}/create-gift-receiver
     * @secure
     */
    checkoutStateControllerCreateGiftReceiverV1: (
      uuid: string,
      data: CreateGiftReceiverDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/create-gift-receiver`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerCompleteGiftReceiverV1
     * @summary Complete gift receiver step
     * @request POST:/api/v1/checkout-state/{uuid}/complete-gift-receiver
     * @secure
     */
    checkoutStateControllerCompleteGiftReceiverV1: (
      uuid: string,
      data: CompleteGiftReceiverDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/complete-gift-receiver`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerUpdateGiftReceiverAddressV1
     * @summary Update gift receiver address of a physical product seat
     * @request POST:/api/v1/checkout-state/{uuid}/update-gift-receiver-addresses
     * @secure
     */
    checkoutStateControllerUpdateGiftReceiverAddressV1: (
      uuid: string,
      data: SaveDeliveryAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, void | ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/update-gift-receiver-addresses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerSaveDeliveryAddressV1
     * @summary Save delivery address of a physical product seat
     * @request POST:/api/v1/checkout-state/{uuid}/save-delivery-addresses
     * @secure
     */
    checkoutStateControllerSaveDeliveryAddressV1: (
      uuid: string,
      data: SaveDeliveryAddressDto,
      params: RequestParams = {},
    ) =>
      this.request<CheckoutStateResponse, void | ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/save-delivery-addresses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Checkout State
     * @name CheckoutStateControllerCompleteConsentInfoV1
     * @summary Complete consent info step
     * @request POST:/api/v1/checkout-state/{uuid}/complete-consent
     * @secure
     */
    checkoutStateControllerCompleteConsentInfoV1: (uuid: string, params: RequestParams = {}) =>
      this.request<CheckoutStateResponse, ErrorResponse>({
        path: `/api/v1/checkout-state/${uuid}/complete-consent`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerCreateIntentV1
     * @request POST:/api/v1/payments/nets/intent
     * @secure
     */
    netsControllerCreateIntentV1: (data: CreateIntentDto, params: RequestParams = {}) =>
      this.request<NetsCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/nets/intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerCreateIntentFromOrderV1
     * @request POST:/api/v1/payments/nets/order-intent
     * @secure
     */
    netsControllerCreateIntentFromOrderV1: (
      data: CreateIntentFromOrderDto,
      params: RequestParams = {},
    ) =>
      this.request<NetsCreateIntentResponse, ErrorResponse>({
        path: `/api/v1/payments/nets/order-intent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerGetCardChangeUrlV1
     * @request GET:/api/v1/payments/nets/card-change-url
     * @secure
     */
    netsControllerGetCardChangeUrlV1: (
      query: {
        memberPackageId: number;
        redirectUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NetsUpdateCardResponse, ErrorResponse>({
        path: `/api/v1/payments/nets/card-change-url`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerUpdateCardV1
     * @request GET:/api/v1/payments/nets/card-change
     * @secure
     */
    netsControllerUpdateCardV1: (
      query: {
        subscriptionId: string;
        redirectUrl: string;
        tenantId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/nets/card-change`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerGetSubscriptionUrlV1
     * @summary Get checkout url to subscribe nets as a provider without initial charge
     * @request GET:/api/v1/payments/nets/subscription-url
     * @secure
     */
    netsControllerGetSubscriptionUrlV1: (
      query: {
        memberPackageId: number;
        redirectUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NetsCreateSubscriptionResponse, void | ErrorResponse>({
        path: `/api/v1/payments/nets/subscription-url`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerGetSubscriptionUrlForAMemberV1
     * @summary Get checkout url to subscribe nets as a provider without initial charge on behalf of a member
     * @request GET:/api/v1/payments/nets/subscription-url/{memberId}
     * @secure
     */
    netsControllerGetSubscriptionUrlForAMemberV1: (
      memberId: string,
      query: {
        memberPackageId: number;
        redirectUrl: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NetsCreateSubscriptionResponse, void | ErrorResponse>({
        path: `/api/v1/payments/nets/subscription-url/${memberId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerCallBackV1
     * @request GET:/api/v1/payments/nets/callback
     * @secure
     */
    netsControllerCallBackV1: (
      query: {
        reference: string;
        tenantId: number;
        packageId?: number;
        orderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/nets/callback`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerWebhookV1
     * @request POST:/api/v1/payments/nets/webhook/{tenantId}/{reference}
     * @secure
     */
    netsControllerWebhookV1: (tenantId: number, reference: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/nets/webhook/${tenantId}/${reference}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerWebhookForHandlingChangingProviderToNetsV1
     * @summary Webhook to add nets as a payment provider to a subscription
     * @request POST:/api/v1/payments/nets/webhook/change-payment-provider/{tenantId}/{memberPackageId}
     * @secure
     */
    netsControllerWebhookForHandlingChangingProviderToNetsV1: (
      tenantId: number,
      memberPackageId: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payments/nets/webhook/change-payment-provider/${tenantId}/${memberPackageId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nets Payment
     * @name NetsControllerQueueNetsRecurringPaymentsV1
     * @request POST:/api/v1/payments/nets/recurrent-payments
     * @secure
     */
    netsControllerQueueNetsRecurringPaymentsV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payments/nets/recurrent-payments`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerUpdateConfigV1
     * @summary Update payment provider configuration
     * @request PATCH:/api/v1/payment-provider/config
     * @secure
     */
    paymentProviderControllerUpdateConfigV1: (
      data: UpdatePaymentProviderConfigDto,
      params: RequestParams = {},
    ) =>
      this.request<PaymentProviderConfig, void | ErrorResponse>({
        path: `/api/v1/payment-provider/config`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerChangePaymentProviderToExternalV1
     * @summary Route to add external as a payment provider to a subscription
     * @request POST:/api/v1/payment-provider/change-external
     * @secure
     */
    paymentProviderControllerChangePaymentProviderToExternalV1: (
      data: ChangePaymentProviderAsExternalReqDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/payment-provider/change-external`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerChangePaymentProviderToExternalByAdminV1
     * @summary Route to add external as a payment provider to a subscription by admin
     * @request POST:/api/v1/payment-provider/change-external/{memberId}
     * @secure
     */
    paymentProviderControllerChangePaymentProviderToExternalByAdminV1: (
      memberId: string,
      query: {
        memberId: string;
      },
      data: ChangePaymentProviderAsExternalReqDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payment-provider/change-external/${memberId}`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerGetAllowedPaymentProvidersV1
     * @summary Get available payment providers on my page and admin page
     * @request GET:/api/v1/payment-provider
     * @secure
     */
    paymentProviderControllerGetAllowedPaymentProvidersV1: (
      query?: {
        showOnMyPage?: boolean;
        showOnAdmin?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaymentProviderResponse[], ErrorResponse>({
        path: `/api/v1/payment-provider`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerGetPaymentProviderSettingsByIdV1
     * @summary Get payment provider settings for admin page by id
     * @request GET:/api/v1/payment-provider/settings/{id}
     * @secure
     */
    paymentProviderControllerGetPaymentProviderSettingsByIdV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<PaymentProviderSettingsResponse, void | ErrorResponse>({
        path: `/api/v1/payment-provider/settings/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerUpdatePaymentProviderSettingsV1
     * @summary Update payment provider settings for admin page
     * @request PATCH:/api/v1/payment-provider/settings/{id}
     * @secure
     */
    paymentProviderControllerUpdatePaymentProviderSettingsV1: (
      id: number,
      data: PaymentProviderSettingsDto,
      params: RequestParams = {},
    ) =>
      this.request<PaymentProviderSettingsResponse, void | ErrorResponse>({
        path: `/api/v1/payment-provider/settings/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerCreatePaymentProviderSettingsV1
     * @summary Create payment provider settings for admin page
     * @request POST:/api/v1/payment-provider/settings
     * @secure
     */
    paymentProviderControllerCreatePaymentProviderSettingsV1: (
      data: PaymentProviderSettingsDto,
      params: RequestParams = {},
    ) =>
      this.request<PaymentProviderSettingsResponse, void | ErrorResponse>({
        path: `/api/v1/payment-provider/settings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerGetPaymentProviderSettingsV1
     * @summary Get payment provider settings for admin page
     * @request GET:/api/v1/payment-provider/settings
     * @secure
     */
    paymentProviderControllerGetPaymentProviderSettingsV1: (params: RequestParams = {}) =>
      this.request<PaymentProviderSettingsResponse[], void | ErrorResponse>({
        path: `/api/v1/payment-provider/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerGetAllowedPaymentProvidersOnSubscriptionPlanV1
     * @summary Get available payment providers on a subscription plan
     * @request GET:/api/v1/payment-provider/subscription-plan/{id}
     * @secure
     */
    paymentProviderControllerGetAllowedPaymentProvidersOnSubscriptionPlanV1: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<string[], ErrorResponse>({
        path: `/api/v1/payment-provider/subscription-plan/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payment-Provider
     * @name PaymentProviderControllerClearWebhookSecretV1
     * @summary Clear webhook secret for a payment provider
     * @request DELETE:/api/v1/payment-provider/clear-webhook-secret/{providerName}
     * @secure
     */
    paymentProviderControllerClearWebhookSecretV1: (
      providerName: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/payment-provider/clear-webhook-secret/${providerName}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerSubscribeViaEInvoiceV1
     * @summary Subscribe a package via invoice payment
     * @request POST:/api/v1/e-invoice/subscribe
     * @secure
     */
    eInvoiceControllerSubscribeViaEInvoiceV1: (
      data: FakturaPackageSubscriptionDto,
      params: RequestParams = {},
    ) =>
      this.request<FakturaPaymentResponseDto, void | ErrorResponse>({
        path: `/api/v1/e-invoice/subscribe`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerSendRecurringInvoicesV1
     * @summary Send recurring invoices to members
     * @request POST:/api/v1/e-invoice/send-recurring-invoices
     * @secure
     */
    eInvoiceControllerSendRecurringInvoicesV1: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/e-invoice/send-recurring-invoices`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerGetInvoiceListV1
     * @summary Get submitted invoices from Orbyt
     * @request GET:/api/v1/e-invoice/orbyt/invoice-list/{memberId}
     * @secure
     */
    eInvoiceControllerGetInvoiceListV1: (memberId: string, params: RequestParams = {}) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/e-invoice/orbyt/invoice-list/${memberId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerGetInvoiceStatusV1
     * @summary Get invoice status from Orbyt
     * @request GET:/api/v1/e-invoice/orbyt/invoice-status/{kid}
     * @secure
     */
    eInvoiceControllerGetInvoiceStatusV1: (kid: string, params: RequestParams = {}) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/e-invoice/orbyt/invoice-status/${kid}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerRenewEInvoicesV1
     * @summary Renew e-invoices
     * @request GET:/api/v1/e-invoice/renew-e-invoices
     * @secure
     */
    eInvoiceControllerRenewEInvoicesV1: (
      query?: {
        /** @format date-time */
        renewalDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, void | ErrorResponse>({
        path: `/api/v1/e-invoice/renew-e-invoices`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerSendExistingInvoiceV1
     * @summary Send existing invoice to member
     * @request POST:/api/v1/e-invoice/send-existing-invoice/{invoiceId}
     * @secure
     */
    eInvoiceControllerSendExistingInvoiceV1: (invoiceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/e-invoice/send-existing-invoice/${invoiceId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags E-Invoice
     * @name EInvoiceControllerGetEInvoiceUsageV1
     * @summary Get usage of e-invoices
     * @request GET:/api/v1/e-invoice/usage
     * @secure
     */
    eInvoiceControllerGetEInvoiceUsageV1: (params: RequestParams = {}) =>
      this.request<EInvoiceUsageResponseDto, void | ErrorResponse>({
        path: `/api/v1/e-invoice/usage`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetInvoicesPaginatedV1
     * @summary Get filtered invoices of the tenant
     * @request POST:/api/v1/invoices/filter
     * @secure
     */
    invoiceControllerGetInvoicesPaginatedV1: (
      data: InvoiceFilter,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<InvoiceResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/invoices/filter`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerCreateCreditNoteV1
     * @summary Create a credit note for a member
     * @request POST:/api/v1/invoices/credit-note
     * @secure
     */
    invoiceControllerCreateCreditNoteV1: (data: CreateCreditNoteDto, params: RequestParams = {}) =>
      this.request<Invoice, void | ErrorResponse>({
        path: `/api/v1/invoices/credit-note`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetInvoiceByInvoiceNumberV1
     * @summary Get an invoice of a member by invoiceNumber
     * @request GET:/api/v1/invoices/{invoiceNumber}/member/{memberId}
     * @secure
     */
    invoiceControllerGetInvoiceByInvoiceNumberV1: (
      memberId: string,
      invoiceNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<Invoice, void | ErrorResponse>({
        path: `/api/v1/invoices/${invoiceNumber}/member/${memberId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerInitiateBatchDownloadV1
     * @summary Initiate a batch download of invoices
     * @request POST:/api/v1/invoices/batch-download/initiate
     * @secure
     */
    invoiceControllerInitiateBatchDownloadV1: (
      data: InvoiceBatchOperationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/batch-download/initiate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetBatchDownloadProgressV1
     * @summary Get the progress of a batch download of invoices
     * @request GET:/api/v1/invoices/batch-download/progress/{jobId}
     * @secure
     */
    invoiceControllerGetBatchDownloadProgressV1: (jobId: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/batch-download/progress/${jobId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerRedirectToSignedZipFileV1
     * @summary Redirect to a temporary download link from S3
     * @request GET:/api/v1/invoices/batch-download/stream/{jobId}
     * @secure
     */
    invoiceControllerRedirectToSignedZipFileV1: (jobId: string, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/batch-download/stream/${jobId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerUpdateDueDateV1
     * @request PATCH:/api/v1/invoices/{invoiceNumber}/due-date
     * @secure
     */
    invoiceControllerUpdateDueDateV1: (
      invoiceNumber: number,
      data: UpdateInvoiceDueDateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/${invoiceNumber}/due-date`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerBatchMarkAsSentV1
     * @request PATCH:/api/v1/invoices/batch-mark-as-sent
     * @secure
     */
    invoiceControllerBatchMarkAsSentV1: (
      data: InvoiceBatchOperationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/batch-mark-as-sent`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerBatchCreateCreditNotesV1
     * @summary Create credit notes for a batch of invoices
     * @request POST:/api/v1/invoices/batch-create-credit-notes
     * @secure
     */
    invoiceControllerBatchCreateCreditNotesV1: (
      data: InvoiceBatchOperationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/invoices/batch-create-credit-notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerValidateBatchCreateCreditNotesV1
     * @summary Validate which invoices can be credited in a batch operation
     * @request POST:/api/v1/invoices/validate-batch-create-credit-notes
     * @secure
     */
    invoiceControllerValidateBatchCreateCreditNotesV1: (
      data: InvoiceBatchOperationDto,
      params: RequestParams = {},
    ) =>
      this.request<ValidatedBatchInvoiceOperationResponse, void | ErrorResponse>({
        path: `/api/v1/invoices/validate-batch-create-credit-notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerValidateBatchMarkAsSentV1
     * @summary Validate which invoices can be marked as sent in a batch operation
     * @request POST:/api/v1/invoices/validate-batch-mark-as-sent
     * @secure
     */
    invoiceControllerValidateBatchMarkAsSentV1: (
      data: InvoiceBatchOperationDto,
      params: RequestParams = {},
    ) =>
      this.request<ValidatedBatchInvoiceOperationResponse, void | ErrorResponse>({
        path: `/api/v1/invoices/validate-batch-mark-as-sent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetInvoiceSummaryForOverPaymentV1
     * @summary Get the summary of the invoice for over payment
     * @request GET:/api/v1/invoices/extension-summary-for-over-payment/{invoiceNumber}
     * @secure
     */
    invoiceControllerGetInvoiceSummaryForOverPaymentV1: (
      invoiceNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<Invoice, void | ErrorResponse>({
        path: `/api/v1/invoices/extension-summary-for-over-payment/${invoiceNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerCreateInvoiceForOverPaymentV1
     * @summary Create an invoice for over payment and extend the subscription
     * @request POST:/api/v1/invoices/create-invoice-for-over-payment
     * @secure
     */
    invoiceControllerCreateInvoiceForOverPaymentV1: (
      data: CreateInvoiceForOverPaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<Invoice, void | ErrorResponse>({
        path: `/api/v1/invoices/create-invoice-for-over-payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ledger
     * @name LedgerControllerGetLedgerV1
     * @summary Get ledger of all members
     * @request POST:/api/v1/ledger/filter
     * @secure
     */
    ledgerControllerGetLedgerV1: (
      data: TransactionFilter,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/ledger/filter`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ledger
     * @name LedgerControllerGetMembersLedgerV1
     * @summary Get ledger of a member
     * @request GET:/api/v1/ledger/{memberId}
     * @secure
     */
    ledgerControllerGetMembersLedgerV1: (
      memberId: string,
      query?: {
        status?: 'open' | 'matched' | 'ignored';
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponse[], void | ErrorResponse>({
        path: `/api/v1/ledger/${memberId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ledger
     * @name LedgerControllerUpdateTransactionGroupStatusV1
     * @summary Match transactions
     * @request PATCH:/api/v1/ledger/{memberId}
     * @secure
     */
    ledgerControllerUpdateTransactionGroupStatusV1: (
      memberId: string,
      data: UpdateTransactionGroupStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<TransactionGroup, void | ErrorResponse>({
        path: `/api/v1/ledger/${memberId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ledger
     * @name LedgerControllerGetTransactionSummaryV1
     * @summary Get transaction summary before matching/unmatching transactions
     * @request POST:/api/v1/ledger/{memberId}/summary
     * @secure
     */
    ledgerControllerGetTransactionSummaryV1: (
      memberId: string,
      data: UpdateTransactionGroupStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<MatchSummary, ErrorResponse | void>({
        path: `/api/v1/ledger/${memberId}/summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ledger
     * @name LedgerControllerUpdateTransactionStatusV1
     * @summary Update transaction status of a particular transaction
     * @request PATCH:/api/v1/ledger/{memberId}/{transactionId}
     * @secure
     */
    ledgerControllerUpdateTransactionStatusV1: (
      memberId: string,
      transactionId: string,
      data: UpdateTransactionStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/ledger/${memberId}/${transactionId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Log
     * @name ActivityLogControllerGetActivityFeedsV1
     * @summary Get all activity feeds for admin
     * @request GET:/api/v1/activity-logs/feeds
     * @secure
     */
    activityLogControllerGetActivityFeedsV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        filter?: FilteredActivityLogAction;
        exclude?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/activity-logs/feeds`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity Log
     * @name ActivityLogControllerGetMemberActivityFeedV1
     * @summary Get  activity feeds for member
     * @request GET:/api/v1/activity-logs/members/{id}
     * @secure
     */
    activityLogControllerGetMemberActivityFeedV1: (
      id: string,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        filter?: FilteredActivityLogAction;
        exclude?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/activity-logs/members/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Action-Types
     * @name ActionTypesControllerIndexV1
     * @summary Get all action types for automation
     * @request GET:/api/v1/automations/action-types
     * @secure
     */
    actionTypesControllerIndexV1: (params: RequestParams = {}) =>
      this.request<ActionType[], void | ErrorResponse>({
        path: `/api/v1/automations/action-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerIndexV1
     * @summary Get all event types for automation
     * @request GET:/api/v1/automations/event-types
     * @secure
     */
    eventTypesControllerIndexV1: (
      query?: {
        selectedEventTypeTags?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<EventTypeWithTokens[], void | ErrorResponse>({
        path: `/api/v1/automations/event-types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerCreateV1
     * @summary Create an event type for automation
     * @request POST:/api/v1/automations/event-types
     * @secure
     */
    eventTypesControllerCreateV1: (data: EventTypeDto, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/event-types`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerGetDefaultInternalMailingByEventTypeV1
     * @summary Get internal email template for an event
     * @request GET:/api/v1/automations/event-types/internal-email-template
     * @secure
     */
    eventTypesControllerGetDefaultInternalMailingByEventTypeV1: (
      query: {
        eventTypeId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<InternalEmail, void | ErrorResponse>({
        path: `/api/v1/automations/event-types/internal-email-template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerCreateInternalMailTemplateV1
     * @summary Create internal mail template for an event
     * @request POST:/api/v1/automations/event-types/internal-email-template
     * @secure
     */
    eventTypesControllerCreateInternalMailTemplateV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/event-types/internal-email-template`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerGetExternalEmailByEventTypeV1
     * @summary Get external email template for an event
     * @request GET:/api/v1/automations/event-types/external-email-template
     * @secure
     */
    eventTypesControllerGetExternalEmailByEventTypeV1: (
      query: {
        eventTypeId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ExternalEmail, void | ErrorResponse>({
        path: `/api/v1/automations/event-types/external-email-template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerCreateExternalMailTemplateV1
     * @summary Create email template for an event, which will be sent to member
     * @request POST:/api/v1/automations/event-types/external-email-template
     * @secure
     */
    eventTypesControllerCreateExternalMailTemplateV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/event-types/external-email-template`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types
     * @name EventTypesControllerUpdateV1
     * @summary Update an event type for automation
     * @request PATCH:/api/v1/automations/event-types/{id}
     * @secure
     */
    eventTypesControllerUpdateV1: (id: number, data: EventTypeDto, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/event-types/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerIndexV1
     * @summary Get all workflows for automation
     * @request GET:/api/v1/automations/workflows
     * @secure
     */
    workflowControllerIndexV1: (params: RequestParams = {}) =>
      this.request<Workflow[], void | ErrorResponse>({
        path: `/api/v1/automations/workflows`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerCreateV1
     * @summary Create a workflow for automation
     * @request POST:/api/v1/automations/workflows
     * @secure
     */
    workflowControllerCreateV1: (data: WorkflowDto, params: RequestParams = {}) =>
      this.request<Workflow, void | ErrorResponse>({
        path: `/api/v1/automations/workflows`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerShowV1
     * @summary Get a workflow for automation
     * @request GET:/api/v1/automations/workflows/{id}
     * @secure
     */
    workflowControllerShowV1: (id: number, params: RequestParams = {}) =>
      this.request<Workflow, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerUpdateV1
     * @summary Update a workflow for automation
     * @request PATCH:/api/v1/automations/workflows/{id}
     * @secure
     */
    workflowControllerUpdateV1: (id: number, data: WorkflowDto, params: RequestParams = {}) =>
      this.request<Workflow, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerDeleteV1
     * @summary Delete a workflow for automation
     * @request DELETE:/api/v1/automations/workflows/{id}
     * @secure
     */
    workflowControllerDeleteV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerDeleteExternalEmailV1
     * @summary Delete a external email  for automation
     * @request DELETE:/api/v1/automations/workflows/external-email/{id}
     * @secure
     */
    workflowControllerDeleteExternalEmailV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/external-email/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerDeleteInternalEmailV1
     * @summary Delete a internal email  for automation
     * @request DELETE:/api/v1/automations/workflows/internal-email/{id}
     * @secure
     */
    workflowControllerDeleteInternalEmailV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/internal-email/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerDeleteWorkflowEventEmailV1
     * @summary Delete a workflow-event  for automation
     * @request DELETE:/api/v1/automations/workflows/workflow-event/{id}
     * @secure
     */
    workflowControllerDeleteWorkflowEventEmailV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/workflow-event/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Workflows
     * @name WorkflowControllerSendPreviewEmailV1
     * @summary Send a test automation email
     * @request POST:/api/v1/automations/workflows/{id}/test/email
     * @secure
     */
    workflowControllerSendPreviewEmailV1: (
      id: number,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/automations/workflows/${id}/test/email`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationTemplate
     * @name CommunicationTemplateControllerCreateV1
     * @summary Create communication template
     * @request POST:/api/v1/communication-template
     * @secure
     */
    communicationTemplateControllerCreateV1: (
      data: CommunicationTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationTemplate, ErrorResponse | void>({
        path: `/api/v1/communication-template`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationTemplate
     * @name CommunicationTemplateControllerFindAllV1
     * @summary Get all communication template
     * @request GET:/api/v1/communication-template
     * @secure
     */
    communicationTemplateControllerFindAllV1: (params: RequestParams = {}) =>
      this.request<CommunicationTemplate[], void | ErrorResponse>({
        path: `/api/v1/communication-template`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationTemplate
     * @name CommunicationTemplateControllerGetV1
     * @summary Get an communication template
     * @request GET:/api/v1/communication-template/{id}
     * @secure
     */
    communicationTemplateControllerGetV1: (id: number, params: RequestParams = {}) =>
      this.request<CommunicationTemplate, void | ErrorResponse>({
        path: `/api/v1/communication-template/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationTemplate
     * @name CommunicationTemplateControllerUpdateV1
     * @summary Update a communication template
     * @request PATCH:/api/v1/communication-template/{id}
     * @secure
     */
    communicationTemplateControllerUpdateV1: (
      id: number,
      data: CommunicationTemplateDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationTemplate, ErrorResponse | void>({
        path: `/api/v1/communication-template/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationTemplate
     * @name CommunicationTemplateControllerGetCommunicationTemplatesV1
     * @summary Get communication  email templates by channel and type
     * @request GET:/api/v1/communication-template/{communicationChannel}/{templateType}
     * @secure
     */
    communicationTemplateControllerGetCommunicationTemplatesV1: (
      communicationChannel: string,
      templateType: string,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationTemplate[], void | ErrorResponse>({
        path: `/api/v1/communication-template/${communicationChannel}/${templateType}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationSender
     * @name CommunicationSenderControllerCreateV1
     * @summary Create a communication sender
     * @request POST:/api/v1/communication-sender
     * @secure
     */
    communicationSenderControllerCreateV1: (
      data: CommunicationSenderCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationSender, void | ErrorResponse>({
        path: `/api/v1/communication-sender`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationSender
     * @name CommunicationSenderControllerFindAllV1
     * @summary Get all communication senders
     * @request GET:/api/v1/communication-sender
     * @secure
     */
    communicationSenderControllerFindAllV1: (params: RequestParams = {}) =>
      this.request<CommunicationSender[], void | ErrorResponse>({
        path: `/api/v1/communication-sender`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationSender
     * @name CommunicationSenderControllerUpdateV1
     * @summary Update a communication sender
     * @request PATCH:/api/v1/communication-sender/{id}
     * @secure
     */
    communicationSenderControllerUpdateV1: (
      id: number,
      data: CommunicationSenderUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationSender, void | ErrorResponse>({
        path: `/api/v1/communication-sender/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunicationSender
     * @name CommunicationSenderControllerGetSenderByChannelV1
     * @summary Get all communication sender by channel
     * @request GET:/api/v1/communication-sender/get-communication-sender/{communicationChannel}
     * @secure
     */
    communicationSenderControllerGetSenderByChannelV1: (
      communicationChannel: string,
      params: RequestParams = {},
    ) =>
      this.request<CommunicationSender[], void | ErrorResponse>({
        path: `/api/v1/communication-sender/get-communication-sender/${communicationChannel}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Automations::Event-Types::Tags
     * @name EventTypesTagsControllerIndexV1
     * @summary Get all event types tags for automation
     * @request GET:/api/v1/automations/event-types/tags
     * @secure
     */
    eventTypesTagsControllerIndexV1: (params: RequestParams = {}) =>
      this.request<Tag[], void | ErrorResponse>({
        path: `/api/v1/automations/event-types/tags`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetStatsV1
     * @summary Get basic stats
     * @request GET:/api/v1/stats/stats
     * @secure
     */
    statsControllerGetStatsV1: (params: RequestParams = {}) =>
      this.request<StatsDTO, void | ErrorResponse>({
        path: `/api/v1/stats/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetStatsForNthDaysV1
     * @summary Get all stats for nth days
     * @request GET:/api/v1/stats/total-stats
     * @secure
     */
    statsControllerGetStatsForNthDaysV1: (
      query: {
        days: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StatsForNthDaysDTO, void | ErrorResponse>({
        path: `/api/v1/stats/total-stats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetActivityFeedsV1
     * @summary Get all activity feeds for admin
     * @request GET:/api/v1/stats/feeds
     * @secure
     */
    statsControllerGetActivityFeedsV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
        filter?: FilteredActivityLogAction;
        exclude?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/stats/feeds`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetReferrerStatsV1
     * @summary Get all sales grouped by referrer for nth days
     * @request GET:/api/v1/stats/referrer-stats
     * @secure
     */
    statsControllerGetReferrerStatsV1: (
      query: {
        days: number;
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "count" */
        orderBy?: 'count';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<ReferrerStatsDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/stats/referrer-stats`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerExportReferrerStatsV1
     * @summary Export all sales by referrer nth days
     * @request GET:/api/v1/stats/export/referrer-stats
     * @secure
     */
    statsControllerExportReferrerStatsV1: (
      query?: {
        /** @format date-time */
        dateFrom?: string;
        /** @format date-time */
        dateTo?: string;
        fileFormat?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/stats/export/referrer-stats`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerRunSubscriptionSummaryV1
     * @summary Run subscription summary job for all tenants
     * @request POST:/api/v1/stats/cron/subscription-summary
     * @secure
     */
    statsControllerRunSubscriptionSummaryV1: (
      data: StatsTenantIdsDTO,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/stats/cron/subscription-summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerRunProductSummaryV1
     * @summary Run product summary job for all tenants
     * @request POST:/api/v1/stats/cron/product-summary
     * @secure
     */
    statsControllerRunProductSummaryV1: (data: StatsTenantIdsDTO, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/stats/cron/product-summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerRunMemberSummaryV1
     * @summary Run member summary job for all tenants
     * @request POST:/api/v1/stats/cron/member-summary
     * @secure
     */
    statsControllerRunMemberSummaryV1: (data: StatsTenantIdsDTO, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/stats/cron/member-summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerRunSubscriptionActivitySummaryV1
     * @summary Run subscription activity summary job for all tenants
     * @request POST:/api/v1/stats/cron/subscription-activity-summary
     * @secure
     */
    statsControllerRunSubscriptionActivitySummaryV1: (
      data: StatsCronDTO,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/stats/cron/subscription-activity-summary`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerRunRecurringRevenueV1
     * @summary Run recurring revenue job for all tenants
     * @request POST:/api/v1/stats/cron/recurring-revenue
     * @secure
     */
    statsControllerRunRecurringRevenueV1: (data: StatsTenantIdsDTO, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/stats/cron/recurring-revenue`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalSubscriptionsV1
     * @summary Get historical subscriptions
     * @request GET:/api/v1/stats/historical-subscriptions
     * @secure
     */
    statsControllerGetHistoricalSubscriptionsV1: (
      query?: {
        period?: DataSelectionPeriod;
        type?: SubscriptionType;
        groupBy?: GroupByType;
        noOfLine?: NoOfLine;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-subscriptions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalProductsV1
     * @summary Get historical products
     * @request GET:/api/v1/stats/historical-products
     * @secure
     */
    statsControllerGetHistoricalProductsV1: (
      query?: {
        period?: DataSelectionPeriod;
        type?: ProductType;
        noOfLine?: NoOfLine;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalMembersV1
     * @summary Get historical members
     * @request GET:/api/v1/stats/historical-members
     * @secure
     */
    statsControllerGetHistoricalMembersV1: (
      query?: {
        period?: DataSelectionPeriod;
        type?: MemberType;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalRecurringRevenueDataV1
     * @summary Get historical recurring revenue
     * @request GET:/api/v1/stats/historical-recurring-revenue
     * @secure
     */
    statsControllerGetHistoricalRecurringRevenueDataV1: (
      query?: {
        estimation?: RevenueEstimationOption;
        type?: RevenueType;
        noOfLine?: NoOfLine;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-recurring-revenue`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalCurrentRevenueDataV1
     * @summary Get historical current revenue
     * @request GET:/api/v1/stats/historical-current-revenue
     * @secure
     */
    statsControllerGetHistoricalCurrentRevenueDataV1: (
      query?: {
        period?: RevenuePeriod;
        type?: RevenueType;
        noOfLine?: NoOfLine;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-current-revenue`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalSubscriptionActivitiesV1
     * @summary Get qty of historical new/stopped subscriptions
     * @request GET:/api/v1/stats/historical-subscriptions-activity
     * @secure
     */
    statsControllerGetHistoricalSubscriptionActivitiesV1: (
      query?: {
        period?: DataSelectionPeriod;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalStatsResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-subscriptions-activity`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subrite statistics
     * @name StatsControllerGetHistoricalChurnRatesV1
     * @summary Get qty of historical churn rates
     * @request GET:/api/v1/stats/historical-churn-rates
     * @secure
     */
    statsControllerGetHistoricalChurnRatesV1: (
      query?: {
        period?: DataSelectionPeriod;
        type?: ChurnType;
        groupBy?: GroupByType;
        noOfLine?: NoOfLine;
      },
      params: RequestParams = {},
    ) =>
      this.request<HistoricalChurnRateResDto, void | ErrorResponse>({
        path: `/api/v1/stats/historical-churn-rates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerCreateV1
     * @summary Create a new custom property
     * @request POST:/api/v1/custom-properties
     * @secure
     */
    customPropertyControllerCreateV1: (data: CreateCustomPropertyDto, params: RequestParams = {}) =>
      this.request<CustomPropertyResponse, ErrorResponse | void>({
        path: `/api/v1/custom-properties`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerFindAllPaginatedV1
     * @summary Get all custom properties of the tenant paginated
     * @request GET:/api/v1/custom-properties
     * @secure
     */
    customPropertyControllerFindAllPaginatedV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomPropertyResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/custom-properties`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerFindAllV1
     * @summary Get all custom properties of the tenant
     * @request GET:/api/v1/custom-properties/all
     * @secure
     */
    customPropertyControllerFindAllV1: (params: RequestParams = {}) =>
      this.request<CustomPropertyViewResponse[], ErrorResponse>({
        path: `/api/v1/custom-properties/all`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerFindOneV1
     * @summary Get a custom property by id
     * @request GET:/api/v1/custom-properties/{id}
     * @secure
     */
    customPropertyControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<CustomPropertyResponse, void | ErrorResponse>({
        path: `/api/v1/custom-properties/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerUpdateV1
     * @summary Update a custom property
     * @request PATCH:/api/v1/custom-properties/{id}
     * @secure
     */
    customPropertyControllerUpdateV1: (
      id: string,
      data: UpdateCustomPropertyDto,
      params: RequestParams = {},
    ) =>
      this.request<CustomPropertyResponse, void | ErrorResponse>({
        path: `/api/v1/custom-properties/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Property
     * @name CustomPropertyControllerRemoveV1
     * @summary Delete a custom property
     * @request DELETE:/api/v1/custom-properties/{id}
     * @secure
     */
    customPropertyControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/custom-properties/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Order Source
     * @name CustomOrderSourceControllerCreateV1
     * @summary Create a new custom order source
     * @request POST:/api/v1/custom-order-sources
     * @secure
     */
    customOrderSourceControllerCreateV1: (
      data: CreateCustomOrderSourceDto,
      params: RequestParams = {},
    ) =>
      this.request<CustomOrderSourceResponse, ErrorResponse | void>({
        path: `/api/v1/custom-order-sources`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Order Source
     * @name CustomOrderSourceControllerFindAllV1
     * @summary Get all custom order sources of the tenant
     * @request GET:/api/v1/custom-order-sources
     * @secure
     */
    customOrderSourceControllerFindAllV1: (params: RequestParams = {}) =>
      this.request<CustomOrderSourceResponse[], void | ErrorResponse>({
        path: `/api/v1/custom-order-sources`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Order Source
     * @name CustomOrderSourceControllerFindOneV1
     * @summary Get a custom order source by id
     * @request GET:/api/v1/custom-order-sources/{id}
     * @secure
     */
    customOrderSourceControllerFindOneV1: (id: string, params: RequestParams = {}) =>
      this.request<CustomOrderSourceResponse, void | ErrorResponse>({
        path: `/api/v1/custom-order-sources/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Order Source
     * @name CustomOrderSourceControllerUpdateV1
     * @summary Update a custom order source
     * @request PATCH:/api/v1/custom-order-sources/{id}
     * @secure
     */
    customOrderSourceControllerUpdateV1: (
      id: string,
      data: UpdateCustomOrderSourceDto,
      params: RequestParams = {},
    ) =>
      this.request<CustomOrderSourceResponse, void | ErrorResponse>({
        path: `/api/v1/custom-order-sources/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Order Source
     * @name CustomOrderSourceControllerRemoveV1
     * @summary Delete a custom order source
     * @request DELETE:/api/v1/custom-order-sources/{id}
     * @secure
     */
    customOrderSourceControllerRemoveV1: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/custom-order-sources/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Orders
     * @name CustomOrderControllerCreateOrderV1
     * @summary Create or update a custom order
     * @request POST:/api/v1/custom-orders
     * @secure
     */
    customOrderControllerCreateOrderV1: (data: CreateCustomOrderDto, params: RequestParams = {}) =>
      this.request<CustomOrder, void>({
        path: `/api/v1/custom-orders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheckRedisHealth
     * @summary Check redis memory health
     * @request GET:/api/health/redis-memory
     * @secure
     */
    healthControllerCheckRedisHealth: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/health/redis-memory`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheckQueueHealth
     * @request GET:/api/health/queue
     */
    healthControllerCheckQueueHealth: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/health/queue`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheckCronHealth
     * @summary Check cron health separately
     * @request GET:/api/health/cron
     */
    healthControllerCheckCronHealth: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/health/cron`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerGetConsentsV1
     * @summary Get all consents
     * @request GET:/api/v1/consents
     * @secure
     */
    consentControllerGetConsentsV1: (params: RequestParams = {}) =>
      this.request<ConsentResponseDto[], void | ErrorResponse>({
        path: `/api/v1/consents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerCreateConsentV1
     * @summary Create a new consent
     * @request POST:/api/v1/consents
     * @secure
     */
    consentControllerCreateConsentV1: (data: ConsentDto, params: RequestParams = {}) =>
      this.request<ConsentResponseDto, void | ErrorResponse>({
        path: `/api/v1/consents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accepts an unsubscribe token and processes the unsubscribe request.
     *
     * @tags Communication consents
     * @name ConsentControllerUnsubscribeFromConsentV1
     * @summary Unsubscribe from newsletter and communications
     * @request POST:/api/v1/consents/unsubscribe
     * @secure
     */
    consentControllerUnsubscribeFromConsentV1: (
      data: UnsubscribeTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/consents/unsubscribe`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerUpdateConsentV1
     * @summary Update a consent
     * @request PATCH:/api/v1/consents/{id}
     * @secure
     */
    consentControllerUpdateConsentV1: (
      id: number,
      data: UpdateConsentDto,
      params: RequestParams = {},
    ) =>
      this.request<ConsentResponseDto, void | ErrorResponse>({
        path: `/api/v1/consents/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerGetConsentV1
     * @summary Get consent details
     * @request GET:/api/v1/consents/{id}
     * @secure
     */
    consentControllerGetConsentV1: (id: number, params: RequestParams = {}) =>
      this.request<ConsentResponseDto, void | ErrorResponse>({
        path: `/api/v1/consents/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerDeleteConsentV1
     * @summary Delete a consent
     * @request DELETE:/api/v1/consents/{id}
     * @secure
     */
    consentControllerDeleteConsentV1: (id: number, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/consents/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerUpdateConsentAndSyncThirdPartyNewsletterV1
     * @summary create consent and member and sync third party newsletter
     * @request POST:/api/v1/consents/{id}
     * @secure
     */
    consentControllerUpdateConsentAndSyncThirdPartyNewsletterV1: (
      id: string,
      data: ConsentRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/consents/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerGetMailchimpWebhookV1
     * @summary Get mailchimp webhook validation
     * @request GET:/api/v1/consents/webhook/mailchimp/{webhooksecret}
     * @secure
     */
    consentControllerGetMailchimpWebhookV1: (webhooksecret: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/consents/webhook/mailchimp/${webhooksecret}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerPostMailchimpWebhookV1
     * @summary Sync member consent from mailchimp
     * @request POST:/api/v1/consents/webhook/mailchimp/{webhooksecret}
     * @secure
     */
    consentControllerPostMailchimpWebhookV1: (webhooksecret: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/consents/webhook/mailchimp/${webhooksecret}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication consents
     * @name ConsentControllerPostMakeWebhookV1
     * @summary Sync member consent from make
     * @request POST:/api/v1/consents/webhook/make/{webhooksecret}
     * @secure
     */
    consentControllerPostMakeWebhookV1: (webhooksecret: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/consents/webhook/make/${webhooksecret}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerFindAllV1
     * @summary Get all exports of the tenant
     * @request GET:/api/v1/exports
     * @secure
     */
    exportControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<ExportHistoryResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/exports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerDownloadStreamV1
     * @summary Get download stream of an export by id
     * @request GET:/api/v1/exports/{id}
     * @secure
     */
    exportControllerDownloadStreamV1: (
      id: number,
      query: {
        format: 'csv' | 'xlsx' | 'xls' | 'DAT';
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportMemberPackageV1
     * @summary Generate subscription report as a csv file
     * @request POST:/api/v1/exports/member-package
     * @secure
     */
    exportControllerExportMemberPackageV1: (
      query?: {
        /** @format date-time */
        nextRenewalDateFrom?: string;
        /** @format date-time */
        nextRenewalDateTo?: string;
        status?: (
          | 'active'
          | 'inactive'
          | 'pending'
          | 'paused'
          | 'stopped'
          | 'expired'
          | 'waiting_for_activation'
        )[];
        paymentProvider?: ('stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf')[];
        subscriptionPlanId?: number[];
        productId?: number[];
        /** @format date-time */
        createdAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/member-package`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportMemberPackageProductsV1
     * @summary Generate subscription products report as a csv file
     * @request POST:/api/v1/exports/member-package-products
     * @secure
     */
    exportControllerExportMemberPackageProductsV1: (
      query?: {
        /** @format date-time */
        nextRenewalDateFrom?: string;
        /** @format date-time */
        nextRenewalDateTo?: string;
        status?: (
          | 'active'
          | 'inactive'
          | 'pending'
          | 'paused'
          | 'stopped'
          | 'expired'
          | 'waiting_for_activation'
        )[];
        paymentProvider?: ('stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf')[];
        subscriptionPlanId?: number[];
        productId?: number[];
        /** @format date-time */
        createdAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/member-package-products`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportPaymentsV1
     * @summary Generate payment and refund report as a csv file
     * @request POST:/api/v1/exports/payments
     * @secure
     */
    exportControllerExportPaymentsV1: (
      query?: {
        /** @format date-time */
        dateFrom?: string;
        /** @format date-time */
        dateTo?: string;
        transactionType?: PaymentAndRefundType;
        /** @format date-time */
        createdAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/payments`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportInvoicesV1
     * @summary Generate invoice report as a csv file
     * @request POST:/api/v1/exports/invoices
     * @secure
     */
    exportControllerExportInvoicesV1: (
      query?: {
        /** @format date-time */
        dateFrom?: string;
        /** @format date-time */
        dateTo?: string;
        /** @format date-time */
        createdAt?: string;
        invoiceType?: InvoiceType;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/invoices`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportMemberPackageUsersV1
     * @summary Generate subscription products and group members report as a csv file
     * @request POST:/api/v1/exports/member-package-users
     * @secure
     */
    exportControllerExportMemberPackageUsersV1: (
      query?: {
        /** @format date-time */
        nextRenewalDateFrom?: string;
        /** @format date-time */
        nextRenewalDateTo?: string;
        status?: (
          | 'active'
          | 'inactive'
          | 'pending'
          | 'paused'
          | 'stopped'
          | 'expired'
          | 'waiting_for_activation'
        )[];
        paymentProvider?: ('stripe' | 'vipps' | 'external' | 'nets' | 'efaktura-avtalegiro-ehf')[];
        subscriptionPlanId?: number[];
        productId?: number[];
        /** @format date-time */
        createdAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/member-package-users`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportMembersV1
     * @summary Generate all members report as a csv file
     * @request POST:/api/v1/exports/members
     * @secure
     */
    exportControllerExportMembersV1: (
      query?: {
        /** @format date-time */
        joinedDateFrom?: string;
        /** @format date-time */
        joinedDateTo?: string;
        /** @format date-time */
        createdAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/members`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportSegmentsV1
     * @summary Generate segment report as a csv file
     * @request POST:/api/v1/exports/segments
     * @secure
     */
    exportControllerExportSegmentsV1: (data: SegmentExportDto, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/segments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportControllerExportLedgerV1
     * @summary Generate ledger report as a csv file
     * @request POST:/api/v1/exports/ledger
     * @secure
     */
    exportControllerExportLedgerV1: (data: LedgerExportFilterDto, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/exports/ledger`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerGetPushSetupV1
     * @summary Get push notifications setup
     * @request GET:/api/v1/app-push/setup
     * @secure
     */
    pushControllerGetPushSetupV1: (params: RequestParams = {}) =>
      this.request<PushSetupResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/setup`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerSavePushSetupV1
     * @summary Setup push notifications
     * @request POST:/api/v1/app-push/setup
     * @secure
     */
    pushControllerSavePushSetupV1: (
      data: CreateFCMPushSetupRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PushSetupResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/setup`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerUpdatePushSetupV1
     * @summary Update push notifications setup
     * @request PATCH:/api/v1/app-push/setup
     * @secure
     */
    pushControllerUpdatePushSetupV1: (
      data: UpdateFCMPushSetupRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PushSetupResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/setup`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerSubscribeToPushV1
     * @summary Subscribe to push notifications from app
     * @request POST:/api/v1/app-push/subscribe
     * @secure
     */
    pushControllerSubscribeToPushV1: (
      data: SubscribeToPushRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PushSubscriber, void | ErrorResponse>({
        path: `/api/v1/app-push/subscribe`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerUnsubscribeFromPushV1
     * @summary Unsubscribe from push notifications from app
     * @request DELETE:/api/v1/app-push/subscribe
     * @secure
     */
    pushControllerUnsubscribeFromPushV1: (
      data: UnsubscribeFromPushRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/app-push/subscribe`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerLinkSubscriberToMemberV1
     * @summary Link subscriber to member
     * @request PUT:/api/v1/app-push/linksubscriber
     * @secure
     */
    pushControllerLinkSubscriberToMemberV1: (
      data: LinkSubscriberToMemberRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/app-push/linksubscriber`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerTrackOpenMessageV1
     * @summary Track opening of message
     * @request PUT:/api/v1/app-push/open
     * @secure
     */
    pushControllerTrackOpenMessageV1: (
      data: TrackOpenMessageRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/app-push/open`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerPushContentV1
     * @summary Trigger dispatch of new push notification
     * @request POST:/api/v1/app-push/pushcontent
     * @secure
     */
    pushControllerPushContentV1: (data: PushContentRequestDto, params: RequestParams = {}) =>
      this.request<PushContent, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerGetPushCampaignsV1
     * @summary Get all push campaigns
     * @request GET:/api/v1/app-push/pushcampaign
     * @secure
     */
    pushControllerGetPushCampaignsV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<PushCampaignResponseDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerCreateCampaignV1
     * @summary Save new push notification campaign draft
     * @request POST:/api/v1/app-push/pushcampaign
     * @secure
     */
    pushControllerCreateCampaignV1: (data: CreatePushCampaignDto, params: RequestParams = {}) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerGetCampaignV1
     * @summary Get push campaign
     * @request GET:/api/v1/app-push/pushcampaign/{id}
     * @secure
     */
    pushControllerGetCampaignV1: (id: number, params: RequestParams = {}) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerUpdateCampaignV1
     * @summary Update push campaign
     * @request PATCH:/api/v1/app-push/pushcampaign/{id}
     * @secure
     */
    pushControllerUpdateCampaignV1: (
      id: number,
      data: PushCampaignDraftUpdateDto,
      params: RequestParams = {},
    ) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerDeleteCampaignV1
     * @summary Delete push campaign
     * @request DELETE:/api/v1/app-push/pushcampaign/{id}
     * @secure
     */
    pushControllerDeleteCampaignV1: (id: number, params: RequestParams = {}) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerSendCampaignV1
     * @summary Send push campaign
     * @request POST:/api/v1/app-push/pushcampaign/{id}/send
     * @secure
     */
    pushControllerSendCampaignV1: (id: number, params: RequestParams = {}) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}/send`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerScheduleCampaignV1
     * @summary Schedule push campaign
     * @request POST:/api/v1/app-push/pushcampaign/{id}/schedule
     * @secure
     */
    pushControllerScheduleCampaignV1: (
      id: number,
      data: SchedulePushCampaignDto,
      params: RequestParams = {},
    ) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}/schedule`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerCancelCampaignV1
     * @summary Cancel push campaign
     * @request POST:/api/v1/app-push/pushcampaign/{id}/cancel
     * @secure
     */
    pushControllerCancelCampaignV1: (id: number, params: RequestParams = {}) =>
      this.request<PushCampaignResponseDto, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}/cancel`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerGetReceiversV1
     * @summary Get receivers for push campaign
     * @request GET:/api/v1/app-push/pushcampaign/{id}/receivers
     * @secure
     */
    pushControllerGetReceiversV1: (
      id: number,
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<PushSubscriberResponseDtoPaginated, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}/receivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerSendTestPushV1
     * @summary Send test push
     * @request POST:/api/v1/app-push/pushcampaign/{id}/test
     * @secure
     */
    pushControllerSendTestPushV1: (id: number, params: RequestParams = {}) =>
      this.request<SendTestPushResponse, ErrorResponse | void>({
        path: `/api/v1/app-push/pushcampaign/${id}/test`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name PushControllerGetCampaignStatsV1
     * @summary Get push campaign stats
     * @request GET:/api/v1/app-push/pushcampaign/{id}/stats
     * @secure
     */
    pushControllerGetCampaignStatsV1: (id: number, params: RequestParams = {}) =>
      this.request<PushStats, void | ErrorResponse>({
        path: `/api/v1/app-push/pushcampaign/${id}/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerFindAllV1
     * @summary Get all import histories of the tenant
     * @request GET:/api/v1/import
     * @secure
     */
    importControllerFindAllV1: (
      query?: {
        /**
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * @min 1
         * @max 50
         * @default 10
         */
        take?: number;
        /** @default "createdAt" */
        orderBy?: 'createdAt' | 'id' | 'updatedAt';
        /** @default "desc" */
        orderDirection?: 'asc' | 'desc';
      },
      params: RequestParams = {},
    ) =>
      this.request<ImportHistoryResponsePaginated, void | ErrorResponse>({
        path: `/api/v1/import`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerDownloadStreamV1
     * @summary Get download stream of an import by id
     * @request GET:/api/v1/import/history/{id}
     * @secure
     */
    importControllerDownloadStreamV1: (
      id: number,
      query: {
        format: 'csv' | 'xlsx' | 'xls' | 'DAT';
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/import/history/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerUpdateMembersV1
     * @summary Update members info by uploading file
     * @request PATCH:/api/v1/import/members
     * @secure
     */
    importControllerUpdateMembersV1: (data: BatchUpdateRequest, params: RequestParams = {}) =>
      this.request<ImportSummary, void | ErrorResponse>({
        path: `/api/v1/import/members`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerCheckConsentHasConfiguredV1
     * @summary Check if consent has configured
     * @request PATCH:/api/v1/import/members/check-consent-has-configured
     * @secure
     */
    importControllerCheckConsentHasConfiguredV1: (
      data: OnlyFileUploadDto,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void | ErrorResponse>({
        path: `/api/v1/import/members/check-consent-has-configured`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerGetAvailableFieldsForMemberUpdateV1
     * @summary Get all available fields for member update
     * @request GET:/api/v1/import/members/fields
     * @secure
     */
    importControllerGetAvailableFieldsForMemberUpdateV1: (params: RequestParams = {}) =>
      this.request<ImportMemberFieldsResponse, void | ErrorResponse>({
        path: `/api/v1/import/members/fields`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerUpdateExternalPaymentsV1
     * @summary Update external payments by uploading file
     * @request PATCH:/api/v1/import/external-payments
     * @secure
     */
    importControllerUpdateExternalPaymentsV1: (
      data: BatchUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportSummary, void | ErrorResponse>({
        path: `/api/v1/import/external-payments`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerUpdateEInvoicePaymentsV1
     * @summary Update e-invoice payments by uploading OCR file
     * @request POST:/api/v1/import/ocr
     * @secure
     */
    importControllerUpdateEInvoicePaymentsV1: (
      data: OnlyFileUploadDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/import/ocr`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerValidateSubscriptionsV1
     * @summary Validate subscription import file before import
     * @request POST:/api/v1/import/subscriptions/validate
     * @secure
     */
    importControllerValidateSubscriptionsV1: (
      data: OnlyFileUploadDto,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionImportValidationResponseDto, void | ErrorResponse>({
        path: `/api/v1/import/subscriptions/validate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerImportSubscriptionsV1
     * @summary Import subscriptions from a file
     * @request POST:/api/v1/import/subscriptions
     * @secure
     */
    importControllerImportSubscriptionsV1: (data: OnlyFileUploadDto, params: RequestParams = {}) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/v1/import/subscriptions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportControllerGetOcrFilesFromSftpV1
     * @summary Get all ocr files from sftp
     * @request GET:/api/v1/import/ocr-file-sftp
     * @secure
     */
    importControllerGetOcrFilesFromSftpV1: (params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/import/ocr-file-sftp`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cron
     * @name CronControllerTriggerCronJobV1
     * @request POST:/api/v1/cron/trigger
     * @secure
     */
    cronControllerTriggerCronJobV1: (data: TriggerCronDto, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/api/v1/cron/trigger`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerCheck
     * @summary Check health of API server
     * @request GET:/health
     */
    healthControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/health`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
